import { ApplicationRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, HostListener, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDatepickerNavigateEvent, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GmonDialogComponent } from '../gmon-dialog/gmon-dialog.component';
import { GMonService } from '../_services/gmon-service/gmon.service';
import { MapService } from '../_services/map/map.service';
import * as L from 'leaflet';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cable } from '../_models/cable';
import { GridElement } from '../_models/grid-element';
import { NodeDetailsDialogComponent } from '../node-details-dialog/node-details-dialog.component';
import { CableDetailsDialogComponent } from '../cable-details-dialog/cable-details-dialog.component';
import { ModalService } from '../_services/modal/modal.service';
import { ApplicationService } from '../_services/application/application.service';
import { Condition } from '../_models/condition';
import { GmonProcessingResult } from '../_models/gmon-processing-result';
import { Config } from '../config';
import { LcDialogDetailsComponent } from '../lc-dialog-details/lc-dialog-details.component';
import { LcDialogComponent } from '../lc-dialog/lc-dialog.component';
import { LcService } from '../_services/lc-service/lc.service';
import { environment } from '../../environments/environment';
import { LaDialogComponent } from '../la-dialog/la-dialog.component';
import { NotificationsDialogComponent } from '../notifications-dialog/notifications-dialog.component';
import { LaService } from '../_services/la-service/la.service';
import { GuiService } from '../_services/gui-service/gui.service';
import { Notification } from '../_models/notification';
import * as mqtt from 'mqtt';
import { MqttTopic } from '../_models/mqtt-topics';
import { UserService } from '../_services/user-service/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReactivePowerAnalysisDialogComponent } from '../reactive-power-analysis-dialog/reactive-power-analysis-dialog.component';
import { ReactivePowerAnalysisService } from '../_services/reactive-power-analysis-service/reactive-power-analysis.service';
import { GplanDialogComponent } from '../gplan-dialog/gplan-dialog.component';
import { GPlanService } from '../_services/gplan-service/gplan.service';
import { GridColor } from '../_models/grid-color';
import { GridElementService } from '../_services/grid-element/grid-element.service';
import { ConfigurationService } from "../_services/configuration/configuration.service";
import { MqttClient } from "mqtt";
import { CableColor } from "../_models/cable-color";
import { NotificationEFL } from '../_models/notificationEFL';
import { Location } from '../_models/location';
import { ApplicationStatus } from '../_models/app-status';
import { DateUtils } from '../_commons/date-utils';
import { StatisticDialogComponentComponent } from '../statistic-dialog-component/statistic-dialog-component.component';
import { TopologyConfig, TopologyList, TopologyWithRoot } from '../_models/topology-list';
import { GPlanInput } from '../_models/gplan-input';
import { PlanningNode } from '../_models/planning-node';
import { PlanningSwitchingState } from '../_models/cable-switching-state';
import { PlanningCable } from '../_models/planning-cable';
import { ApplicationProgressMessage, GMonResultsAvailableMessage, GPResultsAvailableMessage, LAResultsAvailableMessage, LMResultsAvailableMessage, MessageType, PVResultsAvailableMessage, RPAResultsAvailableMessage } from '../_models/mqtt-message';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Observable, fromEvent, throwError, of, from } from 'rxjs';
import { PvListProcessingComponent } from '../pv-list-processing/pv-list-processing.component';
import { MeheStatsDialogComponent } from '../mehe-stats-dialog/mehe-stats-dialog.component';
import { PvListProcessingService } from '../_services/pv-service/pv-list-processing.service';
import { PVData } from '../_models/pv-data';
import { HttpErrorResponse } from '@angular/common/http';
import { LiveMonitoringAndControlComponent } from '../live-monitoring-and-control/live-monitoring-and-control.component';
import { LmService } from '../_services/lm-service/lm.service';
import { GplanSummaryTableComponent } from '../gplan-summary-table/gplan-summary-table.component';
import { ShortCircuitCurrentAnalysisComponent } from '../short-circuit-current-analysis/short-circuit-current-analysis.component';
import { ThdMonitoringComponent } from '../thd-monitoring/thd-monitoring.component';
import { PlanningTrafoDtos } from '../_models/planning-trafo-dtos';
import { ThdMonitoringService } from '../_services/thd-monitoring-service/thd-monitoring.service';
import { ShortCircuitCurrentAnalysisService } from '../_services/short-circuit-current-analysis-service/short-circuit-current-analysis.service';
import { distinctUntilChanged,catchError, map, switchMap } from 'rxjs/operators';
import { InitialNotificationsComponent } from '../initial-notifications/initial-notifications.component';
import { InitialNotifications } from '../_models/initialNotifications';
import { InitialNotificationsService } from '../_services/initial-notifications/initial-notifications.service';
import { AutoExecutor } from '../_models/auto-executor';
import { CommunicationService } from '../_services/communication-service/communication.service';
import { Subscription } from 'rxjs';
import {Property} from "../_models/property";
import { Alarm } from '../_models/alarm';
import { ApplicationsResultsService } from '../_services/applications-results-service/applications-results.service';
import { Coordinate } from '../_models/coordinates';
import { MarkerType } from '../_models/marker-type';
import { EflResult } from '../_models/efl-results';
import { TestingDataForPost } from '../_models/userData';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild("ngSelectComponent", { static: false }) ngSelectComponent: NgSelectComponent;
  selectedTop: string = "";
  @ViewChild("notificationDialog", { static: false })
  public notificationDialog: NgbDropdown;
  private mqttConfig: any;
  private excludedNodes: any;
  private translations: any;
  private gplanTitle: string;
  private gplanTextResults: string;
  private gplanSummary:string;
  private gplanTextError: string;
  private laTextError: string;
  private gmonTitle: string;

  private pvTitle: string;
  private pvTextResults: string;
  private pvTextError: string;
  private pvTextEmpty: string;

  private gmonTextResults: string;
  private gmonTextError: string;
  private laTitle: string;
  private laTextResults: string;
  private rpaTitle: string;
  private rpaTextError: string;
  private rpaTextResults: string;
  private rpaTextEmpty: string;
  private gmonTextEmpty: string;
  private lcTextResults: string;
  private lcTitle: string;
  private lcTextError: string;
  private licenseText: string;
  private licenseTitle: string;
  private sessionText: string;
  private sessionTitle: string;
  private laTextEmpty: string;
  private topology: any;
  private noLVTopologyTitle: string;
  private noLVTopologyText: string;
  private onlyOneLVTrafoTitle: string;
  private onlyOneLVTrafoText: string;
  private subscription: Subscription;
  // edaf
  private eflTextResults: string;
  private eflTextError: string;
  private eflTitle: string;
  private eflTitleError: string;
  private gpSummaryResult:any;
  calculatedRPADays: boolean = false;
  calculatedGmonDays: boolean = false;
  calculatedLADays: boolean = false;
  gmonAvailable: boolean = false;
  laAvailable: boolean = false;
  lcAvailable: boolean = false;
  pvAvailable: boolean = false;

  gplanAvailable: boolean = false;
  rpaAvailable: boolean = false;
  isLiveMonitoringAndControlComponentShown = false;
  showGPlanSummaryTable: boolean = true;
  sccApplicationShown = false;
  thdMonitoringShown = false;
  eflAvailable: boolean = false;
  rank: number;
  mqttClient: MqttClient = null;

  disabledTopologiesDropdown: boolean = false;
  getGridElementsDetailsDone: boolean = false;
  getApplicationsStatusDone: boolean = false;
  loadGridTypeDone: boolean = false;
  loadLegendTypesDone: boolean = false;
  getCablesAndCoordinatesDone: boolean = false;
  getListAvailableScenariosDone: boolean = false;

  loadCableTypeDone: boolean = false;
  gridPlanningScenarios: Array<GPlanInput> = [];
  selectedPlanningScenario: boolean = false;
  public selectedScenario: GPlanInput;
  cableTypes: Array<any>;
  public defaultTopology: string;
  public topologiesWithRoots: Array<TopologyWithRoot>;
  public scenarioLoadsNumber: number = 0;
  public scenarioTrafosNumber: number = 0;
  public scenarioCablesNumber: number = 0;
  public scenarioSwitchingStateNumber: number = 0;
  public scenarioSubTreeNumber: number = 0;
  public planningNodes: Array<PlanningNode>;
  public planningCables: Array<PlanningCable>;
  public planningSwichtingStates: Array<PlanningSwitchingState>;
  public planningSubgridsDtos: Array<PlanningSwitchingState>;
  public planningTrafoDtos: Array<PlanningTrafoDtos>;
  public selectedScenarioName: string;
  public selectedScenarioId: number;
  public open: any;
  public closed: any;
  public mixed: any;

  public selectedDate: boolean = false;
  public toDate: NgbDateStruct;
  private date!: string;
  public enableResetButton: boolean = false;

  private mapLvTopologyAndGridNodes: Map<string, Map<number, GridElement>> = new Map<string, Map<number, GridElement>>();
  private mapLVTopologyNameAndGridElements: Map<string, Array<GridElement>> = new Map<string, Array<GridElement>>();
  private mapLVTopologyNameAndGridElementsID: Map<string, Array<number>> = new Map<string, Array<number>>();
  private mapLVTopologyNameAndMVTrafo: Map<string, GridElement> = new Map<string, GridElement>();
  private mapLVFirstElementAndLVTopologyName: Map<string, string> = new Map<string, string>();

  private mapLVTopologyAndArrayOfCables: Map<string, Array<Cable>> = new Map<string, Array<Cable>>();
  private mapLVTopologyAndArrayOfCableIDs: Map<string, Array<number>> = new Map<string, Array<number>>();

  private lvTopologyAndMapGroupLayer: Map<string, L.layerGroup> = new Map<string, L.layerGroup>();
  private lvTopologyAndFirstTrafo: Map<string, string> = new Map<string, string>();

  public editPlanningScenarioMode: boolean = false;
  public onConfirmSelectionDate: boolean = false;
  isDropdownOpen:boolean = false;
  gotGPSummaryInfo: boolean = false;

  sharedSelectedScenarioID: any;

  private initialNotificationReadOnce: boolean = false;
  private enableCablesHighlighting: boolean;
  private cableZoomingAnimationEnabled: boolean;
  private zoomingAnimationTimeout: number;

  private startMarkerIcon: L.marker;
  private endMarkerIcon: L.marker;
  private gridElementMarkers: Array<L.marker>;

  private zoomingTimeoutHandler: any;

  private predefinedTopologyFromResultsOverview: TopologyConfig;

  // Sidebar navigation menu
  public isSidebarMenuOpen: boolean = false;
  public closeTimeout: any;

  // Dropdown menu
  isHovered: boolean = false;
  hoveredIndex: number | null = null;
  openScenarioIndex: number | null = null;

  // User Related Variables (After login)
  public username: string = "";
  public userRole: string = "";
  public isAdmin: boolean = false;

  public distinctTopologyIds: Array<string> = new Array<string>();

  private getConfiguredDisplay: boolean = false;

  private previousToggledStates;

  public mapModeChangedBool = false;

  private iconsAreDisplayedUsingUserConfig = false;
  public enableMapModeChangeSwitch;
  public eflResultsFromAlarms: Array<EflResult> = new Array<EflResult>();

  mapVisible = true;
  isCartesianMapIsOn = false;

  // Flags to manage the display of the date of the last topology update in the datepicker
  public dateOfTopologyUpdateIsShown: boolean;

  constructor(
    private dateUtils: DateUtils,
    private ngbModal: NgbModal,
    private gMonService: GMonService,
    private lcService: LcService,
    private laService: LaService,
    private mapService: MapService,
    private modalService: ModalService,
    private applicationService: ApplicationService,
    private guiService: GuiService,
    private userService: UserService,
    private gridElementService: GridElementService,
    private router: Router,
    private reactivePowerAnalysisService: ReactivePowerAnalysisService,
    private gPlanService: GPlanService,
    public translate: TranslateService,
    private configurationService: ConfigurationService,
    private pvService: PvListProcessingService,
    private lmService:LmService,
    private thdMonitoringService: ThdMonitoringService,
    private shortCircuitCurrentAnalysisService: ShortCircuitCurrentAnalysisService,
    private initialNotificationsService: InitialNotificationsService,
    private communicationService: CommunicationService,
    private injector: Injector,
    private appRef: ApplicationRef,
    private cfr: ComponentFactoryResolver,

    private applicationsResultsService: ApplicationsResultsService,
    private route: ActivatedRoute
  ) {
    const applications: any = this.configurationService.getConfiguration().APPLICATIONS;
    this.gmonAvailable = applications.gmonAvailable;
    this.laAvailable = applications.laAvailable;
    this.lcAvailable = applications.lcAvailable;
    this.pvAvailable = applications.pvAvailable;
    this.gplanAvailable = applications.gplanAvailable;
    this.rpaAvailable = applications.rpaAvailable;
    this.isLiveMonitoringAndControlComponentShown = applications.isLiveMonitoringAndControlComponentShown
    this.thdMonitoringShown = applications.thdMonitoringShown;
    this.sccApplicationShown = applications.sccApplicationShown;

    const edaf: any = this.configurationService.getConfiguration().EDAF;
    this.eflAvailable = edaf.eflAvailable;
    this.rank = edaf.rank;

    this.enableMapModeChangeSwitch = this.configurationService.getConfiguration().enableMapModeChangeSwitch;

    this.excludedNodes = environment.EXCLUDED_NODES;

    // Translations
    // Set default language
    this.translate.addLangs(["en", "de"]);
    this.translate.setDefaultLang("de");
    const lang = localStorage.getItem("Language");
    if (lang) {
      this.translate.use(lang);
      localStorage.setItem('Language', lang);
    } else {
      this.translate.use("de");
      localStorage.setItem('Language', "de");
    }
    const language = localStorage.getItem("Language");
    this.changeLang(language);

    this.isNotificationsShown = this.configurationService.getConfiguration().APPLICATIONS.isNotificationsShown;
    this.amountOfLVTopologiesOnMVTopologyMap = this.configurationService.getConfiguration().amountOfLVTopologiesOnMVTopologyMap;
    this.enableCablesHighlighting = this.configurationService.getConfiguration().enableCablesHighlighting;
    this.cableZoomingAnimationEnabled = this.configurationService.getConfiguration().cableZoomingAnimationEnabled;
    this.zoomingAnimationTimeout = this.configurationService.getConfiguration().zoomingAnimationTimeout;
    this.multipleCoordinatePointsForCablesIsShown = this.configurationService.getConfiguration().multipleCoordinatePointsForCablesIsShown;
    this.dateOfTopologyUpdateIsShown = this.configurationService.getConfiguration().dateOfTopologyUpdateIsShown ? this.configurationService.getConfiguration().dateOfTopologyUpdateIsShown : false;
  }

  public isLicenseExpired: boolean = false;

  isEnableLvSubstationBusBarOneTrafo: boolean = true;
  isEnableMvSubstationBusBarOneTrafo: boolean = true;
  isEnableMvSubstationBusBarWithoutTrafo: boolean = true;
  isEnableMvStationOneTrafo: boolean = true;
  isEnableMvStationWithoutTrafo: boolean = true;
  isEnableMvStationMultipleTrafo: boolean = true;
  isEnableCustomerConnectionBox: boolean = true;
  isEnableStatistics: boolean = true;
  isEnableControllableDevices: boolean = true;
  isEnableVoltageRegulator: boolean = true;

  isEnableSleeve: boolean = true;
  isEnableLvJunctionBox: boolean = true;
  isEnableGenerator: boolean = true;
  isEnableCable: boolean = true;
  isEnableOpenCable: boolean = true;

  private map: L.map;
  private gridNodesLayer: L.layerGroup;
  private mapNamingAndLVNodes: Map<string, L.layerGroup> = new Map<string, L.layerGroup>();
  private mapNamingAndLVSwitchMarkers: Map<string, L.layerGroup> = new Map<string, L.layerGroup>();
  private mapNamingAndLVCables: Map<string, L.layerGroup> = new Map<string, L.layerGroup>();
  private lvTopologyTrafoMap: Map<string, L.marker> = new Map<string, L.marker>();
  private switchLayer: L.layerGroup;
  //To store lv Topology and The gridElementId of the trafo that we clicked on MV Topology
  private mapLVTopologyMarkerAndMVTrafoGridElement: Map<L.marker, GridElement> = new Map<L.marker, GridElement>();

  private cablesLayer: L.layerGroup;
  private cablesLayerOpen: L.layerGroup;

  private nodesMap: Map<number, GridElement> = new Map<number, GridElement>();
  private nodesMapGP: Map<number, GridElement> = new Map<number, GridElement>();

  private topologiesGridElementsMap: Map<string, Map<number, GridElement>> = new Map<string, Map<number, GridElement>>();

  private cablesMap: Map<number, Cable> = new Map<number, Cable>();
  private cablesMapGP: Map<number, Cable> = new Map<number, Cable>();
  private cablesGP: Array<Cable> = new Array<Cable>();

  private intermediateCablesMap: Map<number, Cable> = new Map<number, Cable>();

  private cables: Array<Cable> = new Array<Cable>();
  private gridElements: Array<GridElement> = new Array<GridElement>();

  private gridColorApps: Map<number, GridColor> = new Map<number, GridColor>();
  private cableColorApps: Map<number, CableColor> = new Map<number, CableColor>();
  private lvCablesColorApps: Map<number, CableColor> = new Map<number, CableColor>();
  public notReadNotificationsCount: number = 0;
  public notifications: Array<Notification> = new Array<Notification>();
  public locationArray: Array<Location> = new Array<Location>();
  public alarms: Array<Alarm> = new Array<Alarm>();

  showIds: boolean = true;
  showSubIds: boolean = false;
  gridElemenetIdsShowHide: boolean = false;
  gridElementSubIdsShowHide: boolean = false;
  showTransformer: boolean = true;
  public topologies_sel = [];
  public topologies: TopologyList;
  public gmonResultsAvailableMessage: GMonResultsAvailableMessage;
  public pvResultsAvailableMessage: PVResultsAvailableMessage;

  public laResultsAvailableMessage: LAResultsAvailableMessage;
  public rpaResultsAvailableMessage: RPAResultsAvailableMessage;

  public gmonProgress: string = "";
  public laProgress: string = "";
  public rpaProgress: string = "";
  public lcProgress: string = "";
  public gplanProgress: string = "";

  private markerMagnifier: L.layerGroup;
  private markerMagnifierArray: Array<L.marker> = new Array<L.marker>();

  public isNotificationsShown: boolean;
  public amountOfLVTopologiesOnMVTopologyMap: number;

  private topologyIdForCurtailabeDeviceCall: TopologyConfig;

  public controllableDevicesGridElementIDs: Array<number> = new Array<number>();

  private multipleCoordinatePointsForCablesIsShown: boolean;

  private highlightedPolylines: Array<L.polyline> = new Array<L.polyline>();
  private originalPolylinesStyles = new Map<L.Polyline, any>();
  private originalMarkerIcons = new Map<L.Marker, L.Icon>();
  private highlightedMarkers = new Set<L.Marker>();

  ngOnInit() {

    this.getUserRole();

    this.subscription = this.communicationService.methodCalled$.subscribe((param: any) => {
      this.jumpTopology(param);
    });

    this.communicationService.topologyId$.subscribe( topologyConfig => {
      if(topologyConfig) {
        this.predefinedTopologyFromResultsOverview = topologyConfig;
      }
    });
    this.getAvailableTopologies();
    this.initMQTT();

    if (this.eflAvailable) {
      this.guiUpdateEvent();
    }

    this.manageGPlanScenarioCreated();

    this.getEflResults();

  }

  getUserRole(){
    const savedUserData = JSON.parse(localStorage.getItem("userData"));
    if(savedUserData){
      this.username = savedUserData.username;
      this.userRole = savedUserData.role;
      this.isAdmin = this.userRole === "admin";
      console.log('received this information about the user: ' + this.username + ' - ' + this.userRole);
    }

    // Get data about the user
    this.userService.userInfo$.subscribe(info => {
      if(info){
        this.username = info.username;
        this.userRole = info.role;
        this.isAdmin = this.userRole === "admin";
        // Save user data in localStorage
        localStorage.setItem("userData", JSON.stringify(info));
        console.log('received this information about the user from service: ' + this.username + ' - ' + this.userRole);
      }
    });
  }

  getListOfCurtailableDevices(){
    this.topologyIdForCurtailabeDeviceCall = (JSON.parse(localStorage.getItem("currentTopology")))
    // console.log("THIS IS CURRENT TOPOLOGY ID : ", this.topologyIdForCurtailabeDeviceCall.topologyId)
    this.applicationService.getControllableDevices(this.topologyIdForCurtailabeDeviceCall.topologyId.toString()).subscribe(response => {
      console.log("List Of Controllable Devices: ", response)
      this.controllableDevicesGridElementIDs = response;
    })
  }

  onSelectTopology(selectedTopologyId: string) {
    this.cables = [];
    this.gridElements = [];

    //this.selectedPlanningScenario = false;

    if (this.cablesLayer) {
      this.map.removeLayer(this.cablesLayer);
    }

    //flag to disable topologies dropdown on select
    this.disabledTopologiesDropdown = true;
    console.log(selectedTopologyId);
    this.topologiesWithRoots.forEach(element => {
      if (element.TopologyId == selectedTopologyId) {
        let topologyConfig: TopologyConfig = new TopologyConfig(
          element.TopologyId,
          element.latitude,
          element.longitude,
          element.lastTopologyChange
        )

        /*when user select a date and click on Confirm (this.onConfirmSelectionDate == true),
        the datepicker will show the previously user date selected,
        in all other case (or when this.onConfirmSelectionDate == false)
        the datepicker shows the "lastTopologyChange" date of the topology
       */
        if (this.onConfirmSelectionDate == false) {
          let date = DateUtils.stringUTCDateToLocalDateObject(element.lastTopologyChange)
          this.toDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        }

        // #### start changes by CS -- maybe ths could be improved by RT
        const lang = localStorage.getItem("Language"); // save the chosen language
        const authToken = localStorage.getItem("authToken"); // save the auth filter
        const userData = localStorage.getItem("userData"); // save the user data (username and role)

        localStorage.clear();
        this.nodesMap.clear(); //by CS; otherwise, we can still see the nodes from the "old" topology on the map
        this.translate.addLangs(["en", "de"]);
        this.translate.setDefaultLang("de");
        if (lang) {
          this.translate.use(lang);
          localStorage.setItem('Language', lang);
        } else {
          this.translate.use("de");
          localStorage.setItem('Language', "de");
        }
        // this.changeLang(language);
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("userData", userData);

        // ### end changes by CS

        localStorage.setItem("currentTopology", JSON.stringify(topologyConfig));
        this.topology = topologyConfig;
        this.gPlanService.getGplanNode(this.topology.topologyId, this.date);

        /*
        this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
          if (response) {
            this.topologies = response
            localStorage.setItem("topologies", JSON.stringify(this.topologies))
          }});*/

        //this.getApplicationsStatus();
        this.loadGridType();
        this.loadCableType();
        this.loadLegendTypes();

        if(!this.isCartesianMapIsOn){
          this.loadMap('map'); // changed by CS
        }
        if(this.isCartesianMapIsOn){
          this.map.removeLayer(this.gridNodesLayer);
          // this.map.removeLayer(this.cablesLayer);
          Promise.resolve().then(() => {
            this.drawElementsOnCartesianMap(selectedTopologyId);
          });
          // this.drawElementsOnCartesianMap();
        }
        //this.emptyMap('map');

        //call API to retrive the available scenarios list
        this.getListAvailableScenarios();
        this.getListOfCurtailableDevices();
      }
    });
    this.gridElementService.saveRootNodeId2(selectedTopologyId, this.date);
  };

  //get all Cable types
  public loadCableType() {
    this.mapService.getCableTypes().subscribe((cableTypes: Array<any>) => {
      this.loadCableTypeDone = true;
      this.cableTypes = cableTypes;
      localStorage.setItem("cableTypes", JSON.stringify(this.cableTypes));
      console.log(localStorage.getItem('cableTypes'));
      this.checkEndAPIsandEnableTopologiesDropdown();
    });
  }

  getAvailableTopologies() {
    //flag to disable topologies dropdown
    this.disabledTopologiesDropdown = true;
    this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
      if (response) {
        this.topologies = response
        localStorage.setItem("topologies", JSON.stringify(this.topologies));
        if(this.predefinedTopologyFromResultsOverview != null){
          this.defaultTopology = this.predefinedTopologyFromResultsOverview.topologyId;
        }else{
          this.defaultTopology = this.topologies.toplogyIdOfDefault;
        }
        if(this.selectedTop != null || this.selectedTop != ""){
          this.selectedTop = this.defaultTopology;
        }
        this.topologiesWithRoots = this.topologies.topologiesWithRoots


        console.log("here is the selected topology: " + this.selectedTop);
        this.loadNotifications();

        this.topologies_sel = [];
        this.topologiesWithRoots.forEach(element => {
          var name;

          if (element.displayName != null)
            name = element.displayName;
          else
          name = element.internalDsoId + " - " + element.TopologyId;

          this.topologies_sel.push(
            { id: element.TopologyId, name: name }
          )
        });

        this.topologies_sel.sort((a, b) => a.name.localeCompare(b.name));

        this.topologiesWithRoots.forEach(element => {
          if (element.TopologyId == this.defaultTopology) {

            /*
            fill datepicker with the "lastTopologyChange" date of the defaultTopology
            */
            let date = DateUtils.stringUTCDateToLocalDateObject(element.lastTopologyChange)
            this.toDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };

            let topologyConfig: TopologyConfig = new TopologyConfig(
              element.TopologyId,
              element.latitude,
              element.longitude,
              element.lastTopologyChange
            )
            localStorage.setItem("currentTopology", JSON.stringify(topologyConfig))
            this.topology = topologyConfig;
            this.gPlanService.getGplanNode(this.topology.topologyId, this.date);

            //this.getApplicationsStatus();
            this.loadGridType();
            this.loadCableType();
            this.loadLegendTypes();
            this.loadMap('map');
          }
        });
        this.gridElementService.saveRootNodeId2(this.topologies.toplogyIdOfDefault, this.date);

        //call API to retrive the available scenarios list
        this.getListAvailableScenarios();

        this.getListOfCurtailableDevices();
        // console.log("Topology Elements ", this.gridPlanningScenarios)

      }

    });
    //this.checkEndAPIsandEnableTopologiesDropdown();
  };

  initPlanningScenarioSummary() {
    this.selectedScenarioName = "";
    this.selectedScenarioId = 0;
    this.scenarioLoadsNumber = 0;
    this.planningNodes = [];
    this.scenarioTrafosNumber = 0;
    this.scenarioCablesNumber = 0
    this.planningCables = [];
    this.scenarioSwitchingStateNumber = 0;
    this.planningSwichtingStates = [];
    this.planningSubgridsDtos = [];

  }
  /**
   * Show planning scenario tab
   * and show Planning changes on map for the selected scenario
   */
  showPlanning() {
    this.savePreviousToggledStates();
    this.toggleAllElements();

    this.selectedPlanningScenario = true;
    this.showSelectedScenarioOnMap();
    this.restoreGPColors();
    if(this.gPlanService.areGplanDataAvailable() == false || this.gPlanService.isGPlanRunning() == true){
      this.showGPlanSummaryTable = false;
    }
    this.sendSelectedScenarioIdToService(this.selectedScenarioId, this.selectedScenarioName,
      this.selectedScenario.intervalStart, this.selectedScenario.intervalEnd, this.selectedScenario.type);
    /*let gpGUIColoringInfoDto:  Array<GPResultsAvailableMessage> = JSON.parse(localStorage.getItem("gpGUIColoringInfoDto"))
    console.log(gpGUIColoringInfoDto);
    if (gpGUIColoringInfoDto) {
      this.manageGPLANResultsColoring(gpGUIColoringInfoDto[0]);
    }*/

      // if(localStorage.getItem('scenariosFromGPlan')){
      //   const storedGPlanScenarios = JSON.parse(localStorage.getItem('scenariosFromGPlan'))
      //   storedGPlanScenarios.forEach((scenario) => {
      //     this.gridPlanningScenarios.push(scenario);
      //   })
      //   console.log("Here are updated scenarios: ", this.gridPlanningScenarios);
      // }

    let gpGUIColoringInfoDto:  Array<GPResultsAvailableMessage> = JSON.parse(localStorage.getItem("gpGUIColoringInfoDto"))
    if(gpGUIColoringInfoDto){
      gpGUIColoringInfoDto.forEach(dto => {
        // if(!isNotNullOrUndefined(dto.gMonGUIColoringInfoDto.gridplanningScenarioId)){
          if (dto.gMonGUIColoringInfoDto.gridplanningScenarioId == this.selectedScenario.id) {
            this.manageGPLANResultsColoring(dto);
          }
        // }
      });
    }
  }

  loadSavedScenarios(){

  }

  /**
   * Hide Planning Scenario and restore the original map
   */
  hidePlanning() {

    /**
     * when the user clicks on "Hide Planning Scenario" button,
     * we have to wait that the map is ready before restore the previous toggled states
     * and show again the nodes and cables that were hidden by the user before
     * showing the planning scenario, otherwise, we can have some problems with the map
     * rendering and some nodes and cables can be hidden without any reason
     */
    this.map.whenReady(() => {
      requestAnimationFrame(() => {
        this.restorePrevoiusToggledStates();
      })
    })
    this.gridElements = Array.from(this.nodesMap.values());
    //set gridColorApps properties for GP with NORMAL condition (i.e. voltageGP, laGP) becouse the user is hiding the planning scenario
    const gridColorAppsJson: string = localStorage.getItem("gridColorApps");
    if (gridColorAppsJson) {
      let gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      gridColorApps.forEach(element => {
        element.voltageGP = Condition.NORMAL;
        element.laGP = Condition.NORMAL;
      });
      localStorage.removeItem("gridColorApps");
      localStorage.setItem("gridColorApps", JSON.stringify(gridColorApps));
    }

    //set cableColorApps properties for GP with NORMAL condition (i.e. laGP)
    const cableColorAppsJson: string = localStorage.getItem("cableColorApps");
    if (cableColorAppsJson) {
      let cableColorApps: Array<CableColor> = JSON.parse(cableColorAppsJson);
      cableColorApps.forEach(element => {
        element.laGP = Condition.NORMAL;
      });
      localStorage.removeItem("cableColorApps");
      localStorage.setItem("cableColorApps", JSON.stringify(cableColorApps));
    }

    let cablesJson: string = localStorage.getItem('cablesOriginal');
    this.cables = JSON.parse(cablesJson);

    this.selectedPlanningScenario = false;
    let gMonGUIColoringInfoDtoDto: GMonResultsAvailableMessage = JSON.parse(localStorage.getItem("gMonGUIColoringInfoDtoDto"))
    let laGuiColoringInfoDto: LAResultsAvailableMessage = JSON.parse(localStorage.getItem("laGuiColoringInfoDto"))


    if (gMonGUIColoringInfoDtoDto) {
      this.manageGMonResultsColoring(gMonGUIColoringInfoDtoDto, false)
    }
    if (laGuiColoringInfoDto) {
      this.manageLAResultsColoring(laGuiColoringInfoDto, false)
    }

    this.restoreOriginalMap();
    this.showGPlanSummaryTable = true;

  }

  /**
   * Manage planning scenario
   * @param gp
   */
  managePlanningScenario(gp: any) {
    this.initPlanningScenarioSummary();
    this.selectedScenario = gp;
    if (this.selectedScenario) {
      this.selectedScenarioName = this.selectedScenario.name
      this.selectedScenarioId = this.selectedScenario.id
      if(this.selectedScenario.planningTrafoDtos){
        this.scenarioTrafosNumber = this.selectedScenario.planningTrafoDtos.length;
        this.planningTrafoDtos = this.selectedScenario.planningTrafoDtos;
      }
      if (this.selectedScenario.planningNodes) {
        this.scenarioLoadsNumber = this.selectedScenario.planningNodes.length;
        this.planningNodes = this.selectedScenario.planningNodes;
      }
      if (this.selectedScenario.planningCables) {
        this.scenarioCablesNumber = this.selectedScenario.planningCables.length;
        this.planningCables = this.selectedScenario.planningCables;
      }
      if (this.selectedScenario.planningSwichtingStates) {
        this.scenarioSwitchingStateNumber = this.selectedScenario.planningSwichtingStates.length;
        this.planningSwichtingStates = this.selectedScenario.planningSwichtingStates;
      }

      if (this.selectedScenario.planningSubgridsDtos) {
        this.scenarioSubTreeNumber = this.selectedScenario.planningSubgridsDtos.length;
        this.planningSubgridsDtos = this.selectedScenario.planningSubgridsDtos;
      }
    }
    console.log(gp)
    console.log("this.selectedPlanningScenario " + this.selectedPlanningScenario)
  };

  leaveScenario(){
    this.openScenarioIndex = null;
    this.selectedScenario = null;
  }

  toggleScenario(index: number){
    this.openScenarioIndex = this.openScenarioIndex === index ? null : index;
    if(this.openScenarioIndex != null){
      console.log("this.openScenarioIndex ", this.openScenarioIndex);
      this.selectedPlanningScenario = true;
      this.showSelectedScenarioOnMap();
      this.restoreGPColors();

      // });

      this.selectedScenario = this.gridPlanningScenarios[index];

      if (this.selectedScenario) {
        this.selectedScenarioName = this.selectedScenario.name
        this.selectedScenarioId = this.selectedScenario.id
        this.sendSelectedScenarioIdToService(this.selectedScenarioId, this.selectedScenarioName,
          this.selectedScenario.intervalStart, this.selectedScenario.intervalEnd, this.selectedScenario.type);

        if(this.selectedScenario.planningTrafoDtos){
          this.scenarioTrafosNumber = this.selectedScenario.planningTrafoDtos.length;
          this.planningTrafoDtos = this.selectedScenario.planningTrafoDtos;
        }
        if (this.selectedScenario.planningNodes) {
          this.scenarioLoadsNumber = this.selectedScenario.planningNodes.length;
          this.planningNodes = this.selectedScenario.planningNodes;
        }
        if (this.selectedScenario.planningCables) {
          this.scenarioCablesNumber = this.selectedScenario.planningCables.length;
          this.planningCables = this.selectedScenario.planningCables;
        }
        if (this.selectedScenario.planningSwichtingStates) {
          this.scenarioSwitchingStateNumber = this.selectedScenario.planningSwichtingStates.length;
          this.planningSwichtingStates = this.selectedScenario.planningSwichtingStates;
        }

        if (this.selectedScenario.planningSubgridsDtos) {
          this.scenarioSubTreeNumber = this.selectedScenario.planningSubgridsDtos.length;
          this.planningSubgridsDtos = this.selectedScenario.planningSubgridsDtos;
        }
      }
      // console.log("this.selectedPlanningScenario " + this.selectedPlanningScenario)
      this.selectedPlanningScenario = true;
      this.restoreOriginalMap();
      this.showSelectedScenarioOnMap();
      this.restoreGPColors();

      // console.log("this.gridPlanningScenarion: ", this.gridPlanningScenarios);
      // console.log("this.selectedScenario: ", this.selectedScenario);

      if(this.gPlanService.areGplanDataAvailable() == false || this.gPlanService.isGPlanRunning() == true){
        this.showGPlanSummaryTable = false;
      }

      // console.log("this.selectedScenarioId: ", this.selectedScenarioId);
      // console.log("this.selecetdScenarioName: ", this.selectedScenarioName);
      // console.log("this.selectedScenario.intervalStart: ", this.selectedScenario.intervalStart);
      // console.log("this.selectedScenario.intervalEnd: ", this.selectedScenario.intervalEnd);
      // console.log("this.selectedScenario.type: ", this.selectedScenario.type);

      // this.sendSelectedScenarioIdToService(this.selectedScenarioId, this.selectedScenarioName,
      //   this.selectedScenario.intervalStart, this.selectedScenario.intervalEnd, this.selectedScenario.type);
      /*let gpGUIColoringInfoDto:  Array<GPResultsAvailableMessage> = JSON.parse(localStorage.getItem("gpGUIColoringInfoDto"))
      console.log(gpGUIColoringInfoDto);
      if (gpGUIColoringInfoDto) {
        this.manageGPLANResultsColoring(gpGUIColoringInfoDto[0]);
      }*/

      let gpGUIColoringInfoDto:  Array<GPResultsAvailableMessage> = JSON.parse(localStorage.getItem("gpGUIColoringInfoDto"))
      gpGUIColoringInfoDto.forEach(dto => {
        // if(!isNotNullOrUndefined(dto.gMonGUIColoringInfoDto.gridplanningScenarioId)){
          if (dto.gMonGUIColoringInfoDto.gridplanningScenarioId == this.selectedScenario.id) {
            this.manageGPLANResultsColoring(dto);
          }
        // }
      })
    }else{
      this.gridElements = Array.from(this.nodesMap.values());
      //set gridColorApps properties for GP with NORMAL condition (i.e. voltageGP, laGP) becouse the user is hiding the planning scenario
      const gridColorAppsJson: string = localStorage.getItem("gridColorApps");
      if (gridColorAppsJson) {
        let gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
        gridColorApps.forEach(element => {
          element.voltageGP = Condition.NORMAL;
          element.laGP = Condition.NORMAL;
        });
        localStorage.removeItem("gridColorApps");
        localStorage.setItem("gridColorApps", JSON.stringify(gridColorApps));
      }

      //set cableColorApps properties for GP with NORMAL condition (i.e. laGP)
      const cableColorAppsJson: string = localStorage.getItem("cableColorApps");
      if (cableColorAppsJson) {
        let cableColorApps: Array<CableColor> = JSON.parse(cableColorAppsJson);
        cableColorApps.forEach(element => {
          element.laGP = Condition.NORMAL;
        });
        localStorage.removeItem("cableColorApps");
        localStorage.setItem("cableColorApps", JSON.stringify(cableColorApps));
      }

      let cablesJson: string = localStorage.getItem('cablesOriginal');
      this.cables = JSON.parse(cablesJson);

      this.selectedPlanningScenario = false;
      let gMonGUIColoringInfoDtoDto: GMonResultsAvailableMessage = JSON.parse(localStorage.getItem("gMonGUIColoringInfoDtoDto"))
      let laGuiColoringInfoDto: LAResultsAvailableMessage = JSON.parse(localStorage.getItem("laGuiColoringInfoDto"))


      if (gMonGUIColoringInfoDtoDto) {
        this.manageGMonResultsColoring(gMonGUIColoringInfoDtoDto, false)
      }
      if (laGuiColoringInfoDto) {
        this.manageLAResultsColoring(laGuiColoringInfoDto, false)
      }

      this.restoreOriginalMap();
      this.showGPlanSummaryTable = true;
    }
  }

  //on select planning scenario by dropdwon menu
  onSelectScenario(gpName: string) {
    this.initPlanningScenarioSummary();

    this.gridPlanningScenarios.forEach(element => {
      if (element.name == gpName) {
        this.selectedScenario = element;
      }
    });

    if (this.selectedScenario) {
      this.selectedScenarioName = this.selectedScenario.name
      this.selectedScenarioId = this.selectedScenario.id
      this.sendSelectedScenarioIdToService(this.selectedScenarioId, this.selectedScenarioName,
        this.selectedScenario.intervalStart, this.selectedScenario.intervalEnd, this.selectedScenario.type);

      if(this.selectedScenario.planningTrafoDtos){
        this.scenarioTrafosNumber = this.selectedScenario.planningTrafoDtos.length;
        this.planningTrafoDtos = this.selectedScenario.planningTrafoDtos;
      }
      if (this.selectedScenario.planningNodes) {
        this.scenarioLoadsNumber = this.selectedScenario.planningNodes.length;
        this.planningNodes = this.selectedScenario.planningNodes;
      }
      if (this.selectedScenario.planningCables) {
        this.scenarioCablesNumber = this.selectedScenario.planningCables.length;
        this.planningCables = this.selectedScenario.planningCables;
      }
      if (this.selectedScenario.planningSwichtingStates) {
        this.scenarioSwitchingStateNumber = this.selectedScenario.planningSwichtingStates.length;
        this.planningSwichtingStates = this.selectedScenario.planningSwichtingStates;
      }

      if (this.selectedScenario.planningSubgridsDtos) {
        this.scenarioSubTreeNumber = this.selectedScenario.planningSubgridsDtos.length;
        this.planningSubgridsDtos = this.selectedScenario.planningSubgridsDtos;
      }
    }
    console.log("this.selectedPlanningScenario " + this.selectedPlanningScenario)
    this.selectedPlanningScenario = true;
    this.restoreOriginalMap();
    this.showSelectedScenarioOnMap();
    this.restoreGPColors();
    let gpGUIColoringInfoDto:  Array<GPResultsAvailableMessage> = JSON.parse(localStorage.getItem("gpGUIColoringInfoDto"))

    if( gpGUIColoringInfoDto) {
      gpGUIColoringInfoDto.forEach(dto => {
        if (dto.gMonGUIColoringInfoDto.gridplanningScenarioId == this.selectedScenario.id) {
          this.manageGPLANResultsColoring(dto);
        }
      });
    }
  };


  //get Cable Type Name by gridELementID
  private getCableTypeName(id: number) {
    let cableTypeName: string = "";
    if (this.cableTypes) {
      this.cableTypes.forEach(element => {
        if (element.id == id) {
          cableTypeName = element.Name
        }
      });
    }
    return cableTypeName;
  }

  //get a Node name by gridElementId
  private getNodeName(id: number) {
    let nodeName: string = "";
    let gridElementsJson: string = localStorage.getItem('gridElements');
    let gridElements: Array<GridElement> = JSON.parse(gridElementsJson);

    /*
    Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {

      if (+gridElement.gridElementId == id) {
        gridElement.properties.forEach(property => {
          if (property.name == "name") {
            nodeName = property.value
          }
        });
      }
    });*/

    if (gridElements != null) {
      gridElements.forEach(element => {
        if (element.gridElementId == id) {
          element.properties.forEach(property => {
            if (property.name == "name") {
              nodeName = property.value
            }
          });
        }
      })
    }

    return nodeName;
  }


  // get the Source Node of a cable by gridElementId
  private getCableSourceNode(id: number) {
    let cableSourceNode: string = "";
    let cablesJson: string = localStorage.getItem('cables');
    let cables: Array<Cable> = JSON.parse(cablesJson);
    if (cables) {
      cables.forEach(element => {
        if (element.gridElementId == id) {
          cableSourceNode = this.getNodeName(element.startNodeId);
        }
      });
    }
    return cableSourceNode;
  }

  // get the ENd Node of a cable by gridElementId
  private getCableEndNode(id: number) {
    let cableEndNode: string = "";
    let cablesJson: string = localStorage.getItem('cables');
    let cables: Array<Cable> = JSON.parse(cablesJson);
    if (cables) {
      cables.forEach(element => {
        if (element.gridElementId == id) {
          cableEndNode = this.getNodeName(element.endNodeId);
        }
      });
    }
    return cableEndNode;
  }


  private getListAvailableScenarios() {
    this.gPlanService.getListAvailableScenarios().subscribe((scenarios: Array<GPlanInput>) => {
      this.getListAvailableScenariosDone = true;
      if (scenarios) {
        this.gridPlanningScenarios = scenarios;


        if (this.gridPlanningScenarios.length > 0) {
          this.managePlanningScenario(this.gridPlanningScenarios[0])
        }
      }
      this.checkEndAPIsandEnableTopologiesDropdown();
    });
  }


  private getApplicationsStatus(topologyId: string): Promise<void> {  // Added return type as Promise<void>
    this.savePreviousToggledStates();
    return new Promise((resolve, reject) => {  // Wrap in a Promise
      this.guiService.getApplicationsStatus(topologyId).subscribe((applicationStatuses: ApplicationStatus) => {
        this.getApplicationsStatusDone = true;
        if (applicationStatuses) {

          console.log(applicationStatuses);

          localStorage.setItem("isGMonRunning", JSON.stringify(applicationStatuses.isGMonRunning));
          localStorage.setItem("isGPlanRunning", JSON.stringify(applicationStatuses.isGPlanRunning));
          localStorage.setItem("isLARunning", JSON.stringify(applicationStatuses.isLARunning));
          localStorage.setItem("isLCRunning", JSON.stringify(applicationStatuses.isLCRunning));
          localStorage.setItem("isReactivePowerAnalysisRunning", JSON.stringify(applicationStatuses.isReactivePowerAnalysisRunning));
          localStorage.setItem("isPvListProcessingisRunning", JSON.stringify(applicationStatuses.isPvListProcessingisRunning));
          localStorage.setItem("areLcDataAvailable", JSON.stringify(applicationStatuses.areLcDataAvailable));
          localStorage.setItem("areGplanDataAvailable", JSON.stringify(applicationStatuses.areGplanDataAvailable));
          localStorage.setItem("areFrequencyDataAvailable", JSON.stringify(applicationStatuses.areFrequencyDataAvailable));
          localStorage.setItem("areVoltageDataAvailable", JSON.stringify(applicationStatuses.areVoltageDataAvailable));
          localStorage.setItem("isLMRunning_"+topologyId, JSON.stringify(applicationStatuses.isLMRunning));
          localStorage.setItem("isCMRunning_"+topologyId, JSON.stringify(applicationStatuses.isCMRunning));

          if (applicationStatuses.areLANodeDataAvailable || applicationStatuses.areLACableDataAvailable) {
            localStorage.setItem("areLADataAvailable", 'true');
          }
          localStorage.setItem("areRPADataAvailable", JSON.stringify(applicationStatuses.areRPADataAvailable));

          if (applicationStatuses.pvData){
            this.managePvData(applicationStatuses.pvData);
            // console.log("manage PV data");
          }

          if(applicationStatuses.rpaGUIColoringInfoDto){
            this.manageRpaResultsColoring(applicationStatuses.rpaGUIColoringInfoDto);
            // console.log("manage rpa coloring");
          }

          if (applicationStatuses.gMonGUIColoringInfoDtoDto) {
            localStorage.setItem("gMonGUIColoringInfoDtoDto", JSON.stringify(applicationStatuses.gMonGUIColoringInfoDtoDto));
            this.manageGMonResultsColoring(applicationStatuses.gMonGUIColoringInfoDtoDto, false);
            // console.log("manage gmon coloring");
          }

          if (applicationStatuses.laGuiColoringInfoDto) {
            localStorage.setItem("laGuiColoringInfoDto", JSON.stringify(applicationStatuses.laGuiColoringInfoDto));
            this.manageLAResultsColoring(applicationStatuses.laGuiColoringInfoDto, false);
            // console.log("manage la coloring");
          }

          if (applicationStatuses.gpGUIColoringInfoDto) {
            localStorage.setItem("gpGUIColoringInfoDto", JSON.stringify(applicationStatuses.gpGUIColoringInfoDto));
            //if (this.selectedPlanningScenario) {
              //this.manageGPLANResultsColoring(applicationStatuses.gpGUIColoringInfoDto);
            //}
          }

          if (applicationStatuses.lmguiColoringInfoDto) {
            localStorage.setItem("lmGUIColoringInfoDto", JSON.stringify(applicationStatuses.lmguiColoringInfoDto));
            this.manageLMResultsColoring(applicationStatuses.lmguiColoringInfoDto);
          }

          if(applicationStatuses.curtailedDevices){
            localStorage.setItem("curtailedDevice",JSON.stringify(applicationStatuses.curtailedDevices))
            this.manageCurtailedDevicesColoring(applicationStatuses.curtailedDevices);
          }

          if(applicationStatuses.rpaGUIColoringInfoDto == null || applicationStatuses.pvData == null|| applicationStatuses.gMonGUIColoringInfoDtoDto == null
            || applicationStatuses.laGuiColoringInfoDto == null|| applicationStatuses.gpGUIColoringInfoDto == null|| applicationStatuses.lmguiColoringInfoDto== null){
              this.getConfiguredDisplay = true;
              if(this.iconsAreDisplayedUsingUserConfig){
                this.savePreviousToggledStates();
              }
              this.redrawNodesLayer(Array.from(this.nodesMap.values()));
              this.redrawCablesLayer();
          }

          if(this.eflResultsFromAlarms.length > 0){
            this.updateGridNodesAccordingToEflResults(this.eflResultsFromAlarms);
          }
        }

        this.checkEndAPIsandEnableTopologiesDropdown();
        if(this.initialNotificationReadOnce == false){
          this.loadInitialNotifications();
        }
        resolve();  // Resolve Promise after the operation
      },
      (error) => {
        console.error('Error fetching application statuses:', error);
        reject(error);  // Reject Promise in case of error
      });
    });
  }

  private managePvData(pvData: PVData){
    //save on local storage
    if(pvData && pvData.input){
      localStorage.setItem("PvInput", JSON.stringify(pvData.input))
    }
    if(pvData && pvData.output){
      localStorage.setItem("PvOutput", JSON.stringify(pvData.output))
    }
  }

  /*
    checkGPlanStatus() {
      let areGplanDataAvailable = localStorage.getItem("areGplanDataAvailable");
      let isGPlanRunning = localStorage.getItem("isGPlanRunning");

      if (areGplanDataAvailable == 'true' || isGPlanRunning == 'true') {
        return true
      } else {
        return false;
      }
    }
  */




  private manageLicenseExpiration(date: String) {
    this.isLicenseExpired = true;

    // Clear browser cache
    localStorage.clear();
    this.emptyMap('map');

    this.modalService.openBasicModal(
      this.licenseTitle,
      "<div>" + this.licenseText + date + ". </div>"
    );
  }

  private manageSessionExpiration() {
    console.log("session expired")
    this.modalService.openBasicModal(
      this.sessionTitle,
      "<div>" + this.sessionText + "</div>"
    );
    localStorage.clear();
    this.router.navigate(['']);
  }

  private emptyMap(mapId: string) {
    this.mapService.emptyMap(this.map);
  }

private loadMap(mapId: string) {
  try {
    // If the map is already initialized, remove it first
    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }

    this.map = this.mapService.buildBaseMap(mapId);

    // Load grid elements or additional layers on the new map
    this.loadGridElementsOnMap(this.map);
  } catch (error) {

    console.error('Error initializing the map:', error);
  }
}


  private loadLegendTypes() {


    if (this.date) {
      this.mapService.getElementTypesByTopologyIdTimeDependant(this.topology.topologyId, this.date).subscribe((types: Array<string>) => {
        this.loadLegendTypesDone = true;
        localStorage.setItem("gridElementsType", JSON.stringify(types));
        console.log(localStorage.getItem('gridElementsType'));
        this.checkEndAPIsandEnableTopologiesDropdown();
      });
    }
    else {


      this.mapService.getElementTypesByTopologyId(this.topology.topologyId).subscribe((types: Array<string>) => {
        this.loadLegendTypesDone = true;
        localStorage.setItem("gridElementsType", JSON.stringify(types));
        console.log(localStorage.getItem('gridElementsType'));
        this.checkEndAPIsandEnableTopologiesDropdown();
      });
    }
  }

  public loadGridType() {
    this.mapService.getGridType(this.topology.topologyId).subscribe((gridType: string) => {
      this.loadGridTypeDone = true;
      localStorage.setItem("gridType", JSON.stringify(gridType));
      console.log(localStorage.getItem('gridType'));
      this.checkEndAPIsandEnableTopologiesDropdown();
    });
  }



  //check if all the APIs responded before enabling topology dropdown
  public checkEndAPIsandEnableTopologiesDropdown() {

    if (this.loadGridTypeDone == true &&
      this.loadCableTypeDone == true &&
      this.loadLegendTypesDone == true &&
      this.getApplicationsStatusDone == true &&
      this.getGridElementsDetailsDone == true &&
      this.getCablesAndCoordinatesDone == true &&
      this.getListAvailableScenariosDone == true
    ) {
      this.disabledTopologiesDropdown = false;
      localStorage.setItem('cablesOriginal', JSON.stringify(this.cables));
      localStorage.setItem('nodeMapOriginal', JSON.stringify(Array.from(this.nodesMap.values())));

    }
    else {
      this.disabledTopologiesDropdown = true
    }
    console.log("this.getListAvailableScenariosDone: " + this.getListAvailableScenariosDone);
    console.log("this.loadGridTypeDone: " + this.loadGridTypeDone);
    console.log("this.loadCableTypeDone: " + this.loadCableTypeDone);
    console.log("this.loadLegendTypesDone: " + this.loadLegendTypesDone);
    console.log("this.getApplicationsStatusDone: " + this.getApplicationsStatusDone);
    console.log("this.getGridElementsDetailsDone: " + this.getGridElementsDetailsDone);
    console.log("this.getCablesAndCoordinatesDone: " + this.getCablesAndCoordinatesDone);
    console.log("this.disabledTopologiesDropdown: " + this.disabledTopologiesDropdown);
  }

  public isMVGridType() {
    let gridTypeJson: string = localStorage.getItem('gridType');
    if (gridTypeJson) {
      let gridTypeStr: string = JSON.parse(gridTypeJson);
      if (gridTypeStr == "MV") {
        return true;
      }
      else {
        return false;
      }
    }
  }


  private subscribeTopics() {
    const topics: Map<MqttTopic, boolean> = this.getTopics();
    const mqttClient = this.mqttClient;
    mqttClient.on('connect', function () {
      topics.forEach((value: boolean, topic: MqttTopic) => {
        if (value) {
          mqttClient.subscribe(topic, { qos: 2 }, function (err) {
            if (!err) {
              console.log("Subscribed to topic: " + topic);
            }
          });
        }
      });
    });
    // this.mqttClient = mqttClient;

    this.mqttClient.on('message', (topic, message) => {
      // message is Buffer
      console.log("Topic: " + topic);
      const messageString = message.toString();
      console.log("Message: " + messageString);
      // client.end()

      switch (topic) {
        /**
         * We should have only two topics here and from them I need to extract other applications
         */
        case MqttTopic.APPLICATIONS_PROGRESS_MESSAGE:

          if (!this.pvService.isPvListProcessingisRunning()) {
            let applicationsProgressMessage: ApplicationProgressMessage = JSON.parse(messageString);
            this.manageApplicationsProgressMessage(applicationsProgressMessage);
          }
          break;
        case MqttTopic.GUI_NOTIFICATION:
          this.manageGUINotification();
          break;
        case MqttTopic.LICENSE_EXPIRED:
          // Check license
          this.manageLicenseExpiration(messageString);
          break;
        case MqttTopic.SESSION_EXPIRED:
          // Check license
          this.manageSessionExpiration();
          break;
        case MqttTopic.ICT_GATEWAY:
          this.manageICTGateway(messageString);
          break;

        case MqttTopic.GMON_RESULTS_AVAILABLE:
          this.gmonResultsAvailableMessage = JSON.parse(messageString);
          this.showGMONResultNotifications(this.gmonResultsAvailableMessage);
          this.gMonService.setGMonRunning(false);
          this.getApplicationsStatus(this.topology.topologyId);
          //this.manageGMonResultsAvailable(this.gmonResultsAvailableMessage);
          break;

        case MqttTopic.PV_RESULTS_AVAILABLE:
            console.log(JSON.parse(messageString));
            this.pvResultsAvailableMessage = JSON.parse(messageString);
            this.showPVResultNotifications(this.pvResultsAvailableMessage);
            this.pvService.setPvListProcessingisRunning(false);
            this.gPlanService.setGPlanRunning(false);
            this.getApplicationsStatus(this.topology.topologyId);
            //this.manageGMonResultsAvailable(this.gmonResultsAvailableMessage);
            break;

        case MqttTopic.LA_RESULTS_AVAILABLE:
          this.laResultsAvailableMessage = JSON.parse(messageString);
          this.showLAResultNotifications(this.laResultsAvailableMessage);
          this.laService.setLARunning(false);
          this.getApplicationsStatus(this.topology.topologyId);
          //this.manageLAResultsAvailable(this.laResultsAvailableMessage);
          break;

        case MqttTopic.RPA_RESULTS_AVAILABLE:
          this.rpaResultsAvailableMessage = JSON.parse(messageString);
          this.showRPAResultNotifications(this.rpaResultsAvailableMessage);
          this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(false);
          this.getApplicationsStatus(this.topology.topologyId);
          //this.manageRPAResultsAvailable(this.rpaResultsAvailableMessage);
          break;

        case MqttTopic.GPLAN_RESULTS_AVAILABLE:
          console.log("IS PV running: " + this.pvService.isPvListProcessingisRunning())
          if (!this.pvService.isPvListProcessingisRunning()) {
              this.getApplicationsStatus(this.topology.topologyId)  // Assuming this is async and returns a Promise
                .then(() => {
                  this.manageGPlanResultsAvailable();  // This will run after the first one finishes
                })
                .catch(error => {
                  console.error('Error during execution:', error);  // Handle any error in the chain
                });
          }
          break;

        case MqttTopic.GMON_ERROR:
          // if (this.gmonAvailable) {
          this.manageGMonError(messageString);
          // }
          break;

        case MqttTopic.PV_ERROR:
            this.managePvError(messageString);
            break;

        case MqttTopic.LC_RESULTS_AVAILABLE:
          //if (this.lcAvailable) {
          this.manageLCResultsAvailable();
          //}
          break;
        case MqttTopic.LC_ERROR:
          //   if (this.lcAvailable) {
          this.manageLCError(messageString);
          //  }
          break;

        case MqttTopic.LA_ERROR:
          //    if (this.laAvailable) {
          this.manageLAError(messageString);
          //    }
          break;

        case MqttTopic.RPA_ERROR:
          //    if (this.rpaAvailable) {
          this.manageRPAError(messageString);
          //    }
          break;

        case MqttTopic.GPLAN_ERROR:
          //   if (this.gplanAvailable) {
          this.manageGPlanError(messageString);
          //   }
          break;
        case MqttTopic.GPLAN_SCENARIO_CREATED:
          console.log("IS PV running: " + this.pvService.isPvListProcessingisRunning())
          if (!this.pvService.isPvListProcessingisRunning())
            this.manageGPlanScenarioCreated();
          //   }
          break;
        case MqttTopic.FAULTLOCATIONS:
          //   if (this.eflAvailable) {
          this.manageEFLNotifications(message);
          //   }
          break;
        case MqttTopic.FAULTLOCATIONS_ERROR:
          //  if (this.eflAvailable) {
          this.manageEFLError(messageString);
          //   }
          break;
        case MqttTopic.ALARM_GENERATED:
          //this.loadNotReadNotificationsCount();
          this.notReadNotificationsCount = +messageString;
          break;
        case MqttTopic.LIVE_MONITORING_RESULTS_READY:
         if(this.topology.topologyId === messageString){
            this.getApplicationsStatus(this.topology.topologyId);
          }
          break;
      }
    });
  }

  initMQTT() {
    this.guiService.getMqttConfig().subscribe((mqttConfigurations: any) => {
      if (mqttConfigurations) {

        //      console.log(mqttConfigurations)

        this.mqttConfig = environment.MQTT_CONFIG;
        //  console.log(mqttConfigurations.clientId)
        this.mqttConfig.protocol = mqttConfigurations.protocol || "wss"
        this.mqttConfig.clientId = mqttConfigurations.clientId
        this.mqttConfig.host = mqttConfigurations.host
        this.mqttConfig.hostname = mqttConfigurations.host
        this.mqttConfig.path = mqttConfigurations.path

        this.mqttConfig.port = mqttConfigurations.port
        this.mqttConfig.username = mqttConfigurations.username
        this.mqttConfig.password = mqttConfigurations.password
        //console.log(this.mqttConfig)
        this.mqttClient = mqtt.connect(this.mqttConfig);
        this.subscribeTopics();
      }
    });
  }

  getTopics() {
    return new Map([
      [MqttTopic.APPLICATIONS_PROGRESS_MESSAGE, true],
      [MqttTopic.GUI_NOTIFICATION, true],
      [MqttTopic.LICENSE_EXPIRED, true],
      [MqttTopic.SESSION_EXPIRED, true],
      [MqttTopic.ICT_GATEWAY, true],
      [MqttTopic.GMON_RESULTS_AVAILABLE, this.gmonAvailable],
      [MqttTopic.GMON_ERROR, this.gmonAvailable],
      [MqttTopic.PV_ERROR, this.pvAvailable],
      [MqttTopic.LC_RESULTS_AVAILABLE, this.lcAvailable],
      [MqttTopic.LC_ERROR, this.lcAvailable],
      [MqttTopic.LA_RESULTS_AVAILABLE, this.laAvailable],
      [MqttTopic.LA_ERROR, this.laAvailable],
      [MqttTopic.RPA_RESULTS_AVAILABLE, this.rpaAvailable],
      [MqttTopic.RPA_ERROR, this.rpaAvailable],
      [MqttTopic.GPLAN_RESULTS_AVAILABLE, this.gplanAvailable],
      [MqttTopic.GPLAN_ERROR, this.gplanAvailable],
      [MqttTopic.GPLAN_SCENARIO_CREATED, this.gplanAvailable],
      [MqttTopic.FAULTLOCATIONS, this.eflAvailable],
      [MqttTopic.FAULTLOCATIONS_ERROR, this.eflAvailable],
      [MqttTopic.PV_RESULTS_AVAILABLE, this.pvAvailable],
      [MqttTopic.ALARM_GENERATED, true],
      [MqttTopic.LIVE_MONITORING_RESULTS_READY,true],
      [MqttTopic.INFOMQTTTOPIC, true],
      [MqttTopic.ERROMQTTTOPIC, true]
    ]);
  }

  manageApplicationsProgressMessage(message: ApplicationProgressMessage) {
    if (message) { }
    switch (message.type) {
      case MessageType.GMON:
        localStorage.setItem('gmonProgress', JSON.stringify(message))
        break;

      case MessageType.LA:
        localStorage.setItem('laProgress', JSON.stringify(message))
        break;

      case MessageType.RPA:
        localStorage.setItem('rpaProgress', JSON.stringify(message))
        break;

      case MessageType.LC:
        localStorage.setItem('lcProgress', JSON.stringify(message))
        break;

      case MessageType.GPLAN:
        localStorage.setItem('gplanProgress', JSON.stringify(message))
        break;
    }
  }

  getGmonProgress() {
    const language = localStorage.getItem("Language");
    let gmonProgressMessage: ApplicationProgressMessage = JSON.parse(localStorage.getItem("gmonProgress"));

    if (language == "de") {
      if (gmonProgressMessage) {
        this.gmonProgress = gmonProgressMessage.message_de;
      }
    }
    if (language == "en") {
      if (gmonProgressMessage) {
        this.gmonProgress = gmonProgressMessage.message_en;
      }
    }
    return this.gmonProgress;
  }

  getLAProgress() {
    const language = localStorage.getItem("Language");
    let laProgressMessage: ApplicationProgressMessage = JSON.parse(localStorage.getItem("laProgress"));

    if (language == "de") {
      if (laProgressMessage) {
        this.laProgress = laProgressMessage.message_de;
      }
    }
    if (language == "en") {
      if (laProgressMessage) {
        this.laProgress = laProgressMessage.message_en;
      }
    }
    return this.laProgress;
  }

  getRPAProgress() {
    const language = localStorage.getItem("Language");
    let rpaProgressMessage: ApplicationProgressMessage = JSON.parse(localStorage.getItem("rpaProgress"));

    if (language == "de") {
      if (rpaProgressMessage) {
        this.rpaProgress = rpaProgressMessage.message_de;
      }
    }
    if (language == "en") {
      if (rpaProgressMessage) {
        this.rpaProgress = rpaProgressMessage.message_en;
      }
    }
    return this.rpaProgress;
  }

  getLCProgress() {
    const language = localStorage.getItem("Language");
    let lcProgressMessage: ApplicationProgressMessage = JSON.parse(localStorage.getItem("lcProgress"));

    if (language == "de") {
      if (lcProgressMessage) {
        this.lcProgress = lcProgressMessage.message_de;
      }
    }
    if (language == "en") {
      if (lcProgressMessage) {
        this.lcProgress = lcProgressMessage.message_en;
      }
    }
    return this.lcProgress;
  }

  getGPlanProgress() {
    const language = localStorage.getItem("Language");
    let gplanProgressMessage: ApplicationProgressMessage = JSON.parse(localStorage.getItem("gplanProgress"));

    if (language == "de") {
      if (gplanProgressMessage) {
        this.gplanProgress = gplanProgressMessage.message_de;
      }
    }
    if (language == "en") {
      if (gplanProgressMessage) {
        this.gplanProgress = gplanProgressMessage.message_en;
      }
    }
    return this.gplanProgress;
  }

  manageGPlanError(message: string) {

    //remove planning scenario if Gplan fails when the user run it
    this.selectedPlanningScenario = false;
    //localStorage.removeItem("currentScenario");

    this.gPlanService.setGPlanRunning(false);
    /*this.modalService.openBasicModal(
      "Grid Planning",
      "<div>Grid Planning algorithm has finished with the following errors:</div>" +
      "<div>" + message + "</div>"
    );*/

    this.modalService.openBasicModal(
      "" + this.gplanTitle,
      "<div>" + this.gplanTextError + "</div>" +
      "<div>" + message + "</div>"
    );

    this.manageGPlanScenarioCreated()
  }

  manageGPlanScenarioCreated() {
    this.gridPlanningScenarios = [];
    this.initPlanningScenarioSummary()
    this.gPlanService.getListAvailableScenarios().subscribe((scenarios: Array<GPlanInput>) => {
      if (scenarios) {
        // console.log("Here is my scenarios list ", scenarios)
        this.gridPlanningScenarios = scenarios;
        if (this.gridPlanningScenarios.length > 0) {
          this.selectedScenario = this.gridPlanningScenarios[0];
          if (this.selectedScenario) {

            this.selectedScenarioName = this.selectedScenario.name
            this.selectedScenarioId = this.selectedScenario.id
            if(this.selectedScenario.planningTrafoDtos){
              this.scenarioTrafosNumber = this.selectedScenario.planningTrafoDtos.length;
              this.planningTrafoDtos = this.selectedScenario.planningTrafoDtos;
            }
            if (this.selectedScenario.planningNodes) {
              this.scenarioLoadsNumber = this.selectedScenario.planningNodes.length;
              this.planningNodes = this.selectedScenario.planningNodes;
            }
            if (this.selectedScenario.planningCables) {
              this.scenarioCablesNumber = this.selectedScenario.planningCables.length;
              this.planningCables = this.selectedScenario.planningCables;
            }
            if (this.selectedScenario.planningSwichtingStates) {
              this.scenarioSwitchingStateNumber = this.selectedScenario.planningSwichtingStates.length;
              this.planningSwichtingStates = this.selectedScenario.planningSwichtingStates;
            }

            if (this.selectedScenario.planningSubgridsDtos) {
              this.scenarioSubTreeNumber = this.selectedScenario.planningSubgridsDtos.length;
              this.planningSubgridsDtos = this.selectedScenario.planningSubgridsDtos;
            }
          }
          console.log("this.selectedPlanningScenario " + this.selectedPlanningScenario)
        }
      }
    });
  };

  manageGPlanResultsAvailable() {
    //localStorage.setItem('currentTab', 'gplan');
    this.gPlanService.setGPlanRunning(false);
    this.gPlanService.setGplanDataAvailable(true);

    //    this.gMonService.setGmonDataAvailable(false);
    //    this.laService.setLADataAvailable(false);


    //  todo) in gplan-processing & coloring
    /*this.modalService.openBasicModal(
      "Grid Planning",
      "<div>Grid Planning algorithm has finished. You can view the results by clicking on a Grid Node or a Cable. <div>"
    );*/
    this.gPlanService.getGPSummaryInfo(this.gridPlanningScenarios[this.gridPlanningScenarios.length - 1].id).subscribe((response: any) => {
    this.gpSummaryResult = response;

        this.modalService.openBasicModal(
          "" + this.gplanTitle,
          "<div>" + this.gplanTextResults +

          this.formatSummaryString(this.gplanSummary,this.gpSummaryResult)
          +
          "</div>"
        );
    });



    /* _____________________________________________________________________
    _________Showing new generated topology when GPlan finished_____________
    ______________________________________________________________________*/

    // this.selectedPlanningScenario = false;
    // this.gridPlanningScenarios = [];
    this.selectedScenario = this.gridPlanningScenarios[this.gridPlanningScenarios.length - 1];

    // dto.gMonGUIColoringInfoDto.gridplanningScenarioId == this.selectedScenario.id
    // console.error("GMOn coloring info dto ", dto.)
    // console.error("Selected scenario ", this.selectedScenario)
    this.onSelectScenario(this.selectedScenario.name);
    this.showPlanning();
  }

  private manageGUINotification() {
   // this.loadNotReadNotificationsCount();
  }

  private manageICTGateway(message: string) {
    if (message.toLowerCase() == 'online') {
      localStorage.setItem("isICTGatewayOnline", "true");
    } else {
      localStorage.setItem("isICTGatewayOnline", "false");
    }
  }

  private manageGMonResultsColoring(gmonResultsAvailableMessage: GMonResultsAvailableMessage, isLMResults: boolean) {
    this.initGridColors();

    //if mqtt message is defined
    if (gmonResultsAvailableMessage) {
      let areFrequencyResultsAvaiable: boolean = gmonResultsAvailableMessage.areFrequencyResultsAvaiable
      let areVoltageResultsAvaiable: boolean = gmonResultsAvailableMessage.areVoltageResultsAvaiable

      //set "areVoltageDataAvailable" and "areFrequencyDataAvailable"
      this.gMonService.setDataAvailable('areVoltageDataAvailable', areVoltageResultsAvaiable);
      this.gMonService.setDataAvailable('areFrequencyDataAvailable', areFrequencyResultsAvaiable);

      //if voltage results are available
      if (areVoltageResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }
          if (gmonResultsAvailableMessage.voltageViolationsPerGridelementId) {
            let numberOfVoltageViolations = gmonResultsAvailableMessage.voltageViolationsPerGridelementId[gridElement.gridElementId]

            gridColorTemp.voltage = this.getConditionVoltage(numberOfVoltageViolations, numberOfDaysRequestedByUser, isLMResults);
            gridColorTemp.voltageGP = Condition.NORMAL;
          }

          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
      //else voltage results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.voltage = Condition.NORMAL;;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if frequency results are available
      if (areFrequencyResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }

          if (gmonResultsAvailableMessage.frequencyViolationsPerGridelementId) {
            let numberOfFrequencyViolations = gmonResultsAvailableMessage.frequencyViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.frequency = this.getConditionFrequency(numberOfFrequencyViolations, numberOfDaysRequestedByUser);
          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //else frequency results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.frequency = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
    }
  }

  private manageGMonResultsColoringGP(gmonResultsAvailableMessage: GMonResultsAvailableMessage) {
    this.initGridColors();

    //if mqtt message is defined
    if (gmonResultsAvailableMessage) {
      let areFrequencyResultsAvaiable: boolean = gmonResultsAvailableMessage.areFrequencyResultsAvaiable
      let areVoltageResultsAvaiable: boolean = gmonResultsAvailableMessage.areVoltageResultsAvaiable

      //set "areVoltageDataAvailable" and "areFrequencyDataAvailable"
      this.gMonService.setDataAvailable('areVoltageDataAvailable', areVoltageResultsAvaiable);
      this.gMonService.setDataAvailable('areFrequencyDataAvailable', areFrequencyResultsAvaiable);

      //if voltage results are available
      if (areVoltageResultsAvaiable == true) {

        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }
          if (gmonResultsAvailableMessage.voltageViolationsPerGridelementId) {
            let numberOfVoltageViolations = gmonResultsAvailableMessage.voltageViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.voltageGP = this.getConditionVoltage(numberOfVoltageViolations, numberOfDaysRequestedByUser, false);
            gridColorTemp.voltage = Condition.NORMAL;
          }

          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }
      //else voltage results are not available
      else {
        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.voltageGP = Condition.NORMAL;;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }

      //if frequency results are available
      if (areFrequencyResultsAvaiable == true) {
        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }

          if (gmonResultsAvailableMessage.frequencyViolationsPerGridelementId) {
            let numberOfFrequencyViolations = gmonResultsAvailableMessage.frequencyViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.frequency = this.getConditionFrequency(numberOfFrequencyViolations, numberOfDaysRequestedByUser);
          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }

      //else frequency results are not available
      else {
        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.frequency = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }
    }
  }


  public getConditionVoltage(numberOfViolations: number, numberOfDay: number, isLM: boolean): Condition {
    let condition: Condition = Condition.NORMAL;
    //    console.log("numberOfDay: " + numberOfDay);
    if (numberOfDay !== 0) {
      numberOfViolations = numberOfViolations / numberOfDay;
      if (numberOfViolations > 0) {
        const x = numberOfViolations; // / this.data.average.length;
        if (
          x > this.configurationService.getConfiguration().normalMaxViolationsRatio &&
          x <= this.configurationService.getConfiguration().attentionMaxViolationsRatio
        ) {
          condition = Condition.ATTENTION;
        }
        if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatio) {
          condition = Condition.PROBLEM;
        }
      }
    } else if (this.selectedScenario && this.selectedScenario.type == "WC" && numberOfViolations > 0) {

      condition = Condition.PROBLEM;
    } else if (numberOfViolations > 0)
      condition = Condition.PROBLEM;
    return condition;
  }

  public getConditionFrequency(numberOfFrequencyViolations: number, numberOfDay: number): Condition {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDay !== 0) {
      numberOfFrequencyViolations = numberOfFrequencyViolations / numberOfDay;

      if (numberOfFrequencyViolations > 0) {
        const x = numberOfFrequencyViolations;
        if (
          numberOfFrequencyViolations > this.configurationService.getConfiguration().normalMaxViolationsRatioFrequency &&
          x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioFrequency
        ) {
          condition = Condition.ATTENTION;
        }
        if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioFrequency) {
          condition = Condition.PROBLEM;
        }
      }

    } else if (this.selectedScenario && this.selectedScenario.type == "WC" && numberOfFrequencyViolations > 0) {

      condition = Condition.PROBLEM;
    }
    // console.log("numberOfViolations: " + numberOfViolations);

    return condition;
  }


  // Redraw Nodes layer
  redrawNodesLayer(gridElements: Array<GridElement>, showSubIds?: boolean) {
    console.log("redrawNodesLayer")
    console.log(this.gridNodesLayer)

    if (this.gridNodesLayer)
      this.map.removeLayer(this.gridNodesLayer);

    const markers: Array<L.marker> = this.drawGridElementsOnMap(gridElements, !this.showIds, showSubIds);
    this.gridNodesLayer = L.layerGroup(markers);
    this.gridNodesLayer.addTo(this.map);
    try {
      localStorage.setItem('gridElements', JSON.stringify(gridElements));
    } catch (e) {
      console.error('Failed to save gridElements:', e);
    }
  }

  // Change Cables color
  redrawCablesLayer() {
    // console.log("This cables from redraw: ", this.cables);
    if (this.cablesLayer) {
      this.map.removeLayer(this.cablesLayer);
    }
    if (this.cablesLayerOpen){
      this.map.removeLayer(this.cablesLayerOpen);
    }
    this.drawCablesOnMap(this.map, this.cables);
    // console.log("This cables Layer from redraw : " , this.cablesLayer);
  }

  private manageGMonError(message: string) {
    this.gMonService.setGMonRunning(false);
    this.modalService.openBasicModal(
      "" + this.gmonTitle,
      "<div>" + this.gmonTextError + "</div>" +
      "<div>" + message + "</div>"
    );
  }

  private managePvError(message: string) {
    this.gPlanService.setGPlanRunning(false);
    this.pvService.setPvListProcessingisRunning(false);
    this.modalService.openBasicModal(
      "" + this.pvTitle,
      "<div>" + this.pvTextError + "</div>" +
      "<div>" + message + "</div>"
    );
  }

  private manageLCResultsAvailable() {
    this.lcService.setLCRunning(false);
    this.lcService.setLCDataAvailable(true);
    this.modalService.openBasicModal(
      "" + this.lcTitle,
      "<div>" + this.lcTextResults + "<i class='fas fa-chart-area'></i><div>"
    );
  }

  private manageLCError(message: string) {
    this.lcService.setLCRunning(false);
    this.modalService.openBasicModal(
      "" + this.lcTitle,
      "<div>" + this.lcTextError + "</div>" +
      "<div>" + message + "</div>"
    );
  }


  /*

  private manageGMonResultsAvailable(gmonResultsAvailableMessage: GMonResultsAvailableMessage) {
    this.showGMONResultNotifications(gmonResultsAvailableMessage);
    this.manageGMonResultsColoring(gmonResultsAvailableMessage);
    //this.gPlanService.setGplanDataAvailable(false);
    this.gMonService.setGMonRunning(false);

  }

  private manageLAResultsAvailable(laResultsAvailableMessage: LAResultsAvailableMessage) {
    this.showLAResultNotifications(laResultsAvailableMessage);
    this.manageLAResultsColoring(laResultsAvailableMessage);
    //this.gPlanService.setGplanDataAvailable(false);
    this.laService.setLARunning(false);

  }

  private manageRPAResultsAvailable(rpaResultsAvailableMessage: RPAResultsAvailableMessage) {
    this.showRPAResultNotifications(rpaResultsAvailableMessage);
    this.manageRpaResultsColoring(rpaResultsAvailableMessage);
  }
  */


  showGMONResultNotifications(gmonResultsAvailableMessage: GMonResultsAvailableMessage) {
    if (gmonResultsAvailableMessage.areFrequencyResultsAvaiable || gmonResultsAvailableMessage.areVoltageResultsAvaiable) {
      localStorage.removeItem('overallResults');
      this.modalService.openBasicModal(
        "" + this.gmonTitle,
        "<div>" + this.gmonTextResults + "</div>"
        // + "<div><img class='gmon-results-showcase' src='assets/images/gmon-results-showcase.gif'></div>"
      );
    }
    else {
      this.modalService.openBasicModal(
        "" + this.gmonTitle,
        "<div>" + this.gmonTextEmpty + "</div>"// +
        // "<div><img class='gmon-results-showcase' src='assets/images/gmon-results-showcase.gif'></div>"
      );
    }
  }

  showPVResultNotifications(pvResultsAvailableMessage: PVResultsAvailableMessage) {
    if (pvResultsAvailableMessage.arePVResultsAvaiable) {
      this.modalService.openBasicModal(
        "" + this.pvTitle,
        "<div>" + this.pvTextResults + "</div>"
      );
    }
    else {
      this.modalService.openBasicModal(
        "" + this.pvTitle,
        "<div>" + this.pvTextEmpty + "</div>"// +
      );
    }
  }

  private showLAResultNotifications(laResultsAvailableMessage: LAResultsAvailableMessage) {
    if (laResultsAvailableMessage.areNodeResultsAvaiable || laResultsAvailableMessage.areCableResultsAvaiable) {
      localStorage.removeItem('overallResults');
      this.modalService.openBasicModal(
        "" + this.laTitle,
        "<div>" + this.laTextResults + "<div>"
      );
    }
    else {
      this.modalService.openBasicModal(
        "" + this.laTitle,
        "<div>" + this.laTextEmpty + "<div>");
    }
  }

  showRPAResultNotifications(rpaResultsAvailableMessage: RPAResultsAvailableMessage) {
    if (rpaResultsAvailableMessage.isDataAvaiable) {
      this.modalService.openBasicModal(
        "" + this.rpaTitle,
        "<div>" + this.rpaTextResults + "<div>"
      );
    }
    else {
      this.modalService.openBasicModal(
        "" + this.rpaTitle,
        "<div>" + this.rpaTextEmpty + "<div>");
    }
  }

  private manageLAResultsColoring(laResultsAvailableMessage: LAResultsAvailableMessage, isLMresults: boolean) {
    this.initGridColors();
    this.initCableColors();

    //if message is defined
    if (laResultsAvailableMessage) {
      let numberOfDaysRequestedByUser = laResultsAvailableMessage.numberOfDaysRequestedByUser
      let areNodeResultsAvaiable = laResultsAvailableMessage.areNodeResultsAvaiable
      let areCableResultsAvaiable = laResultsAvailableMessage.areCableResultsAvaiable

      // set "areLADataAvailable" variable on localstorage
      if (areNodeResultsAvaiable == true || areCableResultsAvaiable == true) {
        this.laService.setLADataAvailable(true)
      }
      else {
        this.laService.setLADataAvailable(false)
      }

      //if node results are available
      if (areNodeResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          if (laResultsAvailableMessage.nodeViolationsPerGridelementId) {
            let nodeViolationsPerGridelementId = laResultsAvailableMessage.nodeViolationsPerGridelementId[gridElement.gridElementId]
            if (nodeViolationsPerGridelementId != null && nodeViolationsPerGridelementId !== undefined) {
              gridColorTemp.la = this.getLaCondition(nodeViolationsPerGridelementId, numberOfDaysRequestedByUser, isLMresults);
            }
          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if node results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.la = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }


      const cablesJson: string = localStorage.getItem('cables');
      const cableGridElementIds: Array<number> = new Array<number>();
      if (this.cables.length > 0) {
        this.cables.forEach((cable: any) => {
          cableGridElementIds.push(cable.gridElementId);
        });
      } else if (cablesJson) {
        this.cables = JSON.parse(cablesJson);
        if (this.cables == null) {
          this.loadCablesOnMap(this.map);
        }
        this.cables.forEach((cable: any) => {
          cableGridElementIds.push(cable.gridElementId);
        });
      }


      //if cable results are available
      if (areCableResultsAvaiable) {
        Array.from(this.cablesMap.values()).map((cable: Cable) => {

          if (laResultsAvailableMessage.cableViolationsPerGridelementId) {
            let cableViolationsPerGridelementId = laResultsAvailableMessage.cableViolationsPerGridelementId[cable.gridElementId]
            const newColor = this.getColorCable(cableViolationsPerGridelementId, numberOfDaysRequestedByUser,isLMresults);
            const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);

            if (cableColorTemp) {
              cableColorTemp.la = newColor;
            }
            cable.color = newColor;

          }
          // console.log(cable.gridElementId + ' ; ' + cable.color);
          return cable;
        });

        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
        } catch (e) {
           console.error('Failed to save cables:', e);
        }
        this.saveCableColorApps();
        this.redrawCablesLayer();
      }

      //if cable results are not available
      else {
        Array.from(this.cablesMap.values()).map((cable: Cable) => {
          const newColor = Config.CONDITION_COLOR_NORMAL;
          const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
          if (cableColorTemp != undefined) {
            cableColorTemp.la = newColor;
          }
          cable.color = newColor;
          // console.log(cable.gridElementId + ' ; ' + cable.color);
          return cable;
        });

        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
         } catch (e) {
             console.error('Failed to save cables:', e);
         }        this.saveCableColorApps();
        this.redrawCablesLayer();
      }
    }
  }

  private manageLAResultsColoringGP(laResultsAvailableMessage: LAResultsAvailableMessage) {
    this.initGridColors();
    this.initCableColors();

    //if message is defined
    if (laResultsAvailableMessage) {
      let numberOfDaysRequestedByUser = laResultsAvailableMessage.numberOfDaysRequestedByUser
      let areNodeResultsAvaiable = laResultsAvailableMessage.areNodeResultsAvaiable
      let areCableResultsAvaiable = laResultsAvailableMessage.areCableResultsAvaiable

      // set "areLADataAvailable" variable on localstorage
      if (areNodeResultsAvaiable == true || areCableResultsAvaiable == true) {
        //this.laService.setLADataAvailable(true)
        this.laService.setLADataAvailableGP(true)
      }
      else {
        this.laService.setLADataAvailableGP(false)
      }

      //if node results are available
      if (areNodeResultsAvaiable == true) {
        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          if (laResultsAvailableMessage.nodeViolationsPerGridelementId) {
            let nodeViolationsPerGridelementId = laResultsAvailableMessage.nodeViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.laGP = this.getLaCondition(nodeViolationsPerGridelementId, numberOfDaysRequestedByUser, false);

          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }

      //if node results are not available
      else {
        Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.laGP = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
      }

      /*
            const cablesJson: string = localStorage.getItem('cables');
            const cableGridElementIds: Array<number> = new Array<number>();
            if (this.cables.length > 0) {
              this.cables.forEach((cable: any) => {
                cableGridElementIds.push(cable.gridElementId);
              });
            } else if (cablesJson) {
              this.cables = JSON.parse(cablesJson);
              if (this.cables == null || this.cables.length === 0) {
                this.loadCablesOnMap(this.map);
              }
              this.cables.forEach((cable: any) => {
                cableGridElementIds.push(cable.gridElementId);
              });
            }
      */

      //if cable results are available
      if (areCableResultsAvaiable) {
        //Array.from(this.cablesMapGP.values()).map((cable: Cable) => {

        this.cables.forEach(cable => {
          if (laResultsAvailableMessage.cableViolationsPerGridelementId) {
            let cableViolationsPerGridelementId = laResultsAvailableMessage.cableViolationsPerGridelementId[cable.gridElementId]
            const newColor = this.getColorCable(cableViolationsPerGridelementId, numberOfDaysRequestedByUser,false);
            const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
            if (cableColorTemp) {
              cableColorTemp.laGP = newColor;
            }
            cable.color = newColor;
          }
          // console.log(cable.gridElementId + ' ; ' + cable.color);

          return cable;
        });

        //localStorage.setItem('cablesGP', JSON.stringify(this.cables));
        this.saveCableColorApps();
        this.redrawCablesLayer();
      }

      //if cable results are not available
      else {

        // Array.from(this.cablesMapGP.values()).map((cable: Cable) => {
        this.cables.forEach(cable => {
          const newColor = Config.CONDITION_COLOR_NORMAL;
          const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
          cableColorTemp.laGP = newColor;
          cable.color = newColor;
          // console.log(cable.gridElementId + ' ; ' + cable.color);
          return cable;
        });

        //localStorage.setItem('cablesGP', JSON.stringify(this.cables));
        this.saveCableColorApps();
        this.redrawCablesLayer();
      }
    }
  }

  private manageGPLANResultsColoring(gpGUIColoringInfoDto: GPResultsAvailableMessage) {
    if (gpGUIColoringInfoDto) {
      if (gpGUIColoringInfoDto.gMonGUIColoringInfoDto) {
        this.manageGMonResultsColoringGP(gpGUIColoringInfoDto.gMonGUIColoringInfoDto);
      }
      if (gpGUIColoringInfoDto.laGuiColoringInfoDto) {
        this.manageLAResultsColoringGP(gpGUIColoringInfoDto.laGuiColoringInfoDto);
      }
    }
  }
   private restoreGPColors() {

      Array.from(this.nodesMapGP.values()).map((gridElement: GridElement) => {
        const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
        gridColorTemp.laGP = Condition.NORMAL;
        gridColorTemp.voltageGP = Condition.NORMAL;
        gridElement.condition = Condition.NORMAL;
        return gridElement;
      });

      this.cablesMapGP.forEach(cable => {
        const newColor = Config.CONDITION_COLOR_NORMAL;
        const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
        cableColorTemp.laGP = newColor;
        cable.color = newColor;
        // console.log(cable.gridElementId + ' ; ' + cable.color);
        return cable;
      });

      //localStorage.setItem('cablesGP', JSON.stringify(this.cables));
      this.redrawCablesLayer();

      this.redrawNodesLayer(Array.from(this.nodesMapGP.values()));
    }

  private manageLMResultsColoring(lmGUIColoringInfoDto: LMResultsAvailableMessage) {
    console.log("Manage LM coloring.")
    if (lmGUIColoringInfoDto) {
      if (lmGUIColoringInfoDto.gMonGUIColoringInfoDto) {
        this.manageGMonResultsColoring(lmGUIColoringInfoDto.gMonGUIColoringInfoDto, true);
      }
      if (lmGUIColoringInfoDto.laGuiColoringInfoDto) {
        this.manageLAResultsColoring(lmGUIColoringInfoDto.laGuiColoringInfoDto, true);
      }
    }
  }

private manageCurtailedDevicesColoring(curtailedDevices: Array<number>) {
    const gridElementJSONParsed: string = localStorage.getItem('gridElements');

    if (gridElementJSONParsed) {
        const gridElementsForComparison: Array<GridElement> = JSON.parse(gridElementJSONParsed);
        for (const node of gridElementsForComparison) {
          const tempGridElementId : number = parseInt(node.gridElementId.toString());

            if (curtailedDevices && curtailedDevices.includes(tempGridElementId)) {
                const markerStatistics = this.mapService.buildControllableIcon(node, Condition.ATTENTION);
                this.map.addLayer(markerStatistics);
            }
            else if (this.controllableDevicesGridElementIDs && this.controllableDevicesGridElementIDs.includes(tempGridElementId)) {
                const markerStatistics = this.mapService.buildControllableIcon(node, Condition.NORMAL);
                this.map.addLayer(markerStatistics);
            }
        }
    }
}

  public getLaCondition(numberOfViolations: number, numberOfDayLA: number, isLMresults: boolean): Condition {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDayLA !== 0) {
      numberOfViolations = numberOfViolations / numberOfDayLA;

      if (numberOfViolations > 0) {
        const x = numberOfViolations; // / this.data.average.length;

        if (x >= this.configurationService.getConfiguration().normalMaxViolationsRatioLA
          && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioLA) {
          condition = Condition.ATTENTION;
        }
        if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioLA) {
          condition = Condition.PROBLEM;
        }
      }
    } else if (this.selectedScenario && this.selectedScenario.type == "WC" && numberOfViolations > 0) {
      condition = Condition.PROBLEM;
    } else if ( numberOfViolations > 0)
      condition = Condition.PROBLEM;

    return condition;
  }

  public getColorCable(numberOfViolations: number, numberOfDayLA: number,isLMresults: boolean): string {
    let color: string = Config.CONDITION_COLOR_NORMAL;
    //  console.log("numberOfDayLA: " + numberOfDayLA);
    if (numberOfDayLA !== 0) {
      numberOfViolations = numberOfViolations / numberOfDayLA;
      if (numberOfViolations > 0) {
        const x = numberOfViolations; // / this.data.average.length;

        if (x >= this.configurationService.getConfiguration().normalMaxViolationsRatioLACable
          && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioLACable) {
          color = Config.CONDITION_COLOR_ATTENTION;
        }
        if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioLACable) {
          color = Config.CONDITION_COLOR_PROBLEM;
        }
      }
    } else if (this.selectedScenario && this.selectedScenario.type == "WC" && numberOfViolations > 0) {

      color = Config.CONDITION_COLOR_PROBLEM;
    }else if (isLMresults && numberOfViolations > 0)
      color = Config.CONDITION_COLOR_PROBLEM;

    return color;
  }


  private manageLAError(message: string) {
    this.laService.setLARunning(false);
    this.modalService.openBasicModal(
      "" + this.laTitle,
      "<div>" + this.laTextError + "<div>" +
      "<div>" + message + "</div>"
    );
  }

  isICTGatewayOnline(): boolean {
    const isICTGatewayOnline: string = localStorage.getItem("isICTGatewayOnline");
    if (isICTGatewayOnline && isICTGatewayOnline.toLowerCase() == "true") {
      return true;
    } else {
      return false;
    }
  }

  private manageRpaResultsColoring(rpaResultsAvailableMessage: RPAResultsAvailableMessage) {
    // this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(false);
    this.initGridColors();

    //if mqtt message is defined
    if (rpaResultsAvailableMessage) {

      let isDataAvaiable: boolean = rpaResultsAvailableMessage.isDataAvaiable;
      let numberOfDaysRequestedByUser: number = rpaResultsAvailableMessage.numberOfDaysRequestedByUser
      this.reactivePowerAnalysisService.setRPADataAvailable(isDataAvaiable)
      let ids = this.gridElementService.getAllTransformerIds();

      //if data are available
      if (isDataAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {

          if (rpaResultsAvailableMessage.nodeViolationsPerGridelementId) {
            let nodeViolationsPerGridelementId: number = rpaResultsAvailableMessage.nodeViolationsPerGridelementId[gridElement.gridElementId]
            console.log("nodeViolationsPerGridElementId: ", nodeViolationsPerGridelementId)
            const newCondition: Condition = this.getConditionRPA(nodeViolationsPerGridelementId, numberOfDaysRequestedByUser);
            console.log("newCondition: ", newCondition)
            const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
            console.log("gridColorApps " , this.gridColorApps)
            /**
             * The rpa is not available in the grid Elements that are not in the gridColorApps in the storage
             */
            gridColorTemp.rpa = newCondition;
            if (gridElement.condition !== newCondition) {
              gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
            }
          }
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if data are not available
      else {
        /*        console.log(ids)
                ids.forEach(id => {
                  Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
                    if (+gridElement.gridElementId == +id) {
                      gridElement.condition = Condition.NORMAL;
                      return gridElement;
                    }
                  });
                });
        */
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.rpa = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.saveGridColorApps();
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
    }

  }

  getConditionRPA(nodeViolationsPerGridelementId: number, numberOfDaysRequestedByUser_: number) {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDaysRequestedByUser_ !== 0) {
      nodeViolationsPerGridelementId = nodeViolationsPerGridelementId / numberOfDaysRequestedByUser_;

      if (nodeViolationsPerGridelementId > 0) {
        const x = nodeViolationsPerGridelementId; // / this.data.average.length;
        if (x > this.configurationService.getConfiguration().normalMaxViolationsRatioRPA
          && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioRPA) {
          condition = Condition.ATTENTION;
        }
        if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioRPA) {
          condition = Condition.PROBLEM;
        }
      }

    } else if (this.selectedScenario && this.selectedScenario.type == "WC" && nodeViolationsPerGridelementId > 0) {
      condition = Condition.PROBLEM;
    }

    return condition;
  }


  private manageRPAError(message: string) {
    this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(false);    // laService.setLARunning(false);
    this.modalService.openBasicModal(
      "" + this.rpaTitle,
      "<div>" + this.rpaTextError + "</div>" +
      "<div>" + message + "</div>"
    );
  }

  async drawLVTopologyCablesOnMVTopology(lvTopologyId: string): Promise<string>{

    return new Promise((resolve) => {
      this.mapService.getCablesAndCoorditanesFromMvTopology(lvTopologyId).subscribe((cables: Array<Cable>) => {
        this.mapLVTopologyAndArrayOfCables.set(lvTopologyId, cables);
        let arrayOfCableIDs: Array<number> = new Array<number>();

        cables.forEach((cable:Cable) => {
          let propList = new Array<Property>();
          propList.push(new Property("jumpTopology",lvTopologyId));
          cable.properties = propList;
          this.cables.push(cable);
          this.cablesGP.push(cable);
          arrayOfCableIDs.push(cable.gridElementId);
        });

        this.cables = this.cables.map((cable: Cable) => {
          // cable.color = Config.CONDITION_COLOR_NORMAL;
          cable.weight = 1;
          return cable;
        });

        this.mapLVTopologyAndArrayOfCableIDs.set(lvTopologyId, arrayOfCableIDs);

        this.cablesMap.forEach((value, key) => {
          this.intermediateCablesMap.set(key, value);
        });

        this.intermediateCablesMap.forEach((value, key) => {
          this.cablesMap.delete(key);
        });

        cables.forEach((cable) => {
          this.cablesMap.set(cable.gridElementId, cable);
        });

        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
        } catch (e) {
          console.error('Failed to save cables:', e);
        }

        this.testingSomeMethodCables();
        this.redrawCablesLayer();

        resolve("Done");
      });
    });
  }

  async toggleLVTopologiesOnMV(gridElementId: number, marker: L.layer, gridElementMSStation: GridElement) {

    let topologies: string[] = [];

    topologies = await this.getLVTopologiesForMV(gridElementId, marker);
    await this.toggleLVTopologyOnMV(topologies, marker, gridElementMSStation);
  }

  async getLVTopologiesForMV(gridElementId: number, marker: L.layer): Promise<string[]> {
    return new Promise((resolve, reject) => {
      this.mapService.getLvGridElementsForMvTopology(gridElementId).pipe(catchError((error: HttpErrorResponse) => {
        this.modalService.openBasicAlert(this.noLVTopologyTitle, this.noLVTopologyText);
        marker.closePopup();
        return throwError(error);
      })).subscribe((response: any) => {
        console.log(response);
        let topologies: string[] = response;
        resolve(topologies);
      });
    });
  }

  /**
   * -----This method toggles LV Topology on the MV Topology -> ---------------------
   * -----When we right click on the Trafo (triangle) we get the name of the topology
   * -----related to that trafo and using that name we performing call to receive all
   * -----gridelements and cables fro that topology----------------------------------
   * @param gridElementId
   * @param marker I'm not sure that this marker should be here. I'll try to use it to hide or show rectangle oor triangle
   */
  async toggleLVTopologyOnMV(topologies: string[], marker: L.layer, gridElementMSStation: GridElement): Promise<void> {

    return new Promise((resolve, reject) => {

      for(let i=0; i<topologies.length; i++){

        let lvTopologyId: string = topologies[i];
        console.log(topologies[i]);

        if(lvTopologyId != null && lvTopologyId != "") {

          // topology/getGuiElements/ endpoint
          this.mapService.getGridElementDetailsFromMVTopology(lvTopologyId).subscribe((gridElements: Array<GridElement>) => {
            console.log("LV Topology grid Elements: ", gridElements);
            if(gridElements.length == 0){
              marker.closePopup();
              this.modalService.openBasicAlert(this.onlyOneLVTrafoTitle, this.onlyOneLVTrafoText);
            }else{
              let firstElementOfGridElements: GridElement;
              let lvTopologyGridNodes: Map<number, GridElement> = new Map<number, GridElement>();

              // lvTopologyGridNodes.clear();

              if(gridElements.length == 1){
              marker.closePopup();
                this.modalService.openBasicAlert(this.onlyOneLVTrafoTitle, this.onlyOneLVTrafoText);
              }else{
                let arrayOfGridElementsIDs: Array<number> = new Array<number>();
                gridElements.forEach((gridElement) => {
                  gridElement.condition = Condition.NORMAL;
                  lvTopologyGridNodes.set(
                    parseInt(gridElement.gridElementId.toString()),
                    new GridElement(
                      gridElement.gridElementId,
                      gridElement.elementSubType,
                      gridElement.properties,
                      gridElement.condition
                    )
                  );
                  arrayOfGridElementsIDs.push(gridElement.gridElementId);
                });

              lvTopologyGridNodes.forEach((value, key) => {
                let prop = { "name": "jumpTopology", "value": lvTopologyId }
                let propResult = { "name": "noResult", "value": "true" }
                value.properties.push(prop)
                value.properties.push(propResult)
                this.nodesMap.set(key, value);
              })
                firstElementOfGridElements = gridElements[0];
                this.mapLVFirstElementAndLVTopologyName.set(firstElementOfGridElements.properties[0].value, lvTopologyId);
                // console.log("mapLVFirstElementAndLVTopologyName: ", this.mapLVFirstElementAndLVTopologyName);
                this.mapLVTopologyNameAndGridElements.set(lvTopologyId, gridElements);
                // console.log("mapLVTopologyNameAndGridElements: ", this.mapLVTopologyNameAndGridElements);
                this.mapLVTopologyNameAndGridElementsID.set(lvTopologyId, arrayOfGridElementsIDs);
                // console.log("mapLVTopologyNameAndGrdiElementsID: ", this.mapLVTopologyNameAndGridElementsID);
                this.mapLVTopologyNameAndMVTrafo.set(lvTopologyId, gridElementMSStation);
                // console.log("mapLVTopologyNameAndMVTrafo: ", this.mapLVTopologyNameAndMVTrafo);

                this.mapLVTopologyNameAndMVTrafo.forEach((value, key) => {
                  this.nodesMap.delete(parseInt((value.gridElementId).toString()));
                });

                //this.getApplicationsStatus(lvTopologyId);
                localStorage.setItem('gridElements', JSON.stringify(Array.from(this.nodesMap.values())));
                this.getColoringForLvTopology();
                this.redrawNodesLayer(Array.from(this.nodesMap.values()));
                this.redrawCablesLayer();
                //Removing the lv topology if the amount of lv topologies more than it required
                if(this.mapLVFirstElementAndLVTopologyName.size > this.amountOfLVTopologiesOnMVTopologyMap){

                  //Removing first displayed LV Topology nodes
                  let lvTopologyIdToRemove = this.mapLVFirstElementAndLVTopologyName.get(this.mapLVFirstElementAndLVTopologyName.keys().next().value);


                  this.mapLVTopologyNameAndGridElementsID.forEach((value, key) => {
                    if(key == lvTopologyIdToRemove){
                      value.forEach((number) => {
                        this.nodesMap.delete(parseInt(number.toString()));
                      })
                    }
                  })
                  this.nodesMap.set(parseInt((this.mapLVTopologyNameAndMVTrafo.get(lvTopologyIdToRemove).gridElementId).toString()), this.mapLVTopologyNameAndMVTrafo.get(lvTopologyIdToRemove));

                  this.mapLVTopologyNameAndGridElements.delete(lvTopologyIdToRemove);
                  this.mapLVFirstElementAndLVTopologyName.delete(this.mapLVFirstElementAndLVTopologyName.keys().next().value)
                  this.mapLVTopologyNameAndMVTrafo.delete(lvTopologyIdToRemove);
                  this.mapLVTopologyNameAndGridElementsID.delete(lvTopologyIdToRemove);

                  this.redrawNodesLayer(Array.from(this.nodesMap.values()));

                  //removing first displayed LV Topology cables

                  this.mapLVTopologyAndArrayOfCables.get(lvTopologyIdToRemove).forEach((cable) => {
                    if(this.cables.indexOf(cable) !== -1){
                  this.cables.splice(this.cables.indexOf(cable), 1);
                      this.cablesGP.splice(this.cablesGP.indexOf(cable), 1);

                    }
                  });

                  this.mapLVTopologyAndArrayOfCableIDs.get(lvTopologyIdToRemove).forEach((value) => {
                    this.intermediateCablesMap.delete(value);
                    this.cablesMap.delete(value);
                    this.cableColorApps.delete(value);
                  });

                    this.mapLVTopologyAndArrayOfCables.delete(lvTopologyIdToRemove);
                    this.mapLVTopologyAndArrayOfCableIDs.delete(lvTopologyIdToRemove);
                   try {
                    localStorage.setItem('cables', JSON.stringify(this.cables));
                   } catch (e) {
                    console.error('Failed to save cables:', e);
                  }
                    this.saveCableColorApps();

                    this.redrawCablesLayer();

                  resolve();
                }
              }
              this.drawLVTopologyCablesOnMVTopology(lvTopologyId);
            }
          });

          // topology/getCablesAndCoordinates/  endpoint
        }
      }
    });
  }
  /**
   * -----This method just takes the list of cables from REST API takes OPEN cables from them --
   * -----calculate the place where we need to place switch marker and store that switch marker-
   * -----in the array of markers---------------------------------------------------------------
   * @param cables Array of cables from REST API
   * @returns Array of Switch markers
   */
  private drawLVSwitchesOnMVTopology(cables: Array<Cable>): Array<L.marker> {
    const markerSwitchesLV: Array<L.marker> = new Array<L.marker>();

    for(const cable of cables){
      if(cable.switchingState == "OPEN"){
        if(cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon){
          let coordinates = [];
          coordinates = [
            [cable.startNodeLat, cable.startNodeLon],
            [cable.endNodeLat, cable.endNodeLon]
          ];

          let sourceLatitudeRadiant = cable.startNodeLat * (Math.PI / 180);
          let destinationLatitudeRadiant = cable.endNodeLat * (Math.PI / 180);
          let middleLatitudeRadiant = Math.atan(Math.sinh(Math.log(Math.sqrt(
            (Math.tan(destinationLatitudeRadiant) + 1 / Math.cos(destinationLatitudeRadiant)) * (Math.tan(sourceLatitudeRadiant) + 1 / Math.cos(sourceLatitudeRadiant))))));
          let middleLatitude = middleLatitudeRadiant * (180 / Math.PI)
          let middleLongitude = (cable.startNodeLon + cable.endNodeLon) / 2;

          const markerSwitchForLV = this.mapService.buildSwitchMarker(middleLatitude, middleLongitude);
          if(markerSwitchForLV){
            markerSwitchesLV.push(markerSwitchForLV);
          }
        }
      }
    }
    return markerSwitchesLV;
  }
  /**
   * -----This method takes an array of cables split them into----------
   * -----OPEN and CLOSED puts them into array of polylines-------------
   * =====Weight and color of cables are hardcoded======================
   * @param cables Array of cables
   * @returns Array of polylines that were extracted from @param cables
   */
  private drawLVCablesOnMVTopology(cables: Array<Cable>): Array<L.polyline>{
    const polylinesOpenLV: Array<L.polyline> = new Array<L.polyline>();

    for(const cable of cables){
      if(cable.switchingState == "OPEN"){
        let dashArrayProperty = null;
        dashArrayProperty = "7,7";
        if(cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon){
          let coordinates = [];
          coordinates = [
            [cable.startNodeLat, cable.startNodeLon],
            [cable.endNodeLat, cable.endNodeLon]
          ];

          const polyline = L.polyline(coordinates, {
            color: '#0088CC',
            weight: 1,
            dashArray: dashArrayProperty
          }).on('click', (data) => {
            const modalRef = this.ngbModal.open(CableDetailsDialogComponent, {
              windowClass: 'my-class',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });
            (modalRef.componentInstance as CableDetailsDialogComponent).gridElementId = cable.gridElementId;
            (modalRef.componentInstance as CableDetailsDialogComponent).nodesMap = this.nodesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).cablesMap = this.cablesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioName = this.selectedScenarioName;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioId = this.selectedScenarioId;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenario = this.selectedScenario;

            modalRef.result.then((result) => {}, (reason) => {});
          });

          polylinesOpenLV.push(polyline);

          let isCableSinglePointed = false;

          if(this.enableCablesHighlighting){
            let awaitChecker: boolean = false;
            let timerHighlight: number = 0;
            let hoverTimeout: any;
            let nearestEndMarker;
            let nearestStartMarker;
            polyline.on('mouseover', () => {
              this.gridElementMarkers.forEach((marker) => {
                if(marker.options.icon.options.html.includes('statistics') && !isCableSinglePointed){
                  if(this.gridElementMarkers.indexOf(marker, 0) > -1){
                    this.gridElementMarkers.splice(this.gridElementMarkers.indexOf(marker, 0), 1);
                  }
                }
              });

              //We need to highlight then start the timer and if the timer hits some point we need to zoom it
              // When we start highlighting we need to set timer to 0

              polyline.setStyle({
                color: 'black',
                weight: 3,
                opacity: 1.0
              });
              let startLatLngs = polyline.getLatLngs()[0];
              let endLatLngs = polyline.getLatLngs()[polyline.getLatLngs().length - 1];
              nearestEndMarker = this.returnNearestMarker(startLatLngs, this.gridElementMarkers);
              nearestStartMarker = this.returnNearestMarker(endLatLngs, this.gridElementMarkers);
              console.log("Here is nearest Marker : ", nearestEndMarker, "     ", nearestStartMarker);
              if(nearestEndMarker == nearestStartMarker){
                isCableSinglePointed = true;
                this.saveSingleMarkerIcon(nearestStartMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }
              if(nearestEndMarker != nearestStartMarker){
                this.saveMarkerIcons(nearestStartMarker, nearestEndMarker);
                this.highlightMarkerOnMouseover(nearestEndMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }

              this.zoomingTimeoutHandler = setTimeout(() => {
                this.map.flyToBounds(polyline.getBounds(), {
                  padding: [220, 220],
                  duration: 1.5
                  // animate: false
                })
              }, this.zoomingAnimationTimeout)
            })


            polyline.on('mouseout', () => {
              // if(hoverTimeout){
              clearTimeout(this.zoomingTimeoutHandler);
              if(isCableSinglePointed){
                isCableSinglePointed = false;
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                this.endMarkerIcon = this.returnStartMarkerIcon();
              }
              if(this.startMarkerIcon != null && this.endMarkerIcon != null && !isCableSinglePointed){
                nearestEndMarker.setIcon(this.returnEndMarkerIcon());
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                isCableSinglePointed = false;
              }
              isCableSinglePointed = false;
              polyline.setStyle({
                // renderer: myRenderer,
                color: cable.color,
                weight: cable.weight,
                dashArrayProperty: dashArrayProperty
              })
              // }
            })
          }
        }
      }
      if(cable.switchingState != "OPEN"){
        if(cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon){
          let coordinates = [];
          // console.error("AGAIN");
          coordinates = [
            [cable.startNodeLat, cable.startNodeLon],
            [cable.endNodeLat, cable.endNodeLon]
          ];

          const polyline = L.polyline(coordinates, {
            // renderer: myRenderer,
            color: '#0088CC',
            weight: 1,
            // dashArray: dashArrayProperty
            // zIndex: 100000
          }).on('click', (data) => {
            const modalRef = this.ngbModal.open(CableDetailsDialogComponent, {
              windowClass: 'my-class',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });
            (modalRef.componentInstance as CableDetailsDialogComponent).gridElementId = cable.gridElementId;
            (modalRef.componentInstance as CableDetailsDialogComponent).nodesMap = this.nodesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).cablesMap = this.cablesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioName = this.selectedScenarioName;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioId = this.selectedScenarioId;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenario = this.selectedScenario;

            modalRef.result.then((result) => {}, (reason) => {});
          });

          polylinesOpenLV.push(polyline);

          let isCableSinglePointed = false;

          if(this.enableCablesHighlighting){
            let awaitChecker: boolean = false;
            let timerHighlight: number = 0;
            let hoverTimeout: any;
            let nearestEndMarker;
            let nearestStartMarker;
            polyline.on('mouseover', () => {
              this.gridElementMarkers.forEach((marker) => {
                if(marker.options.icon.options.html.includes('statistics') && !isCableSinglePointed){
                  if(this.gridElementMarkers.indexOf(marker, 0) > -1){
                    this.gridElementMarkers.splice(this.gridElementMarkers.indexOf(marker, 0), 1);
                  }
                }
              });

              //We need to highlight then start the timer and if the timer hits some point we need to zoom it
              // When we start highlighting we need to set timer to 0

              polyline.setStyle({
                color: 'black',
                weight: 3,
                opacity: 1.0
              });
              let startLatLngs = polyline.getLatLngs()[0];
              let endLatLngs = polyline.getLatLngs()[polyline.getLatLngs().length - 1];
              nearestEndMarker = this.returnNearestMarker(startLatLngs, this.gridElementMarkers);
              nearestStartMarker = this.returnNearestMarker(endLatLngs, this.gridElementMarkers);
              console.log("Here is nearest Marker : ", nearestEndMarker, "     ", nearestStartMarker);
              if(nearestEndMarker == nearestStartMarker){
                isCableSinglePointed = true;
                this.saveSingleMarkerIcon(nearestStartMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }
              if(nearestEndMarker != nearestStartMarker){
                this.saveMarkerIcons(nearestStartMarker, nearestEndMarker);
                this.highlightMarkerOnMouseover(nearestEndMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }

              this.zoomingTimeoutHandler = setTimeout(() => {
                this.map.flyToBounds(polyline.getBounds(), {
                  padding: [220, 220],
                  duration: 1.5
                  // animate: false
                })
              }, this.zoomingAnimationTimeout)
            })


            polyline.on('mouseout', () => {
              // if(hoverTimeout){
              clearTimeout(this.zoomingTimeoutHandler);
              if(isCableSinglePointed){
                isCableSinglePointed = false;
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                this.endMarkerIcon = this.returnStartMarkerIcon();
              }
              if(this.startMarkerIcon != null && this.endMarkerIcon != null && !isCableSinglePointed){
                nearestEndMarker.setIcon(this.returnEndMarkerIcon());
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                isCableSinglePointed = false;
              }
              isCableSinglePointed = false;

              polyline.setStyle({
                // renderer: myRenderer,
                color: cable.color,
                weight: cable.weight,
                // dashArrayProperty: dashArrayProperty
              })
              // }
            })
          }
        }
      }
    }

    return polylinesOpenLV;
  }

  private returnNearestMarker(endLatLng: L.LatLng, markers: L.Marker[]): L.Marker | null{
    let nearestMarker: L.Marker | null = null;
    let minDistance = Infinity;
    markers.forEach(marker => {
      const markerLatLng = marker.getLatLng();
      const distance = endLatLng.distanceTo(markerLatLng);
      if(distance < minDistance){
        minDistance = distance;
        nearestMarker = marker;
      }
    });
    // console.log("This markers looks like this: ", this.gridElementMarkers);
    // console.log("This nearest marker looks like this: ", nearestMarker);
    return nearestMarker;
  }

  private markerRules: MarkerType[] = [
    { key: 'lvsubstationbusbaronetrafo', enabled: () => this.isEnableLvSubstationBusBarOneTrafo },
    { key: 'mvsubstationbusbaronetrafo', enabled: () => this.isEnableMvSubstationBusBarOneTrafo },
    { key: 'mvsubstationbusbarwithouttrafo', enabled: () => this.isEnableMvSubstationBusBarWithoutTrafo },
    { key: 'mvstationonetrafo', enabled: () => this.isEnableMvStationOneTrafo },
    { key: 'mvstationwithouttrafo', enabled: () => this.isEnableMvStationWithoutTrafo },
    { key: 'mvstationmultipletrafo', enabled: () => this.isEnableMvStationMultipleTrafo },
    { key: 'customerconnectionbox', enabled: () => this.isEnableCustomerConnectionBox },
    { key: 'grid-node-statistics', enabled: () => this.isEnableStatistics },
    { key: 'grid-node-controllabledevice', enabled: () => this.isEnableControllableDevices },
    { key: 'sleeve', enabled: () => this.isEnableSleeve },
    { key: 'lvjunctionbox', enabled: () => this.isEnableLvJunctionBox },
    { key: 'generator', enabled: () => this.isEnableGenerator },
    { key: 'voltageregulator', enabled: () => this.isEnableVoltageRegulator }
  ]

  getMarkerType(marker: L.Marker){
    if(!marker) return null;

    const icon = marker.getIcon();
    const html = icon.options.html;

    if(!html) return null;
    for (const rule of this.markerRules){
      if (html.includes(rule.key) && !rule.enabled()) {
        this.setElementTypeVisibility(rule.key, rule.enabled());
      }
    }
  }

  private highlightMarkerOnMouseover(marker: L.Marker): void{

    // console.log("Marker before highlight: ", marker);
      if(!marker) return;
      // console.log("Here the marker: ", marker.options.icon);
      this.getMarkerType(marker);

      const iconOptions = marker.getIcon().options;
      const html = iconOptions.html;

      if(!html) return;

      const highlightIconMap = new Map<string, string>([
        ["transformer", "assets/images/transformer-icon-normal-highlight.svg"],
        ["ssb", "assets/images/ssb-icon-normal-highlight.svg"],
        ["sleeve", "assets/images/sleeve-icon-normal-highlight.svg"],
        ["junction-box", "assets/images/junction-box-icon-normal-highlight.svg"],
        ["customer-connection-box", "assets/images/customer-connection-box-icon-normal-highlight.svg"]
      ]);

      for(let [key, asset] of highlightIconMap.entries()){

        if(key == "customer-connection-box"){
          marker.setIcon(new L.Icon({
            iconUrl: asset,
            iconSize: [30, 41]
          }));
          break;
        }else if(html.includes(key)){
          marker.setIcon(new L.Icon({
            iconUrl: asset,
            iconSize: [50, 71]
          }));
          break;
        }
      }
  }

  private saveMarkerIcons(startMarker: L.Marker, endMarker: L.Marker){
    if(this.startMarkerIcon != null && this.endMarkerIcon != null){
      console.log("Start and End marker icons are not null, so we need to set them to null");
      this.startMarkerIcon = null;
      this.endMarkerIcon = null;
    }
    if(this.startMarkerIcon == null && this.endMarkerIcon == null){
      console.log("Start and End marker icons are null, so we need to set them");
      this.startMarkerIcon = startMarker.options.icon;
      this.endMarkerIcon = endMarker.options.icon;
    }
    console.log("THis log is from function: ", this.startMarkerIcon, " _ ", this.endMarkerIcon);
  }

  private saveSingleMarkerIcon(marker: L.Marker){
    if(this.startMarkerIcon != null){
      this.startMarkerIcon = null;
    }
    if(this.startMarkerIcon == null){
      this.startMarkerIcon = marker.options.icon;
    }
  }

  private returnStartMarkerIcon(): L.Marker{
    console.log("Return StartMarker function :", this.startMarkerIcon);
    return this.startMarkerIcon;
  }
  private returnEndMarkerIcon(): L.Marker{
    console.log("Return EndMarker function :", this.endMarkerIcon);
    return this.endMarkerIcon;
  }

  private drawGridElementsOnMap(gridElements: Array<GridElement>, showIds: boolean, showSubIds?: boolean): Array<L.marker> {
    let countNodeMarker = 0;
    let countStatisticsMarker = 0;
    let countLoadMarker = 0;
    let topologyLVIsShown = false;

    const markers: Array<L.marker> = new Array<L.marker>();
    let addedCount = 0;
    const total = gridElements.length;

    console.log("Here is the total markers that should be drawn: ", total);
    gridElements.forEach((gridElement: GridElement) => {

      const marker = this.mapService.buildGridNodeMarker(gridElement, this.showIds, showSubIds);
      addedCount++;
      /* --------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      --------------------------------------------- When Trafo icon is right-clicked shows the LV topology related to that trafo, -------------------------------------------------
      ---------------------------------------------- (Actually now it works only with one trafo, so even if you right -------------------------------------------------------------
      -------------------------------------- click on any trafo it will display the LV topology for the [MS_Station] Artificial 13 (in my case)) ----------------------------------
      -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      [[ NEED TO ASK ABOUT THE COLORIZATIONS because now the colors of the LV ]]           ----------------------------------------------------------------------------------------
      [[-- topology shown while MV trafo is clicked is different than actual -]]           ----------------------------------------------------------------------------------------
      [[-------------------- colorization on the LV topology -----------------]]           ----------------------------------------------------------------------------------------
      ---------------------------------------------------------------------------------------------------------------------------------------THE COMMENTED CODE SHOULD BE REMOVED*/



      try{
        marker.on('contextmenu', (e) =>{

          const loadingSpinner = `
            <div class="loading-spinner" style="text-align: center;">
              <i class="fas fa-spinner fa-spin" style="font-size: 20px;"></i>
              <p>Loading, please wait...</p>
            </div>
          `;

          let topologyType: string = JSON.parse(localStorage.getItem("gridType"));
          if(topologyType === "MV" && (gridElement.elementSubType == "MvStationOneTrafo" || gridElement.elementSubType == "MvStationMultipleTrafo")){
            if (!marker._popup) {
              marker.bindPopup(loadingSpinner ); // You can use dynamic content here
            }
            marker.openPopup();
            this.toggleLVTopologiesOnMV(gridElement.gridElementId, marker, gridElement);
          }
        });
      }catch(e){
        console.error("Context menu error:", e);
      }


      let controllable = false;



      //I-51_statistics
      //create marker for statistic layer
      if (gridElement.getPropertyValue("measurement_device_avaiable") == "true") {
        countStatisticsMarker++;
        const markerStatistics = this.mapService.buildGridNodeMarker2(gridElement, Condition.NORMAL);
        // const markerStatistics2 = this.mapService.buildGridNodeMarker3(gridElement, Condition.NORMAL);
        markerStatistics.on('click', (data) => {
          const modalRef = this.ngbModal.open(StatisticDialogComponentComponent,
            {
              size: 'lg',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });
          (modalRef.componentInstance as StatisticDialogComponentComponent).gridElementId = gridElement.gridElementId;
          (modalRef.componentInstance as StatisticDialogComponentComponent).elementType = gridElement.elementSubType;

          modalRef.result.then(
            (result) => {
            },
            (reason) => {
            }
          );
        });
        markers.push(markerStatistics);
        // markers.push(markerStatistics2);
      }

      //create marker for Loads of the grid planning scenario
      if (gridElement.getPropertyValue("load_on_scenario") == "yes") {
        countLoadMarker++;
        const markerscenario = this.mapService.buildGridNodeMarkerScenario(gridElement);
        console.log("Scenario: " + gridElement)
        markerscenario.on('click', (data) => {
          const modalRef = this.ngbModal.open(NodeDetailsDialogComponent,
            {
              size: 'lg',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });
          (modalRef.componentInstance as NodeDetailsDialogComponent).gridElementId = gridElement.gridElementId;
          (modalRef.componentInstance as NodeDetailsDialogComponent).elementType = gridElement.elementSubType;
          (modalRef.componentInstance as NodeDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
          (modalRef.componentInstance as NodeDetailsDialogComponent).selectedScenario = this.selectedScenario;

          modalRef.result.then(
            (result) => {
            },
            (reason) => {
            }
          );
        });
        markers.push(markerscenario);
      }


      if (marker) {
        countNodeMarker++;
        // console.log("Here is the marker that we should check: ", marker);
        console.log("Here is the gridElement that probably should be called? : ", gridElement);
        marker.on('click', (data) => {
          const modalRef = this.ngbModal.open(NodeDetailsDialogComponent,
            {
              windowClass: 'my-class',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });
          (modalRef.componentInstance as NodeDetailsDialogComponent).gridElementId = gridElement.gridElementId;
          (modalRef.componentInstance as NodeDetailsDialogComponent).elementType = gridElement.elementSubType;
          (modalRef.componentInstance as NodeDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
          (modalRef.componentInstance as NodeDetailsDialogComponent).selectedScenario = this.selectedScenario;
          (modalRef.componentInstance as NodeDetailsDialogComponent).jumpTopology = gridElement.getPropertyValue("jumpTopology");
          (modalRef.componentInstance as NodeDetailsDialogComponent).noResult = ("true" === gridElement.getPropertyValue("noResult"));

          modalRef.result.then(
            (result) => {
            },
            (reason) => {
            }
          );
        });
        marker.on('contextmenu', (data) => {

          let topologyType: string = JSON.parse(localStorage.getItem("gridType"));
          if(topologyType === "MV" && marker.options.title.includes('[SSB]')){
            if(this.mapLVFirstElementAndLVTopologyName.has(marker.options.title)){

              console.log("Title: " + marker.options.title);
              let lvTopologyId = this.mapLVFirstElementAndLVTopologyName.get(marker.options.title);
              let lvTopologies: string[] = [];
              let mvStationGid = this.mapLVTopologyNameAndMVTrafo.get(lvTopologyId);

              this.mapLVTopologyNameAndMVTrafo.forEach((value, key) => {
                console.log(`Key: ${key}, Value: ${value}`);

                if (value == mvStationGid) {
                  console.log("Remove also: " + key);
                  lvTopologies.push(key);
                }
              });

              for(let i=0; i<lvTopologies.length; i++){

                lvTopologyId = lvTopologies[i];
                console.log("TopologyID: " + lvTopologyId);
                console.log(this.mapLVTopologyNameAndMVTrafo);
                this.nodesMap.set(parseInt((this.mapLVTopologyNameAndMVTrafo.get(lvTopologyId).gridElementId).toString()), this.mapLVTopologyNameAndMVTrafo.get(lvTopologyId));

                this.mapLVTopologyNameAndGridElementsID.forEach((value, key) => {
                  if(key == lvTopologyId){
                    value.forEach((number)=>{
                      this.nodesMap.delete(parseInt(number.toString()));
                    })
                  }
                })

                this.mapLVTopologyNameAndGridElementsID.delete(lvTopologyId);
                this.mapLVFirstElementAndLVTopologyName.delete(marker.options.title);
                this.mapLVTopologyNameAndGridElements.delete(lvTopologyId);
                this.mapLVTopologyNameAndMVTrafo.delete(lvTopologyId);

                this.redrawNodesLayer(Array.from(this.nodesMap.values()));


                //Removing LV cables from map
                this.mapLVTopologyAndArrayOfCables.get(lvTopologyId).forEach((cable) => {
                  if(this.cables.indexOf(cable) !== -1){
                    this.cables.splice(this.cables.indexOf(cable), 1);
                    this.cablesGP.splice(this.cablesGP.indexOf(cable));
                  }
                });

                this.mapLVTopologyAndArrayOfCableIDs.get(lvTopologyId).forEach((value) => {
                  this.intermediateCablesMap.delete(value);
                  this.cablesMap.delete(value);
                  this.cableColorApps.delete(value);
                });


                this.mapLVTopologyAndArrayOfCables.delete(lvTopologyId);
                this.mapLVTopologyAndArrayOfCableIDs.delete(lvTopologyId);

             try {
                localStorage.setItem('cables', JSON.stringify(this.cables));
               } catch (e) {
                  console.error('Failed to save cables:', e);
               }
                this.saveCableColorApps();

                this.redrawCablesLayer();
          try {
                localStorage.setItem('gridElements', JSON.stringify(Array.from(this.nodesMap.values())));
          } catch (e) {
            console.error('Failed to save gridElements:', e);
          }
                this.getColoringForLvTopology();
              }
            }
          }
        })
        markers.push(marker);
      }

      if(addedCount === total && this.getConfiguredDisplay == true){
        this.getConfiguredDisplay = false;
        this.map.whenReady(() => {
          requestAnimationFrame(() => {

            if(!this.iconsAreDisplayedUsingUserConfig){
              this.toggleElementsBasedOnUserConfig();
              this.iconsAreDisplayedUsingUserConfig = true;
            }else{
              // console.log("After saving previous toggled states: ", this.previousToggledStates);
              this.restorePrevoiusToggledStates();
            }

            // console.log("this.isEnableLvSubstationBusBarOneTrafo ", this.isEnableLvSubstationBusBarOneTrafo );
            // console.log("this.isEnableMvSubstationBusBarOneTrafo", this.isEnableMvSubstationBusBarOneTrafo);
            // console.log("this.isEnableMvSubstationBusBarWithoutTrafo", this.isEnableMvSubstationBusBarWithoutTrafo);
            // console.log("this.isEnableMvStationOneTrafo", this.isEnableMvStationOneTrafo);
            // console.log("this.isEnableMvStationWithoutTrafo", this.isEnableMvStationWithoutTrafo);
            // console.log("this.isEnableMvStationMultipleTrafo", this.isEnableMvStationMultipleTrafo);
            // console.log("this.isEnableCustomerConnectionBox", this.isEnableCustomerConnectionBox);
            // console.log("this.isEnableStatistics", this.isEnableStatistics);
            // console.log("this.isEnableControllableDevices ", this.isEnableControllableDevices );
            // console.log("this.isEnableSleeve", this.isEnableSleeve);
            // console.log("this.isEnableLvJunctionBox", this.isEnableLvJunctionBox);
            // console.log("this.isEnableGenerator", this.isEnableGenerator);
          })
        });
      }
    });

    console.log("countNodeMarker = " + countNodeMarker)
    console.log("countStatisticsMarker = " + countStatisticsMarker)
    console.log("countLoadMarker = " + countLoadMarker)
    console.log("total_markers_size = " + markers.length)

    // this.map.eachLayer(function(layer){
    //   console.log("Here is the layers of the map before showing markers: ", layer.options.title);
    // })
    // console.log(markers)

    this.gridElementMarkers = markers;
    // this.gridElementMarkers.forEach((marker) => {
    //   if(marker.options.icon.options.html.includes('statistics')){
    //     if(this.gridElementMarkers.indexOf(marker, 0) > -1){
    //       this.gridElementMarkers.splice(this.gridElementMarkers.indexOf(marker, 0), 1);
    //     }
    //   }
    // })
    // console.log("Here is all markers from ", this.gridElementMarkers);

    return markers;
  }

  private loadGridElementsOnMap(map: L.map) {
    this.getGridElementsDetailsDone = false;
    try {
      if (this.date) {
        this.mapService.getGridElementsDetailsTimeDependant(this.date).subscribe((gridElements: Array<GridElement>) => {
          this.getGridElementsDetailsDone = true;
          gridElements.forEach((gridElement: GridElement) => {
            gridElement.condition = Condition.NORMAL;
            this.nodesMap.set(
              parseInt(gridElement.gridElementId.toString()),
              new GridElement(
                gridElement.gridElementId,
                gridElement.elementSubType,
                gridElement.properties,
                gridElement.condition
              ));
            this.nodesMapGP.set(
              parseInt(gridElement.gridElementId.toString()),
              new GridElement(
                gridElement.gridElementId,
                gridElement.elementSubType,
                gridElement.properties,
                gridElement.condition
              ));

          });
          localStorage.setItem('nodeMap', JSON.stringify(Array.from(this.nodesMap.values())));
          localStorage.setItem('nodeMapOriginal', JSON.stringify(Array.from(this.nodesMap.values())));

          const markers: Array<L.marker> = this.drawGridElementsOnMap(Array.from(this.nodesMap.values()), this.showIds);
          this.gridNodesLayer = L.layerGroup(markers);
          this.gridNodesLayer.addTo(map);
          try {
            localStorage.setItem('gridElements', JSON.stringify(gridElements));
          } catch (e) {
            console.error('Failed to save gridElements:', e);
          }
          localStorage.removeItem('gridColorApps');
          localStorage.removeItem('cables');
          this.initGridColors();
          this.loadCablesOnMap(this.map);
          this.checkEndAPIsandEnableTopologiesDropdown();
          //this.getApplicationsStatus();
        });
      } else {
        this.mapService.getGridElementsDetails().subscribe((gridElements: Array<GridElement>) => {
          let rootGridElement = localStorage.getItem("root");
          let rootGridElementId ;
          let gridType: string = JSON.parse(localStorage.getItem("gridType"));
          if(gridType!= "LV"){
            localStorage.removeItem("parentTopology");
          }
          if(rootGridElement){
              rootGridElementId = JSON.parse(rootGridElement).gridElementId;
          }

          this.getGridElementsDetailsDone = true;
          gridElements.forEach((gridElement: GridElement) => {
            if(gridType== "LV" && gridElement.gridElementId == rootGridElementId){
              let parentTopology = localStorage.getItem("parentTopology")
                if(parentTopology){
                      let prop = { "name": "jumpTopology", "value": parentTopology }
                      gridElement.properties.push(prop);
                }
            }
            gridElement.condition = Condition.NORMAL;
            this.nodesMap.set(
              parseInt(gridElement.gridElementId.toString()),
              new GridElement(
                gridElement.gridElementId,
                gridElement.elementSubType,
                gridElement.properties,
                gridElement.condition
              ));
            this.nodesMapGP.set(
              parseInt(gridElement.gridElementId.toString()),
              new GridElement(
                gridElement.gridElementId,
                gridElement.elementSubType,
                gridElement.properties,
                gridElement.condition
              ));
          });
          localStorage.setItem('nodeMap', JSON.stringify(Array.from(this.nodesMap.values())));
          localStorage.setItem('nodeMapOriginal', JSON.stringify(Array.from(this.nodesMap.values())));

          const markers: Array<L.marker> = this.drawGridElementsOnMap(Array.from(this.nodesMap.values()), this.showIds);
          this.gridNodesLayer = L.layerGroup(markers);
          this.gridNodesLayer.addTo(map);
          try {
             localStorage.setItem('gridElements', JSON.stringify(gridElements));
          } catch (e) {
             console.error('Failed to save gridElements:', e);
          }
          localStorage.removeItem('gridColorApps');
          localStorage.removeItem('cables');
          this.initGridColors();
          this.loadCablesOnMap(this.map);
          this.checkEndAPIsandEnableTopologiesDropdown();
          this.getConfiguredDisplay = true;
        });

      }
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * This method is used to show/hide icons after rendering them first time.
   * The icon condition is based on the user specified config (config.json).
   * It uses timeout of 2 second because without the timeout, the values are setted before rendering is finished
   */
  private toggleElementsBasedOnUserConfig(){

    if(this.iconsAreDisplayedUsingUserConfig) return;
    this.iconsAreDisplayedUsingUserConfig = true;
    const topologyConfig = this.configurationService.getConfiguration().TOPOLOGY;

    if(!topologyConfig) {
      return;
    }

    const elementsToToggle: Array<{shown: boolean; type: string }> = [
      { shown: topologyConfig.isCCBShown, type: 'customerconnectionbox' },
      { shown: topologyConfig.isSleeveShown, type: 'sleeve' },
      { shown: topologyConfig.isJunctionBoxShown, type: 'lvjunctionbox' },
      { shown: topologyConfig.isLvsubstationbusbaronetrafoShown, type: 'lvsubstationbusbaronetrafo' },
      { shown: topologyConfig.isMvsubstationbusbaronetrafoShown, type: 'mvsubstationbusbaronetrafo' },
      { shown: topologyConfig.isMvsubstationbusbarwithouttrafoShown, type: 'mvsubstationbusbarwithouttrafo' },
      { shown: topologyConfig.isMvstationonetrafoShown, type: 'mvstationonetrafo' },
      { shown: topologyConfig.isMvstationwithouttrafoShown, type: 'mvstationwithouttrafo' },
      { shown: topologyConfig.isMvstationmultipletrafoShown, type: 'mvstationmultipletrafo' },
      { shown: topologyConfig.isVoltageRegulatorShown, type: 'voltageregulator' }
    ];

    elementsToToggle.forEach(item => {
      this.setElementTypeVisibility(item.type, item.shown);
    })
    // console.log("State of elements after toggling based on user config: ", {
    //   isEnableLvSubstationBusBarOneTrafo: this.isEnableLvSubstationBusBarOneTrafo,
    //   isEnableMvSubstationBusBarOneTrafo: this.isEnableMvSubstationBusBarOneTrafo,
    //   isEnableMvSubstationBusBarWithoutTrafo: this.isEnableMvSubstationBusBarWithoutTrafo,
    //   isEnableMvStationOneTrafo: this.isEnableMvStationOneTrafo,
    //   isEnableMvStationWithoutTrafo: this.isEnableMvStationWithoutTrafo,
    //   isEnableMvStationMultipleTrafo: this.isEnableMvStationMultipleTrafo,
    //   isEnableCustomerConnectionBox: this.isEnableCustomerConnectionBox,
    //   isEnableSleeve: this.isEnableSleeve,
    //   isEnableLvJunctionBox: this.isEnableLvJunctionBox,
    //   isEnableGenerator: this.isEnableGenerator,
    // })
  }

  private drawCablesOnMap(map: L.map, cables: Array<Cable>): void {
    const polylines: Array<L.polyline> = new Array<L.polyline>();
    const polylinesOpen: Array<L.polyline> = new Array<L.polyline>();
    const markerSwitches: Array<L.marker> = new Array<L.marker>();

    const myRenderer = L.canvas({ padding: 0.5, tolerance: 10 });
    console.log("onMap");
    console.log(cables);
    for (const cable of cables) {
      //if cable is open
      if (cable.switchingState == "OPEN") {
        let dashArrayProperty = null;
        console.log("OPEN ");
        //console.log(cable);
        dashArrayProperty = "7,7"
        if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {
          let coordinates = [];
          if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon && (!cable.hasOwnProperty('coordinates') || cable.coordinates.trim() == "[]" || cable.coordinates == null || this.multipleCoordinatePointsForCablesIsShown == false)) {
            coordinates = [
              [cable.startNodeLat, cable.startNodeLon],
              [cable.endNodeLat, cable.endNodeLon]
            ];
          }

          else if(cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon && (cable.hasOwnProperty('coordinates') && cable.coordinates.trim() != "[]" && cable.coordinates != null) && this.multipleCoordinatePointsForCablesIsShown == true){
            coordinates = [[cable.startNodeLat, cable.startNodeLon]]
            let additionalCoordinates = JSON.parse(cable.coordinates);
            additionalCoordinates.forEach((obj, index) => {
              let stepByStepCoordinates = [null, null];
              for(const key in obj){
                if(obj.hasOwnProperty(key)){
                  if(key.includes("X")){
                    stepByStepCoordinates[0] = obj[key];
                  }
                  if(key.includes("Y")){
                    stepByStepCoordinates[1] = obj[key];
                  }
                }
              }
              coordinates.push(stepByStepCoordinates);
            });
            coordinates.push([cable.endNodeLat, cable.endNodeLon]);
          }
          let middleLatitude;
          let middleLongitude;
          let markerSwitch;

          //get middle coordinates of a cable
          if(cable.coordinates == null  || cable.coordinates.trim() == "[]"){
            // console.log("Here is the cable: ", cable);
            let sourceLatitudeRadiant = cable.startNodeLat * (Math.PI / 180);
            let destinationLatitudeRadiant = cable.endNodeLat * (Math.PI / 180);
            let middleLatitudeRadiant = Math.atan(Math.sinh(Math.log(Math.sqrt(
              (Math.tan(destinationLatitudeRadiant) + 1 / Math.cos(destinationLatitudeRadiant)) * (Math.tan(sourceLatitudeRadiant) + 1 / Math.cos(sourceLatitudeRadiant))))));
            middleLatitude = middleLatitudeRadiant * (180 / Math.PI)
            middleLongitude = (cable.startNodeLon + cable.endNodeLon) / 2;

            markerSwitch = this.mapService.buildSwitchMarker(middleLatitude, middleLongitude);
          }else{
            let additionalCoordinates = JSON.parse(cable.coordinates);

            const normalizedCoordinates: Coordinate[] = additionalCoordinates.map((obj: Record<string, number>) => {
              const keyX = Object.keys(obj).find(k => k.startsWith('X'))!;
              const keyY = Object.keys(obj).find(k => k.startsWith('Y'))!;

              return { X: obj[keyX], Y: obj[keyY] };
            });
            const midIndex = Math.floor(normalizedCoordinates.length / 2);
            console.log("normalizedCoordinates.length: ", normalizedCoordinates);

            if(normalizedCoordinates.length % 2 == 0){
              let sourceLatitudeRadiant = normalizedCoordinates[midIndex - 1].Y * (Math.PI / 180);
              let destinationLatitudeRadiant = normalizedCoordinates[midIndex].Y * (Math.PI / 180);
              let middleLatitudeRadiant = Math.atan(
                Math.sinh(
                  Math.log(
                    Math.sqrt(
                      (Math.tan(destinationLatitudeRadiant) + 1 / Math.cos(destinationLatitudeRadiant)) * (Math.tan(sourceLatitudeRadiant) + 1 / Math.cos(sourceLatitudeRadiant))
                    )
                  )
                )
              );
              middleLatitude = middleLatitudeRadiant * (180 / Math.PI) + 0.00003;
              middleLongitude = (normalizedCoordinates[midIndex - 1].X + normalizedCoordinates[midIndex].X) / 2 + 0.00003;
              // console.log("Here is middleLatitude: ", middleLatitude, " _ middleLongitude: ", middleLongitude);

            }else{
              let sourceLatitudeRadiant = normalizedCoordinates[midIndex].Y * (Math.PI / 180);
              let destinationLatitudeRadiant = normalizedCoordinates[midIndex].Y * (Math.PI / 180);

              let middleLatitudeRadiant = Math.atan(Math.sinh(Math.log(Math.sqrt(
                (Math.tan(destinationLatitudeRadiant) + 1 / Math.cos(destinationLatitudeRadiant)) * (Math.tan(sourceLatitudeRadiant) + 1 / Math.cos(sourceLatitudeRadiant))
              ))))

              middleLatitude = middleLatitudeRadiant * (180 / Math.PI);
              middleLongitude = normalizedCoordinates[midIndex].X;
            }


            markerSwitch = this.mapService.buildSwitchMarker(middleLongitude, middleLatitude);
          }

          //create a marker for switch icon
          // console.log("Here is the middleCoordinates of cable: ", middleLatitude, " _ ", middleLongitude);
          if (markerSwitch) {
            markerSwitches.push(markerSwitch);
          }

          const polyline = L.polyline(coordinates, {
            renderer: myRenderer,
            color: cable.color,
            weight: cable.weight,
            dashArray: dashArrayProperty
          }).on('click', (data) => {
            // Open Modal
            const modalRef = this.ngbModal.open(CableDetailsDialogComponent,
              {
                windowClass: 'my-class',
                ariaLabelledBy: 'modal-basic-title',
                centered: false,
                scrollable: true,
                backdrop: 'static'
              });
            (modalRef.componentInstance as CableDetailsDialogComponent).gridElementId = cable.gridElementId;
            (modalRef.componentInstance as CableDetailsDialogComponent).nodesMap = this.nodesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).cablesMap = this.cablesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioName = this.selectedScenarioName;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioId = this.selectedScenarioId;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenario = this.selectedScenario;

            modalRef.result.then(
              (result) => {
              },
              (reason) => {
              }
            );
          });

          polylinesOpen.push(polyline);

          let isCableSinglePointed = false;

          if(this.enableCablesHighlighting){
            let awaitChecker: boolean = false;
            let hoverTimeout: any;
            let nearestEndMarker;
            let nearestStartMarker;
            polyline.on('mouseover', () => {
              this.gridElementMarkers.forEach((marker) => {
                // console.log("Here is the marker: " + marker );
                  if(marker.options.icon.options.html.includes('statistics') && !isCableSinglePointed){
                    if(this.gridElementMarkers.indexOf(marker, 0) > -1){
                      this.gridElementMarkers.splice(this.gridElementMarkers.indexOf(marker, 0), 1);
                    }
                  }
                });

              polyline.setStyle({
                color: 'black',
                weight: 3,
                opacity: 1.0
              })
              let startLatLngs = polyline.getLatLngs()[0];
              let endLatLngs = polyline.getLatLngs()[polyline.getLatLngs().length - 1];
              nearestEndMarker = this.returnNearestMarker(startLatLngs, this.gridElementMarkers);
              nearestStartMarker = this.returnNearestMarker(endLatLngs, this.gridElementMarkers);
              // console.log("Here is nearest Marker : ", nearestEndMarker, "     ", nearestStartMarker);
              if(nearestEndMarker == nearestStartMarker){
                isCableSinglePointed = true;
                this.saveSingleMarkerIcon(nearestStartMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }
              if(nearestEndMarker != nearestStartMarker){
                this.saveMarkerIcons(nearestStartMarker, nearestEndMarker);
                // console.log("ICONS OF MARKERS : ", iconOfEndMarker, "     ", iconOfStartMarker);
                this.highlightMarkerOnMouseover(nearestEndMarker);
                this.highlightMarkerOnMouseover(nearestStartMarker);
              }

              this.zoomingTimeoutHandler = setTimeout(() => {
                this.map.flyToBounds(polyline.getBounds(), {
                  padding: [220, 220],
                  duration: 1.5
                  // animate: false
                })
              }, this.zoomingAnimationTimeout)
            })


            polyline.on('mouseout', () => {
              clearTimeout(this.zoomingTimeoutHandler);

              if(isCableSinglePointed){
                isCableSinglePointed = false;
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                this.endMarkerIcon = this.returnStartMarkerIcon();
              }
              if(this.startMarkerIcon != null && this.endMarkerIcon != null && !isCableSinglePointed){
                nearestEndMarker.setIcon(this.returnEndMarkerIcon());
                nearestStartMarker.setIcon(this.returnStartMarkerIcon());
                isCableSinglePointed = false;
              }
              isCableSinglePointed = false;
              polyline.setStyle({
                renderer: myRenderer,
                color: cable.color,
                weight: cable.weight,
                dashArrayProperty: dashArrayProperty
              })

              // Returns IDs if they were shown before
              const nodes: Array<Element> = Array.from(document.getElementsByClassName("marker-label"));
              nodes.forEach((element: Element) => {
                if(this.gridElemenetIdsShowHide && element.classList.contains('node-id-hidden')){
                  element.classList.remove('node-id-hidden');
                }
              })
            })
          }
        }
      }

      //if cable is not open
      if (cable.switchingState != "OPEN") {
        let dashArrayProperty = null;
        if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {
          console.log("this.multipleCoordinatePointsForCablesIsShown: ", this.multipleCoordinatePointsForCablesIsShown);
          let coordinates = [];
          if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon && (!cable.hasOwnProperty('coordinates') || cable.coordinates.trim() == "[]" || cable.coordinates == null || this.multipleCoordinatePointsForCablesIsShown == false)) {
            coordinates = [
              [cable.startNodeLat, cable.startNodeLon],
              [cable.endNodeLat, cable.endNodeLon]
            ];
          }

          else if(cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon && (cable.hasOwnProperty('coordinates') && cable.coordinates.trim() != "[]" && cable.coordinates != null) && this.multipleCoordinatePointsForCablesIsShown == true){
            coordinates = [[cable.startNodeLat, cable.startNodeLon]]
            let additionalCoordinates = JSON.parse(cable.coordinates);
            additionalCoordinates.forEach((obj, index) => {
              let stepByStepCoordinates = [null, null];
              for(const key in obj){
                if(obj.hasOwnProperty(key)){
                  if(key.includes("X")){
                    stepByStepCoordinates[0] = obj[key];
                  }
                  if(key.includes("Y")){
                    stepByStepCoordinates[1] = obj[key];
                  }
                }
              }
              coordinates.push(stepByStepCoordinates);
            });
            coordinates.push([cable.endNodeLat, cable.endNodeLon]);
          }

          const polyline = L.polyline(coordinates, {
            renderer: myRenderer,
            color: cable.color ? cable.color : Condition.NORMAL,
            weight: cable.weight,
            dashArray: dashArrayProperty
          }).on('click', (data) => {
            // Open Modal
            const modalRef = this.ngbModal.open(CableDetailsDialogComponent,
              {
                windowClass: 'my-class',
                ariaLabelledBy: 'modal-basic-title',
                centered: false,
                scrollable: true,
                backdrop: 'static'
              });
            (modalRef.componentInstance as CableDetailsDialogComponent).gridElementId = cable.gridElementId;
            (modalRef.componentInstance as CableDetailsDialogComponent).nodesMap = this.nodesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).cablesMap = this.cablesMap;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioName = this.selectedScenarioName;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenarioId = this.selectedScenarioId;
            (modalRef.componentInstance as CableDetailsDialogComponent).selectedScenario = this.selectedScenario;
            (modalRef.componentInstance as CableDetailsDialogComponent).jumpTopology = this.getPropertyValue("jumpTopology",cable.properties);
            modalRef.result.then(
              (result) => {
              },
              (reason) => {
              }
            );
          });

          polylines.push(polyline);
          let isCableSinglePointed = false;

          // polylines.push(polylineTesting);
          if(this.enableCablesHighlighting){
            let nearestEndMarker;
            let nearestStartMarker;
            polyline.on('mouseover', () => {
              this.gridElementMarkers.forEach((marker: L.marker) => {
                if(marker.options.icon.options.html.includes('statistics') && !isCableSinglePointed){
                  if(this.gridElementMarkers.indexOf(marker, 0) > -1){
                    this.gridElementMarkers.splice(this.gridElementMarkers.indexOf(marker, 0), 1);
                  }
                }
              });

              //We need to highlight then start the timer and if the timer hits some point we need to zoom it
              // When we start highlighting we need to set timer to 0
              let startLatLngs = polyline.getLatLngs()[0];
              let endLatLngs = polyline.getLatLngs()[polyline.getLatLngs().length - 1];

              nearestEndMarker = this.returnNearestMarker(startLatLngs, this.gridElementMarkers);
              nearestStartMarker = this.returnNearestMarker(endLatLngs, this.gridElementMarkers);
              console.log("Here is nearest Marker : ", nearestEndMarker, "     ", nearestStartMarker);

              if(JSON.parse(localStorage.getItem("gridType")) === "LV"){
                // Here we are trying to find all the cables that are connected to the Junction Box that is connected to the SSB
                // The cable that lies between the SSB and Junction box is also highlighted
                let nextMarkerFromSSB = null;

                if((nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[JunctionBox]")) || (nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[Sleeve]"))){
                  nextMarkerFromSSB = nearestStartMarker;
                }else if((nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[JunctionBox]")) || (nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[Sleeve]"))){
                  nextMarkerFromSSB = nearestEndMarker;
                }

                if(nextMarkerFromSSB){
                  this.highlightedPolylines = new Array<L.polyline>();
                  const visitedMarkers = new Set<L.marker>();

                  this.highlightCablesFromJunctionBox(nextMarkerFromSSB, visitedMarkers, polylines, "LV");
                }else{
                  this.highlightedPolylines = new Array<L.polyline>();
                  this.highlightedMarkers.clear();
                  this.originalMarkerIcons.clear();
                  this.originalPolylinesStyles.clear();

                  const pathToSSB = this.findPathToSSB(nearestStartMarker, nearestEndMarker, polylines);
                  // console.log("Path to SSB: ", pathToSSB);
                  if(!this.originalPolylinesStyles.has(polyline)){
                    this.originalPolylinesStyles.set(polyline, {
                      color: polyline.options.color,
                      weight: polyline.options.weight,
                      dashArrayProperty: polyline.options.dashArray,
                      renderer: polyline.options.renderer
                    });
                  }
                  polyline.setStyle({
                    color: 'black',
                    weight: 3,
                    opacity: 1.0
                  });
                  this.highlightedPolylines.push(polyline);

                  [nearestStartMarker, nearestEndMarker].forEach((marker) => {
                    if(marker && !this.originalMarkerIcons.has(marker)){
                      this.originalMarkerIcons.set(marker, marker.getIcon());
                    }
                    this.highlightMarkerOnMouseover(marker);
                    this.highlightedMarkers.add(marker);
                  });

                  pathToSSB.forEach(({ polyline: pl, markers}) => {
                    if(!this.originalPolylinesStyles.has(pl)){
                      this.originalPolylinesStyles.set(pl, {
                        color: pl.options.color,
                        weight: pl.options.weight,
                        dashArrayProperty: pl.options.dashArray,
                        renderer: pl.options.renderer
                      });
                    }
                    pl.setStyle({
                      color: 'black',
                      weight: 3,
                      opacity: 1.0
                    });
                    this.highlightedPolylines.push(pl);

                    markers.forEach((marker) => {
                      if(marker && !this.originalMarkerIcons.has(marker)){
                        this.originalMarkerIcons.set(marker, marker.getIcon());
                      }
                      this.highlightMarkerOnMouseover(marker);
                      this.highlightedMarkers.add(marker);
                    })
                  })
                }
              }


              if(JSON.parse(localStorage.getItem("gridType")) === "MV"){
                let msStationMarker = null;

                console.log("Nearest Start Marker: ", nearestStartMarker);
                console.log("Nearest End Marker: ", nearestEndMarker);

                if((nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[MS_Station]")) ||
                  (nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[Sleeve]")) ||
                  (nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[JunctionBox]")) ||
                  (nearestEndMarker.options.label.message.includes("[SSB]") && nearestStartMarker.options.label.message.includes("[CustomerConnectionBox]"))){
                  msStationMarker = nearestStartMarker;
                }else if((nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[MS_Station]")) ||
                  (nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[Sleeve]")) ||
                  (nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[JunctionBox]")) ||
                  (nearestStartMarker.options.label.message.includes("[SSB]") && nearestEndMarker.options.label.message.includes("[CustomerConnectionBox]"))){
                  msStationMarker = nearestEndMarker;
                }

                if(msStationMarker){
                  this.highlightedPolylines = new Array<L.polyline>();
                  const visitedMarkers = new Set<L.marker>();

                  this.highlightCablesFromJunctionBox(msStationMarker, visitedMarkers, polylines, "MV");
                }else{
                  this.highlightedPolylines = new Array<L.polyline>();
                  this.highlightedMarkers.clear();
                  this.originalMarkerIcons.clear();
                  this.originalPolylinesStyles.clear();

                  const pathToSSB = this.findPathToSSB(nearestStartMarker, nearestEndMarker, polylines);
                  // console.log("Path to SSB: ", pathToSSB);
                  if(!this.originalPolylinesStyles.has(polyline)){
                    this.originalPolylinesStyles.set(polyline, {
                      color: polyline.options.color,
                      weight: polyline.options.weight,
                      dashArrayProperty: polyline.options.dashArray,
                      renderer: polyline.options.renderer
                    });
                  }

                  polyline.setStyle({
                    color: 'black',
                    weight: 3,
                    opacity: 1.0
                  });

                  this.highlightedPolylines.push(polyline);

                  [nearestStartMarker, nearestEndMarker].forEach((marker) => {
                    if(marker && !this.originalMarkerIcons.has(marker)){
                      this.originalMarkerIcons.set(marker, marker.getIcon());
                    }

                    this.highlightMarkerOnMouseover(marker);
                    this.highlightedMarkers.add(marker);
                  });

                  pathToSSB.forEach(({ polyline: pl, markers}) => {
                    if(!this.originalPolylinesStyles.has(pl)){
                      this.originalPolylinesStyles.set(pl, {
                        color: pl.options.color,
                        weight: pl.options.weight,
                        dashArrayProperty: pl.options.dashArray,
                        renderer: pl.options.renderer
                      });
                    }
                    pl.setStyle({
                      color: 'black',
                      weight: 3,
                      opacity: 1.0
                    });
                    this.highlightedPolylines.push(pl);

                    markers.forEach((marker) => {
                      if(marker && !this.originalMarkerIcons.has(marker)){
                        this.originalMarkerIcons.set(marker, marker.getIcon());
                      }
                      this.highlightMarkerOnMouseover(marker);
                      this.highlightedMarkers.add(marker);
                    });
                  });
                }
              }

              if(nearestEndMarker == nearestStartMarker){
                isCableSinglePointed = true;
                this.saveSingleMarkerIcon(nearestStartMarker);
                if (nearestStartMarker && !this.highlightedMarkers.has(nearestStartMarker)) {
                  if (!this.originalMarkerIcons.has(nearestStartMarker)) {
                    this.originalMarkerIcons.set(nearestStartMarker, nearestStartMarker.getIcon());
                  }
                  this.highlightMarkerOnMouseover(nearestStartMarker);
                  this.highlightedMarkers.add(nearestStartMarker);
                }
              }
              if(nearestEndMarker != nearestStartMarker){
                this.saveMarkerIcons(nearestStartMarker, nearestEndMarker);
                [nearestEndMarker, nearestStartMarker].forEach((marker) => {
                  if(marker && !this.originalMarkerIcons.has(marker)){
                    this.originalMarkerIcons.set(marker, marker.getIcon());
                  }
                  this.highlightMarkerOnMouseover(marker);
                  this.highlightedMarkers.add(marker);
                });
              }

              if(this.cableZoomingAnimationEnabled){
                this.zoomingTimeoutHandler = setTimeout(() => {
                  this.map.flyToBounds(polyline.getBounds(), {
                    padding: [220, 220],
                    duration: 1.5
                    // animate: false
                  })
                }, this.zoomingAnimationTimeout)
              }

            });


              polyline.on('mouseout', () => {

                if (this.highlightedPolylines && this.highlightedPolylines.length > 0) {
                  this.highlightedPolylines.forEach((pl: any) => {
                    const originalStyle = this.originalPolylinesStyles.get(pl);
                    if (originalStyle){
                      pl.setStyle({
                        color: originalStyle.color,
                        weight: originalStyle.weight,
                        dashArray: originalStyle.dashArrayProperty,
                        renderer: originalStyle.renderer
                      })
                    }
                  });

                  this.highlightedMarkers.forEach((marker: L.marker) => {
                    const originalIcon = this.originalMarkerIcons.get(marker);
                    if(originalIcon){
                      marker.setIcon(originalIcon);
                    }
                  });

                  this.highlightedMarkers.clear();
                  this.originalMarkerIcons.clear();
                  this.originalPolylinesStyles.clear();
                  this.highlightedPolylines = [];
                }

                clearTimeout(this.zoomingTimeoutHandler);

                isCableSinglePointed = false;
                polyline.setStyle({
                  renderer: myRenderer,
                  color: cable.color,
                  weight: cable.weight,
                  dashArrayProperty: dashArrayProperty
                });

                  // Returns IDs if they were shown before
                  const nodes: Array<Element> = Array.from(document.getElementsByClassName("marker-label"));
                  nodes.forEach((element: Element) => {
                    if(this.gridElemenetIdsShowHide && element.classList.contains('node-id-hidden')){
                      element.classList.remove('node-id-hidden');
                    }
                  })

              });
          }
        }
      }
    }


    // this.map.removeLayer(this.cablesLayer);
    this.cablesLayerOpen = L.layerGroup(polylinesOpen);
    if (this.cablesLayerOpen) {
      this.cablesLayerOpen.addTo(map);

    }

    this.cablesLayer = L.layerGroup(polylines);
    if (this.cablesLayer) {
      this.cablesLayer.addTo(map);

    }

    console.log("Switches: " + markerSwitches)
    console.log("Layer: " + this.switchLayer)
    let hasSwitchLayer: boolean; // = this.map.hasLayer(this.switchLayer);

    if (this.switchLayer == undefined)
      hasSwitchLayer = false;
    else
      hasSwitchLayer = this.map.hasLayer(this.switchLayer);

    console.log("Has switches: " + hasSwitchLayer);
    if (hasSwitchLayer) {
      this.map.removeLayer(this.switchLayer);
    } else {
      this.switchLayer = L.layerGroup(markerSwitches);
      this.switchLayer.addTo(map);
    }

    /*
    this.switchLayer = L.layerGroup(markerSwitches);

    if (this.switchLayer) {
      this.switchLayer.addTo(map);
    }*/
  }

  /**
   * This function iterates over all the polylines and highlights the cables that are connected to the junction box until the end
   */
  private highlightCablesFromJunctionBox(marker: L.marker, visitedMarkers: Set<L.marker>, polylines: Array<L.polyline>, topologyType: string){
    if(visitedMarkers.has(marker)) return;

    visitedMarkers.add(marker);

    polylines.forEach((polyline: L.polyline) => {
      const latlngs = polyline.getLatLngs();
      const m1 = this.returnNearestMarker(latlngs[0], this.gridElementMarkers);
      const m2 = this.returnNearestMarker(latlngs[latlngs.length - 1], this.gridElementMarkers);

      const isConnected = (m1 === marker || m2 === marker);
      const otherMarker = (m1 === marker) ? m2 : m1;

      if(isConnected){
        if(!this.originalPolylinesStyles.has(polyline)){
          this.originalPolylinesStyles.set(polyline, {
            color: polyline.options.color,
            weight: polyline.options.weight,
            dashArrayProperty: polyline.options.dashArray,
            renderer: polyline.options.renderer
          });
        }

        polyline.setStyle({
          color: 'black',
          weight: 3,
          opacity: 1.0
        });

        this.highlightedPolylines.push(polyline);

        [m1, m2].forEach((marker) => {
          if(marker && !this.originalMarkerIcons.has(marker)){
            this.originalMarkerIcons.set(marker, marker.getIcon());
          }

          this.highlightMarkerOnMouseover(marker);
          this.highlightedMarkers.add(marker);
        });

        if(topologyType === "LV"){
          if(otherMarker.options.label.message.includes("[JunctionBox]") || otherMarker.options.label.message.includes("[Sleeve]") || otherMarker.options.label.message.includes("[CustomerConnectionBox]")){
            this.highlightCablesFromJunctionBox(otherMarker, visitedMarkers, polylines, "LV");
          }
        }else if(topologyType === "MV"){
          if(otherMarker.options.label.message.includes("[MS_Station]") || otherMarker.options.label.message.includes("[Sleeve]") || otherMarker.options.label.message.includes("[JunctionBox]") || otherMarker.options.label.message.includes("[CustomerConnectionBox]")){
            this.highlightCablesFromJunctionBox(otherMarker, visitedMarkers, polylines, "MV");
          }
        }
      }
    })

    // console.log("Visited markers in highlightCablesFromJunctionBox: ", visitedMarkers);
  }

  private findPathToSSB(startMarker: L.marker, endMarker: L.marker, polylines: Array<L.polyline>): Array<{polyline: L.polyline, markers: L.marker[]}>{

    //if the marker on the end or start of polyline is ssb then we are just returning empty array, no need to iterate over the graph
    if(startMarker.options.label.message.includes("[SSB]") || endMarker.options.label.message.includes("[SSB]")){
      return [];
    }

    const graph = new Map<L.marker, Array<{neighbor: L.marker, polyline: L.polyline}>>();

    polylines.forEach((pl) => {
      const latlngs = pl.getLatLngs();
      const m1 = this.returnNearestMarker(latlngs[0], this.gridElementMarkers);
      const m2 = this.returnNearestMarker(latlngs[latlngs.length - 1], this.gridElementMarkers);

      if(!graph.has(m1)){
        graph.set(m1, []);
      }
      if(!graph.has(m2)){
        graph.set(m2, []);
      }

      graph.get(m1).push({neighbor: m2, polyline: pl});
      graph.get(m2).push({neighbor: m1, polyline: pl});
    });

    const queue: Array<{marker: L.marker, path: Array<{polyline: L.polyline, markers: L.marker[]}>}> = [];
    const visited = new Set<L.marker>();

    queue.push({marker: startMarker, path: []});
    queue.push({marker: endMarker, path: []});
    visited.add(startMarker);
    visited.add(endMarker);

    while(queue.length > 0){
      // console.log("Queue length: ", queue.length);
      // console.log("Visited markers: ", visited.size);
      const {marker, path} = queue.shift();

      if(marker.options.label.message.includes("[SSB]")){
        return path;
      }

      const neighbors = graph.get(marker) || [];
      for(const {neighbor, polyline} of neighbors){
        if(!visited.has(neighbor)){
          visited.add(neighbor);
          const newPath = [...path, {polyline: polyline, markers: [marker, neighbor]}];
          queue.push({marker: neighbor, path: newPath});
        }
      }
    }

    return []; // no path found
  }

  mouseEntered(scenarioName: string) {
    console.log("this.planningTrafoDtos", this.planningTrafoDtos);
    // this.isHovered = true;
    this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
    this.onSelectScenario(scenarioName);
  }

  private loadCablesOnMap(map: L.map) {
    const cablesJson: string = localStorage.getItem('cables');
    console.log("loadCablesOnMap -> cablesJson: ");
    console.log(cablesJson);

    if (cablesJson) {
      this.cables = JSON.parse(cablesJson);

      if (this.cables == null) {
        this.cables = new Array();
      }

      if (this.cables.length == 0) {


        if (this.date) {

          this.mapService.getCablesAndCoordinatesTimeDependant(this.date).subscribe((cables: Array<Cable>) => {

            this.getCablesAndCoordinatesDone = true;

            this.cables = cables;
            this.cablesGP = cables;
        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
         } catch (e) {
             console.error('Failed to save cables:', e);
         }
            this.cables.forEach((cable: Cable) => {
              this.cablesMap.set(
                parseInt(cable.gridElementId.toString()),
                cable
              );
            });

            this.cablesGP.forEach((cable: Cable) => {
              this.cablesMapGP.set(
                parseInt(cable.gridElementId.toString()),
                cable
              );
            });
            this.cables = this.setCableColors(cables);
            this.cables = this.cables.map((cable: Cable) => {
              // cable.color = Config.CONDITION_COLOR_NORMAL;
              cable.weight = 1;
              return cable;
            });

            this.cablesGP = this.setCableColors(cables);
            this.cablesGP = this.cablesGP.map((cable: Cable) => {
              // cable.color = Config.CONDITION_COLOR_NORMAL;
              cable.weight = 1;
              return cable;
            });

            this.drawCablesOnMap(map, this.cables);
            this.getApplicationsStatus(this.topology.topologyId);
            this.checkEndAPIsandEnableTopologiesDropdown();

          });
        }
        else {


          this.mapService.getCablesAndCoordinates().subscribe((cables: Array<Cable>) => {

            this.getCablesAndCoordinatesDone = true;

            this.cables = cables;
            this.cablesGP = cables;
       //     localStorage.setItem('cables', JSON.stringify(cables));

            this.cables.forEach((cable: Cable) => {
              this.cablesMap.set(
                parseInt(cable.gridElementId.toString()),
                cable
              );
            });
            this.cables = this.setCableColors(cables);
            this.cables = this.cables.map((cable: Cable) => {
              // cable.color = Config.CONDITION_COLOR_NORMAL;
              cable.weight = 1;
              return cable;
            });


            this.cablesGP.forEach((cable: Cable) => {
              this.cablesMapGP.set(
                parseInt(cable.gridElementId.toString()),
                cable
              );
            });
            this.cablesGP = this.setCableColors(cables);
            this.cablesGP = this.cables.map((cable: Cable) => {
              // cable.color = Config.CONDITION_COLOR_NORMAL;
              cable.weight = 1;
              return cable;
            });

            this.drawCablesOnMap(map, this.cables);
            this.getApplicationsStatus(this.topology.topologyId);
            this.checkEndAPIsandEnableTopologiesDropdown();

          });
        }
      }

      this.getCablesAndCoordinatesDone = true;

      this.cables.forEach((cable: Cable) => {
        // cable.condition = Condition.NORMAL;
        this.cablesMap.set(
          parseInt(cable.gridElementId.toString()),
          cable
        );
      });

      this.cablesGP.forEach((cable: Cable) => {
        // cable.condition = Condition.NORMAL;
        this.cablesMapGP.set(
          parseInt(cable.gridElementId.toString()),
          cable
        );
      });


      this.cablesGP = this.setCableColors(this.cablesGP);
      this.cablesGP = this.cablesGP.map((cable: Cable) => {
        // if (!cable.color) {
        //   cable.color = Config.CONDITION_COLOR_NORMAL;
        // }
        cable.weight = 1;
        return cable;
      });

      this.checkEndAPIsandEnableTopologiesDropdown();
      this.drawCablesOnMap(map, this.cables);

    } else {

      if (this.date) {
        this.mapService.getCablesAndCoordinatesTimeDependant(this.date).subscribe((cables: Array<Cable>) => {

          this.getCablesAndCoordinatesDone = true;


          this.cables = cables;
        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
         } catch (e) {
             console.error('Failed to save cables:', e);
         }
          this.cables.forEach((cable: Cable) => {
            this.cablesMap.set(
              parseInt(cable.gridElementId.toString()),
              cable
            );
          });

          this.cables = this.cables.map((cable: Cable) => {
            cable.color = Config.CONDITION_COLOR_NORMAL;
            cable.weight = 1;
            return cable;
          });
          this.initCableColors();
          this.drawCablesOnMap(map, this.cables);
          this.getApplicationsStatus(this.topology.topologyId);
          this.checkEndAPIsandEnableTopologiesDropdown();
        });
      }
      else {

        this.mapService.getCablesAndCoordinates().subscribe((cables: Array<Cable>) => {

          this.getCablesAndCoordinatesDone = true;


          this.cables = cables;
          localStorage.setItem('cables', JSON.stringify(cables));

          this.cables.forEach((cable: Cable) => {
            this.cablesMap.set(
              parseInt(cable.gridElementId.toString()),
              cable
            );
          });

          this.cables = this.cables.map((cable: Cable) => {
            cable.color = Config.CONDITION_COLOR_NORMAL;
            cable.weight = 1;
            return cable;
          });
          this.initCableColors();
          this.drawCablesOnMap(map, this.cables);
          this.getApplicationsStatus(this.topology.topologyId);
          this.checkEndAPIsandEnableTopologiesDropdown();
        });
      }
    }
  }


  public toggleCables() {
    const hasCablesLayer: boolean = this.map.hasLayer(this.cablesLayer);
    const cablesLayerOpen: boolean = this.map.hasLayer(this.cablesLayerOpen);

    this.isEnableCable = !this.isEnableCable;

    if (hasCablesLayer) {
      this.map.removeLayer(this.cablesLayer);
      //this.redrawCablesLayer
    } else {
      this.map.addLayer(this.cablesLayer);
    }

    if (cablesLayerOpen) {
      this.map.removeLayer(this.cablesLayerOpen);
      //this.redrawCablesLayer
    } else {
      this.map.addLayer(this.cablesLayerOpen);
    }
  }

  public toggleSwitchLayer() {
    const hasSwitchLayer: boolean = this.map.hasLayer(this.switchLayer);
    this.isEnableOpenCable = !this.isEnableOpenCable;
    if (hasSwitchLayer) {
      this.map.removeLayer(this.switchLayer);
      //this.redrawCablesLayer
    } else {
      this.map.addLayer(this.switchLayer);
    }
  }

  public toggleIds() {
    this.gridElemenetIdsShowHide = !this.gridElemenetIdsShowHide;
    const nodes: Array<Element> = Array.from(document.getElementsByClassName("marker-label"));
    nodes.forEach(element => {
      const isHidden: boolean = element.classList.contains('node-id-hidden');
      if (isHidden) {
        element.classList.remove('node-id-hidden');
      } else {
        element.classList.add('node-id-hidden');
      }
    });
  }

  public toggleSubIds(){
    this.gridElementSubIdsShowHide = !this.gridElementSubIdsShowHide;
    const nodes: Array<Element> = Array.from(document.getElementsByClassName("marker-subtitle"));
    nodes.forEach(element => {
      const isHidden: boolean = element.classList.contains('node-sub-id-hidden');
      if(isHidden){
        element.classList.remove('node-sub-id-hidden');
      }else{
        element.classList.add('node-sub-id-hidden');
      }
      // element.classList.toggle('node-sub-id-hidden');
    })
  }

  /**
   * This method save the current toggled states of the elements before showing the planning,
   * so that when we hide the planning we can restore the previous toggled states
   * and show/hide the elements accordingly
   */
  public savePreviousToggledStates(){

    this.previousToggledStates = {
      isEnableLvSubstationBusBarOneTrafo: this.isEnableLvSubstationBusBarOneTrafo,
      isEnableMvSubstationBusBarOneTrafo: this.isEnableMvSubstationBusBarOneTrafo,
      isEnableMvSubstationBusBarWithoutTrafo: this.isEnableMvSubstationBusBarWithoutTrafo,
      isEnableMvStationOneTrafo: this.isEnableMvStationOneTrafo,
      isEnableMvStationWithoutTrafo: this.isEnableMvStationWithoutTrafo,
      isEnableMvStationMultipleTrafo: this.isEnableMvStationMultipleTrafo,
      isEnableCustomerConnectionBox: this.isEnableCustomerConnectionBox,
      isEnableSleeve: this.isEnableSleeve,
      isEnableLvJunctionBox: this.isEnableLvJunctionBox,
      isEnableGenerator: this.isEnableGenerator,
      isEnableVoltageRegulator: this.isEnableVoltageRegulator
    }

    // console.log("After saving previous toggled states: ", {
    //   isEnableLvSubstationBusBarOneTrafo: this.isEnableLvSubstationBusBarOneTrafo,
    //   isEnableMvSubstationBusBarOneTrafo: this.isEnableMvSubstationBusBarOneTrafo,
    //   isEnableMvSubstationBusBarWithoutTrafo: this.isEnableMvSubstationBusBarWithoutTrafo,
    //   isEnableMvStationOneTrafo: this.isEnableMvStationOneTrafo,
    //   isEnableMvStationWithoutTrafo: this.isEnableMvStationWithoutTrafo,
    //   isEnableMvStationMultipleTrafo: this.isEnableMvStationMultipleTrafo,
    //   isEnableCustomerConnectionBox: this.isEnableCustomerConnectionBox,
    //   isEnableSleeve: this.isEnableSleeve,
    //   isEnableLvJunctionBox: this.isEnableLvJunctionBox,
    //   isEnableGenerator: this.isEnableGenerator,
    // });
  }

  /**
   * This method is called when "Hide Planning" button is pressed,
   * it restores the previous toggled states of the elements before showing the planning,
   * and shows/hides the elements accordingly based on their previous states
   */
  public restorePrevoiusToggledStates(){

    if(!this.previousToggledStates) return;

    const elementsToRestore: Array<{shown: boolean, type: string}> = [
      { shown: this.previousToggledStates.isEnableLvSubstationBusBarOneTrafo, type: 'lvsubstationbusbaronetrafo' },
      { shown: this.previousToggledStates.isEnableMvSubstationBusBarOneTrafo, type: 'mvsubstationbusbaronetrafo' },
      { shown: this.previousToggledStates.isEnableMvSubstationBusBarWithoutTrafo, type: 'mvsubstationbusbarwithouttrafo' },
      { shown: this.previousToggledStates.isEnableMvStationOneTrafo, type: 'mvstationonetrafo' },
      { shown: this.previousToggledStates.isEnableMvStationWithoutTrafo, type: 'mvstationwithouttrafo' },
      { shown: this.previousToggledStates.isEnableMvStationMultipleTrafo, type: 'mvstationmultipletrafo' },
      { shown: this.previousToggledStates.isEnableCustomerConnectionBox, type: 'customerconnectionbox' },
      { shown: this.previousToggledStates.isEnableSleeve, type: 'sleeve' },
      { shown: this.previousToggledStates.isEnableLvJunctionBox, type: 'lvjunctionbox' },
      { shown: this.previousToggledStates.isEnableGenerator, type: 'generator' },
      { shown: this.previousToggledStates.isVoltageRegulator, type: 'voltageregulator' }
    ];

    // console.log("this.previousToggledStates.isEnableLvSubstationBusBarOneTrafo", this.previousToggledStates.isEnableLvSubstationBusBarOneTrafo);
    // console.log("this.previousToggledStates.isEnableMvSubstationBusBarOneTrafo", this.previousToggledStates.isEnableMvSubstationBusBarOneTrafo);
    // console.log("this.previousToggledStates.isEnableMvSubstationBusBarWithoutTrafo", this.previousToggledStates.isEnableMvSubstationBusBarWithoutTrafo);
    // console.log("this.previousToggledStates.isEnableMvStationOneTrafo", this.previousToggledStates.isEnableMvStationOneTrafo);
    // console.log(" this.previousToggledStates.isEnableMvStationWithoutTrafo",  this.previousToggledStates.isEnableMvStationWithoutTrafo);
    // console.log("this.previousToggledStates.isEnableMvStationMultipleTrafo", this.previousToggledStates.isEnableMvStationMultipleTrafo);
    // console.log("this.previousToggledStates.isEnableCustomerConnectionBox", this.previousToggledStates.isEnableCustomerConnectionBox);
    // console.log("this.previousToggledStates.isEnableSleeve", this.previousToggledStates.isEnableSleeve);
    // console.log("this.previousToggledStates.isEnableLvJunctionBox", this.previousToggledStates.isEnableLvJunctionBox);
    // console.log("this.previousToggledStates.isEnableGenerator", this.previousToggledStates.isEnableGenerator);

    // console.log("elements that are restored : ", elementsToRestore);
    // elementsToToggleBack.filter(item => !item.shown).forEach(item => this.setElementTypeVisibility(item.type, item.shown));
    elementsToRestore.forEach(item => this.setElementTypeVisibility(item.type, item.shown));
  }

  public restoreToggleByElementType() {
    this.isEnableLvSubstationBusBarOneTrafo = true;
    this.isEnableMvSubstationBusBarOneTrafo= true;
    this.isEnableMvSubstationBusBarWithoutTrafo= true;
    this.isEnableMvStationOneTrafo= true;
    this.isEnableMvStationWithoutTrafo= true;
    this.isEnableMvStationMultipleTrafo= true;
    this.isEnableCustomerConnectionBox= true;
    this.isEnableStatistics= true;
    this.isEnableControllableDevices = true;
    this.isEnableSleeve= true;
    this.isEnableLvJunctionBox= true;
    this.isEnableGenerator= true;
    this.isEnableVoltageRegulator = true;
  }

  /**
   * This method shows all the elements on the map when "Show Planning" button is pressed
   */
  public toggleAllElements(){

    const elementTypes = [
      'lvsubstationbusbaronetrafo',
      'mvsubstationbusbaronetrafo',
      'mvsubstationbusbarwithouttrafo',
      'mvstationonetrafo',
      'mvstationwithouttrafo',
      'mvstationmultipletrafo',
      'customerconnectionbox',
      'sleeve',
      'lvjunctionbox',
      'generator',
      'voltageregulator'
    ];

    elementTypes.forEach(type => {
      this.setElementTypeVisibility(type, true);
    })

  }

  toggleByElementType(type: string) {
    const current = this.getElementVisibility(type);
    this.setElementTypeVisibility(type, !current);
  }

  getElementVisibility(type: string): boolean {
    switch (type) {
      case 'lvsubstationbusbaronetrafo':
        return this.isEnableLvSubstationBusBarOneTrafo;

      case 'mvsubstationbusbaronetrafo':
        return this.isEnableMvSubstationBusBarOneTrafo;

      case 'mvsubstationbusbarwithouttrafo':
        return this.isEnableMvSubstationBusBarWithoutTrafo;

      case 'mvstationonetrafo':
        return this.isEnableMvStationOneTrafo;

      case 'mvstationwithouttrafo':
        return this.isEnableMvStationWithoutTrafo;

      case 'mvstationmultipletrafo':
        return this.isEnableMvStationMultipleTrafo;

      case 'customerconnectionbox':
        return this.isEnableCustomerConnectionBox;

      case 'sleeve':
        return this.isEnableSleeve;

      case 'lvjunctionbox':
        return this.isEnableLvJunctionBox;

      case 'generator':
        return this.isEnableGenerator;

      case 'grid-node-statistics':
        return this.isEnableStatistics;

      case 'voltageregulator':
        return this.isEnableVoltageRegulator;
      
      default:
        return false;
    }
  }

  public setElementTypeVisibility(type: string, visible: boolean) {
    switch (type) {

        case 'lvsubstationbusbaronetrafo':
        this.isEnableLvSubstationBusBarOneTrafo = visible;
        break;

      case 'mvsubstationbusbaronetrafo':
        this.isEnableMvSubstationBusBarOneTrafo = visible;
        break;

      case 'mvsubstationbusbarwithouttrafo':
        this.isEnableMvSubstationBusBarWithoutTrafo = visible;
        break;

      case 'mvstationonetrafo':
        this.isEnableMvStationOneTrafo = visible;
        break;

      case 'mvstationwithouttrafo':
        this.isEnableMvStationWithoutTrafo = visible;
        break;

      case 'mvstationmultipletrafo':
        this.isEnableMvStationMultipleTrafo = visible;
        break;

      case 'customerconnectionbox':
        this.isEnableCustomerConnectionBox = visible;
        break;

      case 'grid-node-statistics':
        this.isEnableStatistics = visible;
        break;

      case 'grid-node-controllabledevice':
        this.isEnableControllableDevices = visible;
        break;

      case 'sleeve':
        this.isEnableSleeve = visible;
        break;

      case 'lvjunctionbox':
        this.isEnableLvJunctionBox = visible;
        break;

      case 'generator':
        this.isEnableGenerator = visible;
        break;

      case 'voltageregulator':
        this.isEnableVoltageRegulator = visible;
        break;
    }

    const nodes: Array<Element> = Array.from(document.getElementsByClassName(type));
    nodes.forEach(element => {
      if(visible) element.classList.remove('node-id-hidden');
      else element.classList.add('node-id-hidden');
    })
  }


  public setNodesVisibility(className: string, visible: boolean){
    const nodes: Array<Element> = Array.from(document.getElementsByClassName(className));

    nodes.forEach(element => {
      if(visible){
        element.classList.remove('node-id-hidden');
      }else{
        element.classList.add('node-id-hidden');
      }
    })
  }


  public toogleNodes(className: string) {
    const nodes: Array<Element> = Array.from(document.getElementsByClassName(className));
    nodes.forEach(element => {
      // console.log("Before changing state of element: " + element.classList);
      const isHidden: boolean = element.classList.contains('node-id-hidden');
      if (isHidden) {
        // console.log("State is hidden, showing element: ", element);
        element.classList.remove('node-id-hidden');
      } else {
        // console.log("State is visible, hiding element: ", element);
        element.classList.add('node-id-hidden');
      }
      // console.log("After changing state of element: " + element.classList);
    });
  }

  public checkLegendCableType(type: string) {
    // console.log('The type inside of legend cable type: ', type);
    switch (type) {
      //show or hide open cable legend icon
      case 'openCable':
        let openCablePresent: boolean = false
        this.cables.forEach(element => {
          if (element.switchingState == "OPEN") {
            openCablePresent = true
          }
        });

        if (openCablePresent) {
          return true
        }
        else {
          return false
        };


      //show or hide closed cable legend icon
      case 'closedCable':
        let closedCablePresent: boolean = false
        this.cables.forEach(element => {
          if (element.switchingState == "CLOSED") {
            closedCablePresent = true
          }
        });
        if (closedCablePresent) {
          return true
        }
        else {
          return false
        };

    }

  }

  public checkLegendType(type: string) {
    if (localStorage.getItem('gridElementsType')) {
      switch (type) {
        case 'lvsubstationbusbaronetrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.LVSUBSTATIONBUSBARONETRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'mvsubstationbusbaronetrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.MVSUBSTATIONBUSBARONETRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'mvsubstationbusbarwithouttrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.MVSUBSTATIONBUSBARWITHOUTTRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'mvstationonetrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.MVSTATIONONETRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'mvstationwithouttrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.MVSTATIONWITHOUTTRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'mvstationmultipletrafo':
          if (localStorage.getItem('gridElementsType').includes(Config.MVSTATIONMULTIPLETRAFO)) {
            return true;
          } else {
            return false;
          };

        case 'customerconnectionbox':
          if (localStorage.getItem('gridElementsType').includes(Config.CCBOX)) {
            return true;
          } else {
            return false;
          };

        case 'sleeve':
          if (localStorage.getItem('gridElementsType').includes(Config.SLEEVE)) {
            return true;
          } else {
            return false;
          };

        case 'lvjunctionbox':
          if (localStorage.getItem('gridElementsType').includes(Config.LVJUNCTIONBOX)) {
            return true;
          } else {
            return false;
          };

        case 'generator':
          if (localStorage.getItem('gridElementsType').includes(Config.GENERATOR)) {
            return true;
          } else {
            return false;
          };

        case 'voltageregulator': 
          if(localStorage.getItem('gridElementsType').includes(Config.VOLTAGEREGULATOR)){
            return true;
          }else{
            return false;
          }

        default: break;
      }
    }
  }

  // Open THD application component
  openThdDialog(){
    const modalRef = this.ngbModal.open(
      ThdMonitoringComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static',
      }
    );

    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
    })
  }

  //Open Short Circuit Current Anaalysis component
  openSCCADialog(){
    const modalRefSCCA = this.ngbModal.open(
      ShortCircuitCurrentAnalysisComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    modalRefSCCA.componentInstance.editPlanningScenarioMode = this.selectedPlanningScenario;
    modalRefSCCA.componentInstance.selectedScenarioId = this.selectedScenarioId;

    modalRefSCCA.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
    })

  }


  openGMonDialog() {
    this.ngbModal.open(
      GmonDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        if (reason == "gmonStarted") {
          this.gMonService.setGMonRunning(true);
        }
      });
  }

  openLCDialog() {
    this.ngbModal.open(
      LcDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        if (reason == "lcStarted") {
          this.lcService.setLCRunning(true);
          this.lcService.setLCDataAvailable(false);
        }
      });
  }

  openLCDialogDetails() {
    this.ngbModal.open(
      LcDialogDetailsComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        // if (reason == "gmonStarted") {
        //   this.gMonService.setGMonRunning(true);
        // }
      });
  }


  openPvListProcessingDialog(){
    this.ngbModal.open(
      PvListProcessingComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        if (reason === "pvListProcessingStarted") {
          this.pvService.setPvListProcessingisRunning(true);
        }
      });
  }

  openMeheStatsDialog(){
    this.ngbModal.open(
      MeheStatsDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });
  }

  openLiveMonitoringAndControl(){
    this.ngbModal.open(
      LiveMonitoringAndControlComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {

      });
  }

  openInitialNotificationsMenu(){
    this.ngbModal.open(
      InitialNotificationsComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {

      });

      this.initialNotificationReadOnce = true;
  }

  openGPlanSummaryTable(){
    this.ngbModal.open(
      GplanSummaryTableComponent, {
        windowClass:'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }
    ).result.then((result) => {
      console.log(result);
    }, (reason) => {

    });
  }

  loadInitialNotifications(){
    this.guiService.getInitialNotifications().subscribe((response: Response) => {
      // console.log("Status: ", response.status);
      let contentOfAutoExecutorJson: AutoExecutor | null = null;
              const notifications: InitialNotifications = Object(response.body);

      if(response.status == 200){
        try{
           contentOfAutoExecutorJson = JSON.parse(notifications.description);
        } catch (error) {
           console.log("Failed to parse AutoExecutor response JSON");
           return;
         }

        this.openInitialNotificationsMenu();
        // console.log(notifications)
        this.initialNotificationsService.setInitialNotifiactionTitle(notifications.title);
        this.initialNotificationsService.setAutoExecutorMessage(contentOfAutoExecutorJson);
        // console.log("Here is the failedTopologies: ", contentOfAutoExecutorJson.failedTopologies)
        // console.log("Here is the violationResults: ", contentOfAutoExecutorJson.violationResults)
        this.initialNotificationsService.setNotificationId(notifications.id);
      }else{
        console.log("You already read the notification")
      }
    })
  }

  loadNotifications() {
    this.guiService.getLastNotifications().subscribe((alarms: Array<Alarm>) => {
      console.log("@@"+alarms);

      alarms.sort((a, b) => {
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
      })

      this.alarms = new Array<Alarm>();
      alarms.forEach((alarm: Alarm) => {
        this.alarms.push(new Alarm(
          alarm.topologyId,
          alarm.dsoInternalId,
          alarm.gridElementId,
          DateUtils.stringUTCDateToLocalDate(alarm.timestamp).toString(),
          alarm.violationLoad,
          alarm.violationType,
          alarm.violationVoltage_V,
          alarm.measurementCount,
          alarm.deviceId,
          alarm.probability
        ));

      });

      this.notReadNotificationsCount = alarms.length;
    });

    if(this.alarms && this.alarms.length > 0){
      const ids = this.alarms.map(a => a.topologyId);
      this.distinctTopologyIds = Array.from(new Set(ids));
    }else{
      this.distinctTopologyIds = [];
    }
  }

  onTopologySelected(){
    // this.applicationsResultsService.setSelectedTopologyId(topologyId);
    this.applicationsResultsService.setAlarms(this.alarms);
    // this.applicationsResultsService.setDistinctTopologyIds(this.distinctTopologyIds);

    this.router.navigate(['/alarms-menu']);
  }

  // parseNotificationTitle(title: string): {deviceId: string, topologyId: string }{
  //   const devicePattern = /device (\[.*?\])([^[]+) in topology/;
  //   const topologyPattern = /in topology (\[.*?\].*)/;

  //   const deviceIdMatch = title.match(devicePattern);
  //   console.log("DEVICE MATHC |" + deviceIdMatch)
  //   const topologyIdMatch = title.match(topologyPattern);
  //   console.log("TOPOLOGY MATHC | " + topologyIdMatch)

  //   const deviceId = deviceIdMatch ? deviceIdMatch[1] + deviceIdMatch[2] : 'Unknown Device';
  //   const topologyId = topologyIdMatch ? topologyIdMatch[1].trim() : 'Unknown TOpology';
  //   return {deviceId, topologyId};
  // }

  markAllNotificationsRead() {
    // if (this.notifications && this.notifications.length === 0) {
    //   console.log("No notifications");
    //   return;
    // }
    // this.guiService.markAllNotificationsRead().subscribe(result => {
    //   console.log();

    //   this.loadNotReadNotificationsCount();
    //   this.loadNotifications();
    // });
    this.hidePlanning();
    // this.map.removeItem(this.markerMagnifier)
  }


  isGMonRunning(): boolean {
    return this.gMonService.isGMonRunning();
  }

  isLCRunning(): boolean {
    return this.lcService.isLCRunning();
  }

  areLCDataAvailable(): boolean {
    return !this.lcService.isLCRunning() && this.lcService.areLCDataAvailable();
  }

  isLARunning(): boolean {
    return this.laService.isLARunning();
  }


  isLMRunning(): boolean {
    if(this.topology)
      return this.lmService.isLMRunning(this.topology.topologyId);
    else
      return false;
  }

  isTHDMonitoringRunning(): boolean {
    return this.thdMonitoringService.getThdIsReceived();
  }

  isCMRunning(): boolean {
    return this.lmService.isCMRunning(this.topology.topologyId);
  }

  isSCCCRunning(): boolean{
    return this.shortCircuitCurrentAnalysisService.getIsSccaAvailable();
  }

  isReactivePowerAnalysisRunning() {
    return this.reactivePowerAnalysisService.isReactivePowerAnalysisRunning();
  }

  areRPADataAvailable(): boolean {
    return !this.reactivePowerAnalysisService.isReactivePowerAnalysisRunning()
      && this.reactivePowerAnalysisService.areRPADataAvailable();
  }

  openLADialogDetails() {
    this.ngbModal.open(
      LaDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        if (reason == "laStarted") {
          this.laService.setLARunning(true);
        }
      });
  }

  openReactivePowerAnalysisDialog() {
    this.ngbModal.open(
      ReactivePowerAnalysisDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        // console.log(reason);
        if (reason === "reactivePowerAnalysisStarted") {
          this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(true);
        }
      });
  }

  openGPlanDialog() {

    if (this.selectedPlanningScenario) {
      this.restoreOriginalMap();
      this.selectedPlanningScenario = false;
    }
    this.editPlanningScenarioMode = false;
    const modalRef = this.ngbModal.open(
      GplanDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });
    modalRef.componentInstance.editPlanningScenarioMode = this.editPlanningScenarioMode;

    modalRef.result.then((result) => {

      console.log(result);
    }, (reason) => {
      console.log(reason);
      if (reason === "gplanStarted") {
        this.gridPlanningScenarios = [];
        this.gPlanService.setGPlanRunning(true);
        //this.gridPlanningScenarios.push(JSON.parse(localStorage.getItem("currentScenario")));
        //this.restoreOriginalMap();
        //this.selectedPlanningScenario = false;
      }
    });
  }

  editPlanningScenario() {
    if (this.selectedPlanningScenario) {
      this.hidePlanning();
      this.selectedPlanningScenario = false;
    }

    this.editPlanningScenarioMode = true;
    let selectedScenario = this.selectedScenario
    localStorage.setItem("currentScenarioEdit", JSON.stringify(selectedScenario));

    const modalRef = this.ngbModal.open(
      GplanDialogComponent,
      {
        windowClass: 'my-class',
        ariaLabelledBy: 'modal-basic-title',
        centered: false,
        scrollable: true,
        backdrop: 'static'
      });

    modalRef.componentInstance.editPlanningScenarioMode = this.editPlanningScenarioMode;

    modalRef.result.then((result) => {
      if (result === "close") {
        localStorage.removeItem('planningNodeList');
        localStorage.removeItem('planningCableList');
        localStorage.removeItem('currentScenarioEdit');
      }
      console.log(result);
    }, (reason) => {
      console.log(reason);
      if (reason === "gplanStarted") {
        this.gridPlanningScenarios = [];
        this.gPlanService.setGPlanRunning(true);
        //this.gridPlanningScenarios.push(JSON.parse(localStorage.getItem("currentScenario")));
        //this.restoreOriginalMap();
        //this.selectedPlanningScenario = false;
      }
    });
  }

  glanRunningDisable() {
    this.gPlanService.setGPlanRunning(false);
  }

  isGPlanRunning(): boolean {
    return this.gPlanService.isGPlanRunning();
  }

  isPVListRunning(): boolean {
    return this.pvService.isPvListProcessingisRunning();
  }

  logout(): void {
    this.userService.logout().subscribe(() => {
      this.userService.removeToken();
      this.router.navigate(['']);
      localStorage.clear();
      this.mqttDeconnect();
    }, (error) => {
      error.console.error();
    });
  }

  private mqttDeconnect() {

    if (this.mqttClient) {
      const topics: Map<MqttTopic, boolean> = this.getTopics();
      console.log('Unsubscribing topics...');
      topics.forEach((value: boolean, topic: MqttTopic) => {
        if (value) {
          console.log('Unsubscribing ' + topic);
          this.mqttClient.unsubscribe(topic);
        }
      });
      console.log('Ending connection...');
      this.mqttClient.end();
      this.mqttClient = null;
      console.log('Closed MQTT client...');
    }
    // console.log("2. mqttClient..: " + JSON.stringify(this.mqttClient));
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('Language', lang);

    this.translate.getTranslation(lang).subscribe((translations) => {
      console.log("Translations: ", translations);

      this.translations = translations;

      this.gplanTitle = translations["code-string"]["Grid-Planning"];
      this.gplanTextResults = translations["code-string"]["gplan-results"];
      this.gplanTextError = translations["code-string"]["gplan-errors"];
      this.gplanSummary = translations["code-string"]["gplan-summary"]
      this.gmonTitle = translations["code-string"]["Grid-Monitoring"];
      this.gmonTextResults = translations["code-string"]["gmon-results"];
      this.gmonTextError = translations["code-string"]["gmon-errors"];
      this.gmonTextEmpty = translations["code-string"]["gmon-empty"];

      this.pvTitle = translations["code-string"]["PV-List-Processing"];
      this.pvTextResults = translations["code-string"]["pv-results"];
      this.pvTextError = translations["code-string"]["pv-errors"];
      this.pvTextEmpty = translations["code-string"]["pv-empty"];

      this.laTitle = translations["code-string"]["Loading-Analysis"];
      this.laTextResults = translations["code-string"]["la-results"];
      this.laTextError = translations["code-string"]["la-errors"];
      this.laTextEmpty = translations["code-string"]["la-empty"];

      this.rpaTitle = translations["code-string"]["Reactive-Power-Analysis"];
      this.rpaTextResults = translations["code-string"]["rpa-results"];
      this.rpaTextError = translations["code-string"]["rpa-errors"];
      this.rpaTextEmpty = translations["code-string"]["rpa-empty"];

      this.lcTitle = translations["code-string"]["Loss-Calculation"];
      this.lcTextResults = translations["code-string"]["lc-results"];
      this.lcTextError = translations["code-string"]["lc-errors"];

      this.licenseTitle = translations["code-string"]["License-expired"];
      this.licenseText = translations["code-string"]["License-expired-text"];

      this.sessionTitle = translations["code-string"]["session-expired"];
      this.sessionText = translations["code-string"]["session-expired-text"];

      this.eflTitle = translations["edaf-code-string"]["efl-title"];
      this.eflTextResults = translations["edaf-code-string"]["efl-results"];
      this.eflTitleError = translations["edaf-code-string"]["efl-title-error"];
      this.eflTextError = translations["edaf-code-string"]["efl-error"];

      this.open = translations["code-string"]['open'];
      this.closed = translations["code-string"]['closed'];
      this.mixed = translations["code-string"]['mixed'];

      this.noLVTopologyTitle = translations["home"]["3dcde023-8001-4dca-81bb-560a234581d8"];
      this.noLVTopologyText = translations["home"]["29a4d150-8686-4d87-b338-9b580a12be0a"];
      this.onlyOneLVTrafoTitle = translations["home"]["c4d76997-628e-4a5c-97fd-1f0898aece55"];
      this.onlyOneLVTrafoText = translations["home"]["4ead41e8-bcb2-4c6f-91d8-5daa0b09e153"];
    });
  }

  // private initGridColors(appName?: string) {
  private initGridColors() {
    // console.log("THIS CALLED TWICE")
    const gridColorAppsJson: string = localStorage.getItem('gridColorApps');
    if (gridColorAppsJson) {
      const gridColorAppsArray = JSON.parse(gridColorAppsJson);
      if (gridColorAppsArray.length != 0 ) {

        gridColorAppsArray.forEach(gc => {
          const gridColor = new GridColor(gc.gridElementId);
          gridColor.voltage = gc.voltage;
          gridColor.voltageGP = gc.voltageGP;
          gridColor.frequency = gc.frequency;
          gridColor.la = gc.la;
          gridColor.laGP = gc.laGP;
          gridColor.rpa = gc.rpa;
          this.gridColorApps.set(+gridColor.gridElementId, gridColor);
        });
        this.saveGridColorApps();
        return;
      }
    }
    const gridElementsJson: string = localStorage.getItem('gridElements');
    if (gridElementsJson) {
      const gridElements: Array<GridElement> = JSON.parse(gridElementsJson);
      gridElements.forEach(gridElem => {
        this.gridColorApps.set(+gridElem.gridElementId, new GridColor(+gridElem.gridElementId, gridElem.condition));
      });
      this.saveGridColorApps();
    } else {
      console.log('not gridElements loaded yet');
    }

  }

  private getColoringForLvTopology(){
    const gridElementJSON: string = localStorage.getItem('gridElements');
    if(gridElementJSON) {
      const gridElements: Array<GridElement> = JSON.parse(gridElementJSON);
      gridElements.forEach(gridElem => {
        this.gridColorApps.set(+gridElem.gridElementId, new GridColor(+gridElem.gridElementId, gridElem.condition));
      });
      this.saveGridColorApps();
    }
  }

  /*
  private setGridColors(gridElements: Array<GridElement>) {
    this.initGridColors();
    if (this.selectedPlanningScenario == true) {
      gridElements.forEach((gridElement: GridElement) => {
        const gridColor = this.gridColorApps.get(+gridElement.gridElementId);
        gridElement.condition = gridColor.getHighestCondition();
      });
      return gridElements;

    }
    else {
      gridElements.forEach((gridElement: GridElement) => {
        const gridColor = this.gridColorApps.get(+gridElement.gridElementId);
        gridElement.condition = gridColor.getHighestCondition();
      });
      return gridElements;
    }

  }*/

  private saveGridColorApps() {
    // console.log("Array from gridColorApps: ", JSON.stringify(Array.from(this.gridColorApps.values())));
    localStorage.setItem('gridColorApps', JSON.stringify(Array.from(this.gridColorApps.values())));
  }

  clearMemory() {
    localStorage.removeItem("gridElements");
    localStorage.removeItem("cables");
    localStorage.removeItem("gridColorApps");

    localStorage.removeItem("root");
    localStorage.removeItem("gplanNodes");
    //localStorage.removeItem("currentTab");
    localStorage.removeItem("areLcDataAvailable");
    localStorage.removeItem("areGplanDataAvailable");
    localStorage.removeItem("areFrequencyDataAvailable");
    localStorage.removeItem("areVoltageDataAvailable");
    localStorage.removeItem("areLADataAvailable");
    localStorage.removeItem("areRPADataAvailable");
    this.resetLocaleArray();
    window.location.reload(); //onIniit
    this.loadGridElementsOnMap(this.map);
  }

  ngOnDestroy() {
    this.mqttDeconnect();
    // this.logout();

    this.isAdmin = false;
  }

  stopGmonRunning() {
    this.gMonService.setGMonRunning(false);
  }

  stopGPlanRunning() {
    this.gPlanService.setGPlanRunning(false);
  }

  stopLARunning() {
    this.laService.setLARunning(false);
  }

  stopRPARunning() {
    this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(false);

        if (this.subscription) {
          this.subscription.unsubscribe();
        }
  }

  private initCableColors() {
    if (this.selectedPlanningScenario == true) {
      const cableColorAppsJson: string = localStorage.getItem('cableColorApps');
      if (cableColorAppsJson) {
        const cableColorAppsArray = JSON.parse(cableColorAppsJson);
        if (cableColorAppsArray.length != 0) {
          cableColorAppsArray.forEach(cc => {
            const cableColor = new CableColor(cc.gridElementId);
            cableColor.la = cc.la;
            cableColor.laGP = cc.laGP;
            this.cableColorApps.set(+cableColor.gridElementId, cableColor);
          });
          this.saveCableColorApps();
          // console.log('cableColorApps in init: ' + JSON.stringify(Array.from(this.gridColorApps.values())));
          return;
        }
      }
      const cablesJson: string = localStorage.getItem('cables');
      if (cablesJson) {
        const cables: Array<Cable> = JSON.parse(cablesJson);
        cables.forEach(cableElem => {
          this.cableColorApps.set(+cableElem.gridElementId, new CableColor(+cableElem.gridElementId, cableElem.color));
        });
        this.saveCableColorApps();
      } else {
        console.log('not cable-Elements loaded yet');
      }
    }
    else {
      const cableColorAppsJson: string = localStorage.getItem('cableColorApps');
      if (cableColorAppsJson) {
        const cableColorAppsArray = JSON.parse(cableColorAppsJson);
        if (cableColorAppsArray.length != 0) {
          cableColorAppsArray.forEach(cc => {
            const cableColor = new CableColor(cc.gridElementId);
            cableColor.la = cc.la;
            cableColor.laGP = cc.laGP;
            this.cableColorApps.set(+cableColor.gridElementId, cableColor);
          });
          this.saveCableColorApps();
          // console.log('cableColorApps in init: ' + JSON.stringify(Array.from(this.gridColorApps.values())));
          return;
        }
      }
      const cablesJson: string = localStorage.getItem('cables');
      if (cablesJson) {
        const cables: Array<Cable> = JSON.parse(cablesJson);
        cables.forEach(cableElem => {
          this.cableColorApps.set(+cableElem.gridElementId, new CableColor(+cableElem.gridElementId, cableElem.color));
        });
        this.saveCableColorApps();
      } else {
        console.log('not cable-Elements loaded yet');
      }
    }

  }

  private testingSomeMethodCables(){
    const cablesJson: string = localStorage.getItem('cables');
      if (cablesJson) {
        const cables: Array<Cable> = JSON.parse(cablesJson);
        cables.forEach(cableElem => {
          this.cableColorApps.set(+cableElem.gridElementId, new CableColor(+cableElem.gridElementId, cableElem.color));
        });
        this.saveCableColorApps();
      } else {
        console.log('not cable-Elements loaded yet');
      }
  }

  private setCableColors(cables: Array<Cable>) {
    this.initCableColors();
    cables.forEach((cable: Cable) => {
      const cableColor = this.cableColorApps.get(+cable.gridElementId);
      cable.color = cableColor.la;
    });
    return cables;
  }

  private saveCableColorApps() {
    localStorage.setItem('cableColorApps', JSON.stringify(Array.from(this.cableColorApps.values())));
  }


  // EDAF
  manageEFLError(message: string) {
    this.modalService.openBasicModal(
      "" + this.eflTitleError,
      "<div>" + this.eflTextError + "</div>" +
      "<div>" + message + "</div>"
    );
  }

  manageEFLNotifications(message: any) {
    const notificationEfl: NotificationEFL = JSON.parse(message);
    console.log('notificationEfl' + notificationEfl);
    if (notificationEfl) {
      this.modalService.openBasicModal(
        "" + this.eflTitle,
        "<div>" + this.eflTextResults + "</div>"
      );
      if (notificationEfl.payload.locations.length === 0) {
        return;
      } else {
        this.updateLocationArray(notificationEfl.payload.locations);
      }
    }
  }

  private updateLocationArray(newLocations: Array<Location>) {
    console.log("method updateLocationArray call");
    const locationArrayJson: string = localStorage.getItem("locationArray");
    if (locationArrayJson) {
      this.locationArray = JSON.parse(locationArrayJson);
    }
    // const newLocations: Array<Location> = notificationEfl.payload.locations;
    if (this.locationArray.length === 0) {
      this.locationArray = newLocations;
      localStorage.setItem("locationArray", JSON.stringify(this.locationArray));
      this.guiUpdateEvent();
      return;
    }
    console.log("add new locations to locationArray");
    newLocations.forEach(loc => {
      let hasNotIndex = true;
      console.log("check locations");
      for (const location of this.locationArray) {
        if (loc.nodeId === location.nodeId) {
          location.correlation = loc.correlation;
          hasNotIndex = false;
          console.log("has locations");
          break;
        }
      }
      if (hasNotIndex) {
        this.locationArray.push(loc);
      }
    });
    console.log(this.locationArray);
    this.guiUpdateEvent();
  }

  private guiUpdateEvent() {
    // console.log("method guiUpdateEvent call");
    if (!this.locationArray || this.locationArray.length === 0) {
      const locationArrayJson: string = localStorage.getItem("locationArray");
      if (locationArrayJson) {
        this.locationArray = JSON.parse(locationArrayJson);
      }
    }
    if (this.locationArray.length !== 0) {
      this.locationArray.sort((loc1: Location, loc2: Location) =>
        loc2.correlation - loc1.correlation);
      localStorage.setItem("locationArray", JSON.stringify(this.locationArray));
      this.updateMap();
    } else {
      return;
    }
  }

  updateMap() {
    console.log("method updateMap call");
    if (this.locationArray.length === 0) {
      return;
    }
    // const len = Math.max(this.rank, this.locationArray.length);
    const len = this.locationArray.length;
    console.log(this.locationArray);
    console.log(this.nodesMap);


    this.nodesMap.forEach((value: GridElement, key: number) => {
      //console.log("vale nodes map" +key);
      //console.log("kex nodes map "  +value.properties[0].value);
      for (let index = 0; index < len; index++) {


        if (this.locationArray[index].nodeId === value.properties[0].value) {

          console.log("MATCH");

          const gridElement: GridElement = value;
          console.log(gridElement);
          const locTemp = this.locationArray[index];
          const loc: Location = new Location(gridElement.properties[3].value, locTemp.correlation);

          if (gridElement) {
            if (!this.rank) {
              this.rank = this.configurationService.getConfiguration().EDAF.rank;
            }
            console.log("Rank: " + this.rank);
            console.log("Con: " + loc.getConditionEFL(1, this.rank));
            gridElement.condition = loc.getConditionEFL(1, this.rank);
            // gridElement.condition = this.getConditionEFL(index, loc.probability);
            // console.log(gridElement);
          } else {
            console.error("No grid-node with the id: " + this.locationArray[index].nodeId);
          }
        }
      }
    });

    this.redrawNodesLayer(Array.from(this.nodesMap.values()));
  }

  resetLocaleArray() {
    this.locationArray = new Array<Location>();
    localStorage.removeItem("locationArray");
  }

  // translate switching state on planning summary
  getSwitchingStateTranslation(state: string) {
    if (state == 'MIXED') {
      return this.mixed
    }
    if (state == 'OPEN') {
      return this.open
    }
    if (state == 'CLOSED') {
      return this.closed
    }
  }

  onSelectTopologyByDropDown(selectedTopology: any) {
    // if(!this.isCartesianMapIsOn){
      this.getConfiguredDisplay = false;
      this.restoreToggleByElementType();
      this.iconsAreDisplayedUsingUserConfig = false;
      //reset maps when user switches topology
      this.nodesMapGP.clear();
      this.nodesMap.clear();
      this.cablesMap.clear();
      this.cablesMapGP.clear();
      this.cables = [];
      this.cablesGP = [];

      this.onConfirmSelectionDate = false;
      this.selectedPlanningScenario = false;
      this.gridPlanningScenarios = [];
      console.log(selectedTopology)
      this.toDate = null
      this.date = undefined;
      this.selectedDate = false;
      this.enableResetButton = false;
      if (selectedTopology && selectedTopology.id) {
        this.onSelectTopology(selectedTopology.id);
      }

    this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
      if(response) {
        localStorage.setItem("topologies", JSON.stringify(response));
      }
    });

    //Resetting EFL resutls to remove coloring
    this.resetEflResults();
  }

  onSelectDate() {
    this.date = undefined;
    if (this.toDate) {
      this.selectedDate = true;
      console.log(this.toDate)
    }
  }

  confirm() {
    //this.date = "";
    this.onConfirmSelectionDate = true;
    this.enableResetButton = true;

    if (this.toDate && this.toDate.month && this.toDate.day && this.toDate.year) {
      //convert selected date to local Date
      let localDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
      //convert Local Dtae to UTC
      this.date = DateUtils.stringLocalDateToUTC(localDate)
    }
    let topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.onSelectTopology(topology.topologyId);
  }

  reset() {
    this.onConfirmSelectionDate = false;
    this.enableResetButton = false;
    //this.date = undefined
    let topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.onSelectTopology(topology.topologyId);
    //this.toDate = null
    this.selectedDate = false;
  }

  /**
 * Highlight the changes of the selected scenario on the map
 * 1) modify the cables following the "Switching within the chosen topology" of the selected scenario
 * (e.g. if a cable in "Switches within the selected topology" is OPEN and in the map the same cable is CLOSED, change the cable on the map to OPEN (dashed line in this case)
 * 2) Highlight the cables present in the "Cables" list of the selected scenario on the map with a thicker black line
 * 3) For the Nodes present in the "Loads" list of the selected scenario, on the map add a black icon of the generator
 */
  showSelectedScenarioOnMap() {

    //save the current cables
    localStorage.setItem('cables', JSON.stringify(this.cables));
    //save the current node Map
    localStorage.setItem('nodeMap', JSON.stringify(Array.from(this.nodesMap.values())));

    //extract gridElement lists from nodeMap
    this.gridElements = Array.from(this.nodesMapGP.values());
    //edit current cables with the related switching state of the "Swichtings within chosen topology" list of the selected scenario
    //weight = 2
    if (this.selectedScenario.planningSwichtingStates) {
      this.selectedScenario.planningSwichtingStates.forEach(cableScenario => {
        this.cables.forEach(element => {
          if (cableScenario.cableGridelementId == element.gridElementId) {
            element.switchingState = cableScenario.switchingState;
            element.weight = 2;
          }
        });
      });
    }

    //edit current cables with the related switching state of the "Swichtings to neighbour topology" list of the selected scenario
    //weight = 2
    if (this.selectedScenario.planningSubgridsDtos) {
      this.selectedScenario.planningSubgridsDtos.forEach(cableScenario => {
        this.cables.forEach(element => {
          if (cableScenario.cableGridelementId == element.gridElementId) {
            element.switchingState = cableScenario.switchingState;
            element.weight = 2;
          }
        });
      });
    }


    //edit current cables with the related switching state of the "Cables" list of the selected scenario
    //black color and weight = 2 line
    if (this.selectedScenario.planningCables) {
      this.selectedScenario.planningCables.forEach(cableScenario => {
        this.cables.forEach(element => {
          if (cableScenario.cableGridelementId == element.gridElementId) {
            element.color = "#000000";
            element.weight = 2;
          }
        });
      });
    }


    //add load propertiy with "no" value if not present, set to "no" otherwise
    this.gridElements.forEach(element => {

      if (element.getProperty("load_on_scenario")) {
        element.setPropertyValue("load_on_scenario", "no")
      }

      else {
        let prop = { "name": "load_on_scenario", "value": "no" }
        element.properties.push(prop)
      }

    });

    //if the current scenario contains a Load, show in the map a black generator icon, for that node
    if (this.selectedScenario.planningNodes) {
      this.selectedScenario.planningNodes.forEach(node => {
        if (this.gridElements) {
          this.gridElements.forEach(element => {
            if (node.nodeGridelementId == element.gridElementId) {
              element.setPropertyValue("load_on_scenario", "yes");
            }
          });
        }
      });
    }

    //redraw the node layer
    if (this.gridNodesLayer) {
      this.map.removeLayer(this.gridNodesLayer);
    }
    const markers: Array<L.marker> = this.drawGridElementsOnMap(this.gridElements, this.showIds);
    this.gridNodesLayer = L.layerGroup(markers);
    this.gridNodesLayer.addTo(this.map);

    //redraw the cable layer
    if (this.cablesLayer) {
      this.map.removeLayer(this.cablesLayer);
    }
    if (this.cablesLayerOpen) {
      this.map.removeLayer(this.cablesLayerOpen);
    }

    if (this.switchLayer) {
      this.map.removeLayer(this.switchLayer);
    }
    this.drawCablesOnMap(this.map, this.cables);
  }

  /**
   * Restore original map using 'cables' and 'nodeMap' saved into the localstorage
   * Redraw cable layer and cable layer
   */
  restoreOriginalMap() {
    //retrive original cables and nodeMap from localStorage
    let cablesJson: string = localStorage.getItem('cables');
    let originalCables: Array<Cable> = JSON.parse(cablesJson);
    console.log("Here is the original cables to restore: ", originalCables);

    let gridElements = JSON.parse(localStorage.getItem('nodeMapOriginal'));
    console.log("Here is the original nodeMap to restore: ", gridElements);

    let laGuiColoringInfoDto: LAResultsAvailableMessage = JSON.parse(localStorage.getItem("laGuiColoringInfoDto"))

    if(!laGuiColoringInfoDto){
      originalCables = originalCables.map((cable: Cable) => {
        cable.color = Config.CONDITION_COLOR_NORMAL;
        cable.weight = 1;
        return cable;
      });
    }

    //restore cables color and weight
    if (originalCables) {
      originalCables.forEach(original => {

        if (this.cables) {
          this.cables.forEach(element => {

            if (element.gridElementId == original.gridElementId) {
              element.switchingState = original.switchingState;
              element.color = original.color;
              element.weight = original.weight;
            }
          });
        }
      });
    }

    //restore nodes with original properties
    if (gridElements) {
      gridElements.forEach(original => {
        this.gridElements.forEach(node => {
          if (original.gridElementId == node.gridElementId) {
            node.properties = original.properties;
          }
        });
      });
    }
    //redraw node layer
    if (this.gridNodesLayer) {
      this.map.removeLayer(this.gridNodesLayer);
      console.log("GridNodesLayer removed from map");
    }

    //redraw cable layer
    if (this.cablesLayer) {
      this.map.removeLayer(this.cablesLayer);
    }
    if (this.cablesLayerOpen) {
      this.map.removeLayer(this.cablesLayerOpen);
    }
    if (this.switchLayer) {
      this.map.removeLayer(this.switchLayer);
    }

    /*
    this.cables = this.cables.map((cable: Cable) => {
      cable.color = Config.CONDITION_COLOR_NORMAL;
      cable.weight = 1;
      return cable;
    });
    */

    console.log(this.cables)
    this.drawCablesOnMap(this.map, this.cables);
    this.redrawNodesLayer(Array.from(this.nodesMap.values()));
    this.map.invalidateSize();
  }

  /*----------------------------------------------------------------------------------------------------------------------------------------------
  --------------------------------------------Grid Planning Summary (Info button in Show Planning)------------------------------------------------
  ----------------------------------------------------------------------------------------------------------------------------------------------*/
  getGPSummaryInfo(){
    // console.log("just showing selected scenario ID ", this.selectedScenarioId);
    this.gPlanService.getGPSummaryInfo(this.selectedScenarioId).subscribe((response) => {
      // console.log("The result of calling REST API GP summary ", JSON.stringify(response));

      let responseArray: Map<string, number> = new Map(Object.entries((response)));
    });

    this.gotGPSummaryInfo = true;
  }

  sendSelectedScenarioIdToService(scenarioId: number, scenarioName: string, scenarioIntervalStart: string, scenarioIntervalEnd: string, scenarioType: string){
    // console.log("SELECted scenario ID From the home component ", this.selectedScenarioId)
    const organizedScenario = {scenarioId, scenarioName, scenarioIntervalStart, scenarioIntervalEnd, scenarioType}
    this.gPlanService.setSharedData(organizedScenario);
  }

  //when user click on datepicker hide Planning Scenario tab and restore original map
  onNavigateDate(event: NgbDatepickerNavigateEvent) {
    if (this.selectedPlanningScenario == true) {
      this.hidePlanning()
    }
  }

  close(){
    this.hidePlanning();
    for(let i = 0; i < this.markerMagnifierArray.length; i++){
      // this.map.removeLayer(this.markerMagnifier);
      this.map.removeLayer(this.markerMagnifierArray[i]);
      // console.log("MARKER MAGNIFIER : " , this.markerMagnifier);
      // this.markerMagnifierArray.length = 0;
    }
  }

  formatSummaryString(template, values) {
    console.log("formatSummaryString:"+template);
    return template
        .replace("maxCableLoad", values.maxCableLoad)
        .replace("numberOfLineLoadingViolation", values.numberOfLineLoadingViolation)
        .replace("numberOfNodeLoadingViolation", values.numberOfNodeLoadingViolation)
        .replace("maxVoltage", values.maxVoltage)
        .replace("minVoltage", values.minVoltage)
        .replace("numberOfVoltageViolation", values.numberOfVoltageViolation)
        .replace("maxNodeLoad", values.maxNodeLoad);
 }

  jumpTopology(param: any){
    let prop = { "name": param.param, "id": param.param }
    this.selectedTop = param.param;
    this.onSelectTopologyByDropDown(prop);
    localStorage.setItem("parentTopology",param.param2);
  }

  getPropertyValue(propertyName: string, properties: Array<Property>): string {
   let propertyValue: string = "";

   properties.forEach((property: Property) => {
     if (property.name.toLowerCase() === propertyName.toLowerCase()) {
       propertyValue = property.value;
       return;
     }
   });

   return propertyValue;
  }

  mapModeChanged(event: Event){
    const input = event.target as HTMLInputElement;

    this.resetMapState();

    // setTimeout(() => {
    if(input.checked){
      console.log("Cartesian map mode selected");
      this.map = this.mapService.initializeCartesianMap();
      this.isCartesianMapIsOn = true;
      Promise.resolve().then(() => {
        this.drawElementsOnCartesianMap();
      });
    }else{
      console.log("Geographical map mode selected");
      this.destroyMap();
      this.gPlanService.getGplanNode(this.topology.topologyId, this.date);

      //this.getApplicationsStatus();
      this.loadGridType();
      this.loadCableType();
      this.loadLegendTypes();
      this.loadMap('map');
      this.isCartesianMapIsOn = false;
    }
    // })
  }

  destroyMap(): void {
    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }
  }

  drawElementsOnCartesianMap(selectedTopologyId?: string): void {
    if (!this.map) {
      console.error("Map is not initialized yet!");
      return;
    }

    this.getGridMap(selectedTopologyId).pipe(
      switchMap(gridMap => {
        return this.mapService
          .getMarkerCoordinatesForCartesianMap(this.topology.topologyId)
          .pipe(
            map((response: TestingDataForPost[]) => ({ response, gridMap }))
          );
      })
    ).subscribe(({ response, gridMap }) => {

      const coordinateMap = this.drawMarkersOnCartesianMap(response, gridMap);
      console.log("Here is the coordinate Map: ", coordinateMap);
      this.drawCablesOnCartesianMap(coordinateMap , selectedTopologyId);

    });
  }

  private getGridMap(selectedTopologyId: string): Observable<Map<number, any>>{
    const storedGridElements = localStorage.getItem('gridElements');

    if(storedGridElements){
      const parsedGridElements = JSON.parse(storedGridElements);
      return of(
        new Map(parsedGridElements.map(g => [Number(g.gridElementId), g]))
      );
    }

    return this.mapService.getGridElementsDetailsForCartesianMap(selectedTopologyId).pipe(
      map((gridElements: Array<GridElement>) => {
        return new Map(
          gridElements.map(g => [Number(g.gridElementId), g])
        );
      })
    );
  }

  private drawMarkersOnCartesianMap(
    response: TestingDataForPost[],
    gridMap: Map<number, any>
  ): Map<number, { x: number; y: number }> {

    // console.log("Here is the response testing data : ", response);
    // console.log("Here is the gridMap: ", gridMap);

    const cartesianMarkers = new Array<L.marker>();
    const coordinateMap = new Map<number, { x: number; y: number }>();

    response.forEach(data => {
      if(data.x && data.y){
        const gridId = Number(data.gridelementid);
        const gridElement = gridMap.get(gridId);

        if (!gridElement) return;

        const marker = this.mapService.buildCartesianMarker(gridElement, data, this.showIds, this.showSubIds);
        // console.log("Here is the gridElement: ", gridElement);

        cartesianMarkers.push(marker);

        if (!marker) return;

        coordinateMap.set(gridId, { x: data.x, y: data.y });

        if(marker){
          marker.on('click', (data) => {
            const modalRef = this.ngbModal.open(NodeDetailsDialogComponent, {
              windowClass: 'my-class',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });

            (modalRef.componentInstance as NodeDetailsDialogComponent).gridElementId = gridElement.gridElementId;
            (modalRef.componentInstance as NodeDetailsDialogComponent).elementType = gridElement.elementSubType;
            (modalRef.componentInstance as NodeDetailsDialogComponent).selectedPlanningScenario = this.selectedPlanningScenario;
            (modalRef.componentInstance as NodeDetailsDialogComponent).selectedScenario = this.selectedScenario;
            (modalRef.componentInstance as NodeDetailsDialogComponent).jumpTopology = gridElement.getPropertyValue("jumpTopology");
            (modalRef.componentInstance as NodeDetailsDialogComponent).noResult = ("true" === gridElement.getPropertyValue("noResult"));
            // console.log("Here is the gridElement noResult: ", gridElement.getPropertyValue("noResult"));
            modalRef.result.then((result) => {

            }, (reason) => {

            });
          });
        }
      }
    });


    this.gridNodesLayer = L.layerGroup(cartesianMarkers);
    if(this.gridNodesLayer){
      this.gridNodesLayer.addTo(this.map);
    }

    return coordinateMap;
  }

  private drawCablesOnCartesianMap(coordinateMap: Map<number, {x: number; y: number}>, selectedTopologyId?: string): void{
    const storedCables = localStorage.getItem('cables');

    if(storedCables){
      const cables: Cable[] = JSON.parse(storedCables);
      this.handleCablesOnCartesianMap(cables, coordinateMap);
      return;
    }

    if(selectedTopologyId){
      this.mapService.getCablesAndCoordinatesForCartesianMap(selectedTopologyId).subscribe((cables: Array<Cable>) => {
        console.log("Here are the cables that we are geting: ", cables);

        this.handleCablesOnCartesianMap(cables, coordinateMap);
      })
    }
  }

  private handleCablesOnCartesianMap(cables: Array<Cable>, coordinateMap: Map<number, {x: number; y: number}>): void {
    this.cables = cables;

    if(!cables.length){
      console.warn('No cables were found ');
      return;
    }

    const cablePolylines = cables.map(cable => this.createPolylineOnCartesianMap(cable, coordinateMap)).filter((polyline): polyline is L.Polyline => !!polyline);

    this.cablesLayer = L.layerGroup(cablePolylines);
    if(this.cablesLayer){
      this.cablesLayer.addTo(this.map);
    }
  }

  private createPolylineOnCartesianMap(cable: Cable, coordinateMap: Map<number, {x: number; y: number}>): L.polyline | null {
    const fromNode = coordinateMap.get(Number(cable.startNodeId));
    const toNode = coordinateMap.get(Number(cable.endNodeId));

    if(!fromNode || !toNode){
      console.warn(`Missing startpoint or endpoint for the cable: ${cable.gridElementId}`);
      return null;
    }

    const latLngs: [number, number][] = [
      [fromNode.y, fromNode.x],
      [toNode.y, toNode.x]
    ];

    return L.polyline(latLngs, {
      color: (cable.color !== null && cable.color !== undefined) ? cable.color : '#3388ff',
      weight: (cable.weight !== null && cable.weight !== undefined) ? cable.weight : 1,
      dashArray: cable.switchingState === 'OPEN' ? '4' : undefined
    });
  }


  /**
   * This function used for testing purposes
   */
  setGridElementCoordinates(){
    let postingData: Array<TestingDataForPost> = [];

    console.log("NodesMap with coordinates: ", this.nodesMap);

    this.nodesMap.forEach((value: GridElement, key: number) => {
      const testData: TestingDataForPost = new TestingDataForPost(
        value.gridElementId,
        Math.floor(Math.random() * 100) + 1, // random x coordinate
        Math.floor(Math.random() * 100) + 1  // random y coordinate
      );
      postingData.push(testData);
    });

    this.mapService.postCoordinatesForGridElement(postingData).subscribe({
      next: (response) => {
        console.log("Coordinates posted successfully: ", response);
      }
    });
  }

  resetMapState(): void{
    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }

    this.mapVisible = false;
    setTimeout(() => {
      this.mapVisible = true;
    })

    this.nodesMapGP.clear();
    this.nodesMap.clear();
    this.cablesMap.clear();
    this.cablesMapGP.clear();

    this.cables = [];
    this.cablesGP = [];

    this.onConfirmSelectionDate = false;
    this.selectedPlanningScenario = false;
    this.gridPlanningScenarios = [];

    this.toDate = null;
    this.date = undefined;
    this.selectedDate = false;
    this.enableResetButton = false;
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if(this.isDropdownOpen){
    // this.loadNotReadNotificationsCount(this.selectedTop);

    this.loadNotifications();
    }
  }

  toggleSidebarMenu(){
    this.isSidebarMenuOpen = !this.isSidebarMenuOpen;
  }

  closeSidebarMenu(){
    this.closeTimeout = setTimeout(() => {
      this.isSidebarMenuOpen = false;
    }, 300);
  }

  cancelAutoCloseSidebarMenu(){
    if(this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  deletePlanningScenario(){
    console.log("Here is the scenario to delete: ", this.selectedScenario);
    if(this.gridPlanningScenarios.length == 1){
      this.hidePlanning();
    }
    this.gPlanService.deleteGplanScenario(this.selectedScenario.id).subscribe({
      next: () => {
        console.log("Scenario deleted successfully");
        this.getListAvailableScenarios();
      },
      error: (err) => {
        console.error("Error deleting scenario:", err);
      }
    });
  }

  /**
   * This function get the EFL values from service where we stored it
   */
  getEflResults(): void{
    this.applicationsResultsService.eflResults$.pipe(distinctUntilChanged()).subscribe(eflResults => {
      if (!eflResults) return;

      // console.log("Here we have efl results:", eflResults);
      this.eflResultsFromAlarms = eflResults;

      // this.assignNodeFaultProbabilities(eflResults);
    });
  }

  updateGridNodesAccordingToEflResults(eflResults: Array<EflResult>): void{
    // console.log("Here we have efl results:", eflResults);
    // console.log("Here we have this nodesMpa: ", this.nodesMap);
    if(!eflResults.length || !this.nodesMap) return;

    for(const {gridElement: {id}, data} of eflResults){

      const gridElement = this.nodesMap.get(id);
      const gridColor = this.gridColorApps.get(id);

      const value = Number(data);
      const percentage = Math.round(value * 100) + '%';
      const condition = this.getConditionFromEflValue(value);

      // console.log("Here is the id of efl result: ", id);
      // console.log("Here is the grid element with the same id: ", gridElement);
      // console.log("Here is the grid color with the same id: ", gridColor);
      // console.log("Here is the efl value: ", data);

      if(!condition) continue;

      if(gridElement && gridColor){
        gridElement.condition = condition;
        gridColor.efl = condition;

        let prop = { "name": "eflValue", "value": percentage }
        gridElement.properties.push(prop);
        continue;
      }

      const cable = this.cables.find(c => c.gridElementId === id);

      if(cable){
        cable.color = this.getCableColorFromElfCondition(condition);
      }
    }

    // console.log("Here we have cables : ", this.cables);

    this.showSubIds = true;

    this.redrawCablesLayer();
    this.redrawNodesLayer([...this.nodesMap.values()], this.showSubIds);
  }

  private getCableColorFromElfCondition(condition: Condition): string{
    // console.log("Here is the condition: ", condition);
    switch(condition){
      case Condition.HIGH_FAULT_PROBABILITY:
        return Config.CONDITION_COLOR_PROBLEM;
      case Condition.MID_FAULT_PROBABILITY:
        return Config.CONDITION_COLOR_PROBLEM;
      case Condition.LOW_FAULT_PROBABILITY:
        return Config.CONDITION_COLOR_PROBLEM;
      default:
        return Config.CONDITION_COLOR_NORMAL;
    }
  }

  private getConditionFromEflValue(value: number): Condition | null {

    if(value >= 0.2){
      return Condition.HIGH_FAULT_PROBABILITY;
    }

    if(value >= 0.15 && value <= 0.20){
      return Condition.MID_FAULT_PROBABILITY;
    }

    if(value <= 0.15){
      return Condition.LOW_FAULT_PROBABILITY;
    }

    return null;
  }

  private resetEflResults(): void {
    this.eflResultsFromAlarms = [];
    this.applicationsResultsService.setEflResults([]);

  }
}
